var is = Object.defineProperty;
var ls = (t, e, r) => e in t ? is(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var ee = (t, e, r) => (ls(t, typeof e != "symbol" ? e + "" : e, r), r);
import { enqueueSnackbar as qe, useEventCallback as It, Box as R, Typography as A, Tooltip as Te, Chip as Ve, Badge as ot, Breadcrumbs as Ht, Avatar as ze, sx as je, SelectAdvanceComponents as Oe, Button as We, SelectAdvanceList as bt, IconButton as Fe, ThemeProvider as cs, Tabs as rr, Tab as at, isDeepEqual as ds, LayoutContainer as us, Layout as ps, Popper as nr, bindPopper as St, SelectAdvancePopper as Wr, usePopupState as ht, bindToggle as kt, ClickAwayListener as yt, bindFocus as fs, InputWithTags as gs, Skeleton as Ze, useDebounceValue as Rt, SelectAdvancePopover as ms, TypoTooltip as be, TextField as Ke, Alert as wt, Link as Vr, Dialog as hs, DialogContent as Kr, ButtonBase as Nt, Paper as qr, useClipboard as ys, Divider as Yt, useFavicon as ws, useDocumentTitle as vs, DialogTitle as xs, Container as Rr, CircularProgress as Is, Row as Lt, Col as Pt, DialogActions as bs, LoadingButton as Ut, Accordion as sr, AccordionSummary as ar, AccordionDetails as or, Drawer as Ss } from "@applift/factor";
import { useQuery as ke, useInfiniteQuery as jt, useMutation as Rs } from "@tanstack/react-query";
import Le, { AxiosError as js } from "axios";
import { AppCustomers as As, AppDashboard as Ls, AppReports as Ps, AppBidModel as Cs, AppOrganisation as Es, AppMyProfile as Os, AppCampaigns as ks, AppAudiences as Ds, AppCreatives as _s, AppInventory as Ts, AppConversion as Ns, AppInsights as Us, AppPlanner as Fs, AppCampaignDebugger as Bs, AlertOctagon as gt, Show as Hr, CurrencyDollar as Ft, ChevronRight as Gt, Lock as zs, Database as Ms, Download as $s, RadioButtonChecked as Dt, RadioButtonUnchecked as Yr, Close as ir, VerticalPolitical as Ws, VerticalHealthcare as Vs, VerticalSpecialty as Ks, Redo as qs, ArrowsSort as Hs, Filter as Ys, Search as Gr, SemanticWarning as Gs, InfoCircle as Js, CreativeImage as Jr, CreativeHTML as Qs, CreativeVideo as Zs, CreativeNative as Xs, CreativeAudio as ea, IoCurrency as Qr, IoImpression as Zr, StatusDraft as ta, StatusPending as Xr, StatusPaused as en, StatusRunning as ra, StatusExpired as tn, StatusDeleted as rn, StatusRejected as nn, StatusFailed as na, Message as sa, GridDots as aa, Copy as sn, Crown as an, ClipboardRemove as oa, Home as ia, QuestionCircle as la, StatusApproved as ca, StatusInvited as da, CreditCard as jr, BrandPaypal as ua, Hourglass as pa, Cheque as fa, StatusReady as ga, Settings as ma } from "@applift/icons";
import * as u from "react";
import Ye, { useImperativeHandle as ha, createElement as ya } from "react";
import Ce from "clsx";
import { datadogRum as ct } from "@datadog/browser-rum";
import { DigitalExperience as wa } from "@applift/illustrations";
const Pe = () => {
  const t = window.location.host;
  return ["localhost", "127.0.0.1"].filter((r) => t.includes(r)).length > 0;
}, lr = (t) => {
  let e = "";
  try {
    e = new URL(t).origin;
  } catch {
    e = "";
  }
  return Pe() ? e ?? "" : window.location.origin;
}, cr = (t = "") => t.replace(/^https?:\/\//, ""), sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getDomainURL: cr,
  getOriginURL: lr,
  isLocalhost: Pe
}, Symbol.toStringTag, { value: "Module" })), va = {
  Customers: As,
  Dashboard: Ls,
  Reports: Ps,
  "Bid Model": Cs,
  Organization: Es,
  "My Profile": Os,
  Campaigns: ks,
  Audiences: Ds,
  Creatives: _s,
  Inventory: Ts,
  Conversions: Ns,
  Insights: Us,
  Planner: Fs,
  "Campaign Debugger": Bs,
  Marketplace: gt,
  // Marketplace has no icon
  Messages: gt,
  // Messages has no icon
  "Auth Pages": gt
  // Messages has no icon
}, vt = {
  appId: -3,
  appName: "Auth Pages",
  appIcon: "logo/auth-pages.png",
  appUrl: "/",
  showInDrawer: !1
}, dr = "Basic N3BuaWJrdWpleTFvanJnbnNsbjU6MTIzNDU2", fe = {
  AUTH: "auth",
  LAST_OWID: "last_owid",
  LEGACY_OWIDS_ARRAY: "owIds",
  LEGACY_AUTH: "authorizedUser",
  LEGACY_INIT: "initData",
  INIT: "init",
  ORIGIN_URL: "ORIGIN_URL"
}, on = "X-IAA-OW-ID", ln = "https://d64is2qkxbhv3.cloudfront.net/assets/dist", cn = "https://d2v0lj9tfbnmhu.cloudfront.net/assets/dist", xa = 20, Ia = 20, Be = {
  SUPER: "SUPER",
  WORKSPACE: "WORKSPACE",
  ADVERTISER: "ADVERTISER"
};
var Jt = { exports: {} }, dt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function ba() {
  if (Ar)
    return dt;
  Ar = 1;
  var t = Ye, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(i, c, m) {
    var y, p = {}, f = null, I = null;
    m !== void 0 && (f = "" + m), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (I = c.ref);
    for (y in c)
      n.call(c, y) && !o.hasOwnProperty(y) && (p[y] = c[y]);
    if (i && i.defaultProps)
      for (y in c = i.defaultProps, c)
        p[y] === void 0 && (p[y] = c[y]);
    return { $$typeof: e, type: i, key: f, ref: I, props: p, _owner: a.current };
  }
  return dt.Fragment = r, dt.jsx = l, dt.jsxs = l, dt;
}
var ut = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function Sa() {
  return Lr || (Lr = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ye, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), i = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), I = Symbol.for("react.offscreen"), b = Symbol.iterator, w = "@@iterator";
    function S(d) {
      if (d === null || typeof d != "object")
        return null;
      var v = b && d[b] || d[w];
      return typeof v == "function" ? v : null;
    }
    var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(d) {
      {
        for (var v = arguments.length, E = new Array(v > 1 ? v - 1 : 0), Z = 1; Z < v; Z++)
          E[Z - 1] = arguments[Z];
        T("error", d, E);
      }
    }
    function T(d, v, E) {
      {
        var Z = N.ReactDebugCurrentFrame, ue = Z.getStackAddendum();
        ue !== "" && (v += "%s", E = E.concat([ue]));
        var ge = E.map(function(de) {
          return String(de);
        });
        ge.unshift("Warning: " + v), Function.prototype.apply.call(console[d], console, ge);
      }
    }
    var G = !1, F = !1, X = !1, z = !1, W = !1, V;
    V = Symbol.for("react.module.reference");
    function C(d) {
      return !!(typeof d == "string" || typeof d == "function" || d === n || d === o || W || d === a || d === m || d === y || z || d === I || G || F || X || typeof d == "object" && d !== null && (d.$$typeof === f || d.$$typeof === p || d.$$typeof === l || d.$$typeof === i || d.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      d.$$typeof === V || d.getModuleId !== void 0));
    }
    function H(d, v, E) {
      var Z = d.displayName;
      if (Z)
        return Z;
      var ue = v.displayName || v.name || "";
      return ue !== "" ? E + "(" + ue + ")" : E;
    }
    function oe(d) {
      return d.displayName || "Context";
    }
    function re(d) {
      if (d == null)
        return null;
      if (typeof d.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof d == "function")
        return d.displayName || d.name || null;
      if (typeof d == "string")
        return d;
      switch (d) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case i:
            var v = d;
            return oe(v) + ".Consumer";
          case l:
            var E = d;
            return oe(E._context) + ".Provider";
          case c:
            return H(d, d.render, "ForwardRef");
          case p:
            var Z = d.displayName || null;
            return Z !== null ? Z : re(d.type) || "Memo";
          case f: {
            var ue = d, ge = ue._payload, de = ue._init;
            try {
              return re(de(ge));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ie = 0, xe, ne, D, M, he, pe, Ie;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function h() {
      {
        if (ie === 0) {
          xe = console.log, ne = console.info, D = console.warn, M = console.error, he = console.group, pe = console.groupCollapsed, Ie = console.groupEnd;
          var d = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: d,
            log: d,
            warn: d,
            error: d,
            group: d,
            groupCollapsed: d,
            groupEnd: d
          });
        }
        ie++;
      }
    }
    function B() {
      {
        if (ie--, ie === 0) {
          var d = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, d, {
              value: xe
            }),
            info: Q({}, d, {
              value: ne
            }),
            warn: Q({}, d, {
              value: D
            }),
            error: Q({}, d, {
              value: M
            }),
            group: Q({}, d, {
              value: he
            }),
            groupCollapsed: Q({}, d, {
              value: pe
            }),
            groupEnd: Q({}, d, {
              value: Ie
            })
          });
        }
        ie < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = N.ReactCurrentDispatcher, le;
    function j(d, v, E) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (ue) {
            var Z = ue.stack.trim().match(/\n( *(at )?)/);
            le = Z && Z[1] || "";
          }
        return `
` + le + d;
      }
    }
    var _ = !1, x;
    {
      var L = typeof WeakMap == "function" ? WeakMap : Map;
      x = new L();
    }
    function q(d, v) {
      if (!d || _)
        return "";
      {
        var E = x.get(d);
        if (E !== void 0)
          return E;
      }
      var Z;
      _ = !0;
      var ue = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ge;
      ge = te.current, te.current = null, h();
      try {
        if (v) {
          var de = function() {
            throw Error();
          };
          if (Object.defineProperty(de.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(de, []);
            } catch (_e) {
              Z = _e;
            }
            Reflect.construct(d, [], de);
          } else {
            try {
              de.call();
            } catch (_e) {
              Z = _e;
            }
            d.call(de.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (_e) {
            Z = _e;
          }
          d();
        }
      } catch (_e) {
        if (_e && Z && typeof _e.stack == "string") {
          for (var ae = _e.stack.split(`
`), De = Z.stack.split(`
`), Se = ae.length - 1, Ae = De.length - 1; Se >= 1 && Ae >= 0 && ae[Se] !== De[Ae]; )
            Ae--;
          for (; Se >= 1 && Ae >= 0; Se--, Ae--)
            if (ae[Se] !== De[Ae]) {
              if (Se !== 1 || Ae !== 1)
                do
                  if (Se--, Ae--, Ae < 0 || ae[Se] !== De[Ae]) {
                    var Ue = `
` + ae[Se].replace(" at new ", " at ");
                    return d.displayName && Ue.includes("<anonymous>") && (Ue = Ue.replace("<anonymous>", d.displayName)), typeof d == "function" && x.set(d, Ue), Ue;
                  }
                while (Se >= 1 && Ae >= 0);
              break;
            }
        }
      } finally {
        _ = !1, te.current = ge, B(), Error.prepareStackTrace = ue;
      }
      var tt = d ? d.displayName || d.name : "", Je = tt ? j(tt) : "";
      return typeof d == "function" && x.set(d, Je), Je;
    }
    function J(d, v, E) {
      return q(d, !1);
    }
    function ce(d) {
      var v = d.prototype;
      return !!(v && v.isReactComponent);
    }
    function O(d, v, E) {
      if (d == null)
        return "";
      if (typeof d == "function")
        return q(d, ce(d));
      if (typeof d == "string")
        return j(d);
      switch (d) {
        case m:
          return j("Suspense");
        case y:
          return j("SuspenseList");
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case c:
            return J(d.render);
          case p:
            return O(d.type, v, E);
          case f: {
            var Z = d, ue = Z._payload, ge = Z._init;
            try {
              return O(ge(ue), v, E);
            } catch {
            }
          }
        }
      return "";
    }
    var g = Object.prototype.hasOwnProperty, P = {}, U = N.ReactDebugCurrentFrame;
    function K(d) {
      if (d) {
        var v = d._owner, E = O(d.type, d._source, v ? v.type : null);
        U.setExtraStackFrame(E);
      } else
        U.setExtraStackFrame(null);
    }
    function $(d, v, E, Z, ue) {
      {
        var ge = Function.call.bind(g);
        for (var de in d)
          if (ge(d, de)) {
            var ae = void 0;
            try {
              if (typeof d[de] != "function") {
                var De = Error((Z || "React class") + ": " + E + " type `" + de + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[de] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw De.name = "Invariant Violation", De;
              }
              ae = d[de](v, de, Z, E, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              ae = Se;
            }
            ae && !(ae instanceof Error) && (K(ue), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Z || "React class", E, de, typeof ae), K(null)), ae instanceof Error && !(ae.message in P) && (P[ae.message] = !0, K(ue), k("Failed %s type: %s", E, ae.message), K(null));
          }
      }
    }
    var me = Array.isArray;
    function ye(d) {
      return me(d);
    }
    function we(d) {
      {
        var v = typeof Symbol == "function" && Symbol.toStringTag, E = v && d[Symbol.toStringTag] || d.constructor.name || "Object";
        return E;
      }
    }
    function Ee(d) {
      try {
        return se(d), !1;
      } catch {
        return !0;
      }
    }
    function se(d) {
      return "" + d;
    }
    function Ne(d) {
      if (Ee(d))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", we(d)), se(d);
    }
    var Me = N.ReactCurrentOwner, Wn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, mr, hr, Bt;
    Bt = {};
    function Vn(d) {
      if (g.call(d, "ref")) {
        var v = Object.getOwnPropertyDescriptor(d, "ref").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return d.ref !== void 0;
    }
    function Kn(d) {
      if (g.call(d, "key")) {
        var v = Object.getOwnPropertyDescriptor(d, "key").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return d.key !== void 0;
    }
    function qn(d, v) {
      if (typeof d.ref == "string" && Me.current && v && Me.current.stateNode !== v) {
        var E = re(Me.current.type);
        Bt[E] || (k('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', re(Me.current.type), d.ref), Bt[E] = !0);
      }
    }
    function Hn(d, v) {
      {
        var E = function() {
          mr || (mr = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        E.isReactWarning = !0, Object.defineProperty(d, "key", {
          get: E,
          configurable: !0
        });
      }
    }
    function Yn(d, v) {
      {
        var E = function() {
          hr || (hr = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        E.isReactWarning = !0, Object.defineProperty(d, "ref", {
          get: E,
          configurable: !0
        });
      }
    }
    var Gn = function(d, v, E, Z, ue, ge, de) {
      var ae = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: d,
        key: v,
        ref: E,
        props: de,
        // Record the component responsible for creating this element.
        _owner: ge
      };
      return ae._store = {}, Object.defineProperty(ae._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ae, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.defineProperty(ae, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ue
      }), Object.freeze && (Object.freeze(ae.props), Object.freeze(ae)), ae;
    };
    function Jn(d, v, E, Z, ue) {
      {
        var ge, de = {}, ae = null, De = null;
        E !== void 0 && (Ne(E), ae = "" + E), Kn(v) && (Ne(v.key), ae = "" + v.key), Vn(v) && (De = v.ref, qn(v, ue));
        for (ge in v)
          g.call(v, ge) && !Wn.hasOwnProperty(ge) && (de[ge] = v[ge]);
        if (d && d.defaultProps) {
          var Se = d.defaultProps;
          for (ge in Se)
            de[ge] === void 0 && (de[ge] = Se[ge]);
        }
        if (ae || De) {
          var Ae = typeof d == "function" ? d.displayName || d.name || "Unknown" : d;
          ae && Hn(de, Ae), De && Yn(de, Ae);
        }
        return Gn(d, ae, De, ue, Z, Me.current, de);
      }
    }
    var zt = N.ReactCurrentOwner, yr = N.ReactDebugCurrentFrame;
    function et(d) {
      if (d) {
        var v = d._owner, E = O(d.type, d._source, v ? v.type : null);
        yr.setExtraStackFrame(E);
      } else
        yr.setExtraStackFrame(null);
    }
    var Mt;
    Mt = !1;
    function $t(d) {
      return typeof d == "object" && d !== null && d.$$typeof === e;
    }
    function wr() {
      {
        if (zt.current) {
          var d = re(zt.current.type);
          if (d)
            return `

Check the render method of \`` + d + "`.";
        }
        return "";
      }
    }
    function Qn(d) {
      {
        if (d !== void 0) {
          var v = d.fileName.replace(/^.*[\\\/]/, ""), E = d.lineNumber;
          return `

Check your code at ` + v + ":" + E + ".";
        }
        return "";
      }
    }
    var vr = {};
    function Zn(d) {
      {
        var v = wr();
        if (!v) {
          var E = typeof d == "string" ? d : d.displayName || d.name;
          E && (v = `

Check the top-level render call using <` + E + ">.");
        }
        return v;
      }
    }
    function xr(d, v) {
      {
        if (!d._store || d._store.validated || d.key != null)
          return;
        d._store.validated = !0;
        var E = Zn(v);
        if (vr[E])
          return;
        vr[E] = !0;
        var Z = "";
        d && d._owner && d._owner !== zt.current && (Z = " It was passed a child from " + re(d._owner.type) + "."), et(d), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', E, Z), et(null);
      }
    }
    function Ir(d, v) {
      {
        if (typeof d != "object")
          return;
        if (ye(d))
          for (var E = 0; E < d.length; E++) {
            var Z = d[E];
            $t(Z) && xr(Z, v);
          }
        else if ($t(d))
          d._store && (d._store.validated = !0);
        else if (d) {
          var ue = S(d);
          if (typeof ue == "function" && ue !== d.entries)
            for (var ge = ue.call(d), de; !(de = ge.next()).done; )
              $t(de.value) && xr(de.value, v);
        }
      }
    }
    function Xn(d) {
      {
        var v = d.type;
        if (v == null || typeof v == "string")
          return;
        var E;
        if (typeof v == "function")
          E = v.propTypes;
        else if (typeof v == "object" && (v.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        v.$$typeof === p))
          E = v.propTypes;
        else
          return;
        if (E) {
          var Z = re(v);
          $(E, d.props, "prop", Z, d);
        } else if (v.PropTypes !== void 0 && !Mt) {
          Mt = !0;
          var ue = re(v);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ue || "Unknown");
        }
        typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function es(d) {
      {
        for (var v = Object.keys(d.props), E = 0; E < v.length; E++) {
          var Z = v[E];
          if (Z !== "children" && Z !== "key") {
            et(d), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Z), et(null);
            break;
          }
        }
        d.ref !== null && (et(d), k("Invalid attribute `ref` supplied to `React.Fragment`."), et(null));
      }
    }
    var br = {};
    function Sr(d, v, E, Z, ue, ge) {
      {
        var de = C(d);
        if (!de) {
          var ae = "";
          (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var De = Qn(ue);
          De ? ae += De : ae += wr();
          var Se;
          d === null ? Se = "null" : ye(d) ? Se = "array" : d !== void 0 && d.$$typeof === e ? (Se = "<" + (re(d.type) || "Unknown") + " />", ae = " Did you accidentally export a JSX literal instead of a component?") : Se = typeof d, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Se, ae);
        }
        var Ae = Jn(d, v, E, ue, ge);
        if (Ae == null)
          return Ae;
        if (de) {
          var Ue = v.children;
          if (Ue !== void 0)
            if (Z)
              if (ye(Ue)) {
                for (var tt = 0; tt < Ue.length; tt++)
                  Ir(Ue[tt], d);
                Object.freeze && Object.freeze(Ue);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ir(Ue, d);
        }
        if (g.call(v, "key")) {
          var Je = re(d), _e = Object.keys(v).filter(function(os) {
            return os !== "key";
          }), Wt = _e.length > 0 ? "{key: someKey, " + _e.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!br[Je + Wt]) {
            var as = _e.length > 0 ? "{" + _e.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Wt, Je, as, Je), br[Je + Wt] = !0;
          }
        }
        return d === n ? es(Ae) : Xn(Ae), Ae;
      }
    }
    function ts(d, v, E) {
      return Sr(d, v, E, !0);
    }
    function rs(d, v, E) {
      return Sr(d, v, E, !1);
    }
    var ns = rs, ss = ts;
    ut.Fragment = n, ut.jsx = ns, ut.jsxs = ss;
  }()), ut;
}
process.env.NODE_ENV === "production" ? Jt.exports = ba() : Jt.exports = Sa();
var s = Jt.exports;
const it = {
  verticalIds: {},
  priceRangeIds: {},
  reachRangeIds: {},
  availabilityId: {},
  providerIds: {}
}, Ra = {
  availabilityId: "SET_AVABILITY",
  priceRangeIds: "SET_PRICE",
  reachRangeIds: "SET_REACH",
  providerIds: "SET_PROVIDER",
  verticalIds: "SET_VERTICAL"
}, ur = [
  { label: "Vertical", value: "vertical", filterKey: "verticalIds" },
  { label: "Source", value: "source", filterKey: "providerIds" },
  { label: "Price", value: "price", filterKey: "priceRangeIds" },
  { label: "Reach", value: "reach", filterKey: "reachRangeIds" },
  { label: "Availability", value: "availability", filterKey: "availabilityId" }
], _t = [
  "priceRangeIds",
  "reachRangeIds",
  "availabilityId"
], Pr = [
  {
    label: "By Reach",
    value: "reach",
    icon: /* @__PURE__ */ s.jsx(Hr, { sx: { textColor: "neutral-400", flexShrink: 0, fontSize: 20 } })
  },
  {
    label: "By Price",
    value: "cpm",
    icon: /* @__PURE__ */ s.jsx(
      Ft,
      {
        sx: { textColor: "neutral-400", flexShrink: 0, fontSize: 20 }
      }
    )
  }
], Tt = () => {
  var e;
  const t = window.location.href ?? "";
  try {
    const r = Number((e = t.match(/\/u\/[0-9]+/i)) == null ? void 0 : e[0].substring(3)), n = isNaN(r) ? 0 : r;
    return Pe() ? 0 : n;
  } catch {
    return 0;
  }
}, mt = (t) => {
  try {
    const e = JSON.parse(
      window.localStorage.getItem(fe.LEGACY_OWIDS_ARRAY) ?? "[]"
    ), r = Number(t), n = e == null ? void 0 : e.map(Number);
    return Array.isArray(n) ? [n.indexOf(r), n] : [-1, []];
  } catch {
    return [-1, []];
  }
}, dn = (t) => {
  try {
    const e = JSON.parse(
      window.localStorage.getItem(fe.LEGACY_OWIDS_ARRAY) ?? "[]"
    ), r = e == null ? void 0 : e.map(Number);
    if (Array.isArray(r)) {
      const n = Number(r[t]);
      return isNaN(n) ? null : n;
    } else
      return null;
  } catch {
    return null;
  }
}, un = () => {
  const t = Tt();
  return dn(t);
}, pn = () => {
  var r;
  let t = Number(
    localStorage.getItem(fe.LAST_OWID)
  );
  if (t = isNaN(t) ? null : t, Pe())
    return t;
  const e = window.location.href ?? "";
  try {
    const n = Number((r = e.match(/\/u\/[0-9]+/i)) == null ? void 0 : r[0].substring(3));
    return (isNaN(n) ? null : n) ?? t;
  } catch {
    return null;
  }
}, rt = (t, e, r) => t.replace(new RegExp(`/u/${e}`, "i"), `/u/${r}`), ad = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getOwIdAtIndexFromLocalstorageLegacy: dn,
  getOwIdFromPath: pn,
  getOwIdFromPathLegacy: un,
  getOwIdIndexFromLocalstorage: mt,
  getOwIdIndexFromPathLegacy: Tt,
  setOwIdInURL: rt
}, Symbol.toStringTag, { value: "Module" })), Qt = () => {
  const t = window.localStorage.getItem(fe.AUTH);
  if (t)
    try {
      return JSON.parse(t);
    } catch {
      return null;
    }
  return null;
}, Zt = () => {
  const t = window.localStorage.getItem(fe.LEGACY_AUTH);
  if (t)
    try {
      const e = JSON.parse(t);
      return {
        accessToken: e.apiToken,
        refreshToken: e.refreshToken,
        tokenType: "bearer",
        expiresIn: e.expiresAt,
        scope: "read write"
      };
    } catch {
      return null;
    }
  return null;
}, Xe = () => {
  localStorage.removeItem(fe.AUTH), localStorage.removeItem(fe.LEGACY_AUTH), localStorage.removeItem(fe.LAST_OWID), localStorage.removeItem(fe.LEGACY_OWIDS_ARRAY);
}, od = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearAuthTokenFromLocalstorage: Xe,
  readAuthDataFromLocalstorage: Qt,
  readAuthDataFromLocalstorageLegacy: Zt
}, Symbol.toStringTag, { value: "Module" })), fn = () => {
  var e, r, n;
  const t = localStorage.getItem(fe.LEGACY_INIT) ?? "{}";
  try {
    const a = JSON.parse(t);
    return {
      favicon: (a == null ? void 0 : a.smallLogoUrl) ?? "",
      helpURL: ((n = (r = (e = a == null ? void 0 : a.pages) == null ? void 0 : e.help_url) == null ? void 0 : r[0]) == null ? void 0 : n.url) ?? ""
    };
  } catch {
    return {
      favicon: "",
      helpURL: ""
    };
  }
}, gn = () => {
  const t = localStorage.getItem(fe.INIT) ?? "{}";
  try {
    const e = JSON.parse(t);
    return {
      favicon: e == null ? void 0 : e.favicon,
      helpURL: e == null ? void 0 : e.helpURL
    };
  } catch {
    return {
      favicon: "",
      helpURL: ""
    };
  }
}, mn = (t) => {
  var r, n, a;
  const e = {
    favicon: (t == null ? void 0 : t.smallLogoUrl) ?? "",
    helpURL: ((a = (n = (r = t == null ? void 0 : t.pages) == null ? void 0 : r.help_url) == null ? void 0 : n[0]) == null ? void 0 : a.url) ?? ""
  };
  window.localStorage.setItem(fe.INIT, JSON.stringify(e));
}, hn = (t) => {
  window.localStorage.setItem(
    fe.LEGACY_INIT,
    JSON.stringify(t)
  );
}, id = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  readInitDataFromLocalstorage: gn,
  readLegacyInitDataFromLocalstorage: fn,
  storeInitDataToLocalstorage: mn,
  storeInitDataToLocalstorageLegacy: hn
}, Symbol.toStringTag, { value: "Module" }));
let yn;
function Cr(t) {
  yn = t;
}
function ve() {
  return yn || Le;
}
function wn(t) {
  t.interceptors.request.use((e) => ({
    ...e,
    meta: {
      startTime: Date.now()
    }
  })), t.interceptors.response.use((e) => {
    var r, n, a;
    if (e) {
      const o = Date.now(), l = ((n = (r = e == null ? void 0 : e.config) == null ? void 0 : r.meta) == null ? void 0 : n.startTime) ?? o, i = o - l;
      return {
        ...e,
        config: {
          ...e.config,
          meta: {
            startTime: l,
            ...((a = e == null ? void 0 : e.config) == null ? void 0 : a.meta) ?? {},
            endTime: o,
            latency: i
          }
        }
      };
    }
    return e;
  });
}
function ja(t, e) {
  const r = new URL(vt.appUrl, e).toString();
  t.interceptors.response.use(
    (n) => n,
    (n) => {
      var a;
      return Le.isCancel(n) ? Promise.reject({
        response: {
          data: n
        }
      }) : (((a = n == null ? void 0 : n.response) == null ? void 0 : a.status) === 401 && (Xe(), Pe() || window.location.replace(r)), Promise.reject(n));
    }
  );
}
const vn = "11,13,14", Aa = (t) => {
  const e = {};
  for (const [r] of Object.entries(t ?? {}))
    e[r] = !0;
  return e;
}, xn = (t) => Array.isArray(t) ? t.map((e) => ({
  value: `provider-${e.providerId}`,
  preservedValue: `${e.providerId}`,
  isProvider: !0,
  label: e.providerName,
  description: e.description,
  providerId: e.providerId,
  providerName: e.providerName,
  providerLogoUrl: e.providerLogoUrl,
  parentPathKey: null,
  cpm: 0,
  isLeaf: !1,
  creativeTypeIdList: [],
  creativeTypeIdSerialized: "",
  isAllCreativeType: !1,
  subRows: In(e.childSegments, e)
})) : [], In = (t, e) => Array.isArray(t) ? t.map((r) => {
  const n = (r.creativeTypeIdList ?? []).sort().join(",");
  return {
    value: r.isLeaf ? `${r.prebidAudienceSegmentId}` : `intermediate-segment-${r.prebidAudienceSegmentId}`,
    preservedValue: `${r.prebidAudienceSegmentId}`,
    isProvider: !1,
    label: r.prebidAudienceSegmentName,
    description: r.description,
    parentPathKey: r.parentPathKey,
    cpm: r.cpm,
    creativeTypeIdList: r.creativeTypeIdList ?? [],
    creativeTypeIdSerialized: n,
    isAllCreativeType: n === vn,
    isLeaf: r.isLeaf,
    subRows: [],
    providerId: e.providerId,
    providerName: e.providerName,
    providerLogoUrl: e.providerLogoUrl
  };
}) : [], La = (t, e = {}) => Array.isArray(t) ? t.map((n) => {
  var o, l;
  const a = (n.creativeTypeIdList ?? []).sort().join(",");
  return {
    value: `${n.prebidAudienceSegmentId}`,
    preservedValue: `${n.prebidAudienceSegmentId}`,
    isProvider: !1,
    label: n.prebidAudienceSegmentName,
    description: n.description,
    parentPathKey: n.parentPathKey,
    cpm: n.cpm,
    creativeTypeIdList: n.creativeTypeIdList ?? [],
    creativeTypeIdSerialized: a,
    isAllCreativeType: a === vn,
    isLeaf: n.isLeaf,
    subRows: [],
    providerId: n.providerId,
    providerName: ((o = e == null ? void 0 : e[n.providerId]) == null ? void 0 : o.providerName) ?? "",
    providerLogoUrl: ((l = e == null ? void 0 : e[n.providerId]) == null ? void 0 : l.providerLogoUrl) ?? ""
  };
}) : [], Pa = (t, e = {}) => {
  const n = La(
    t,
    e
  ).reduce(
    (o, l) => {
      if (Array.isArray(o[l.providerId])) {
        const c = o[l.providerId];
        return c.push(l), { ...o, [l.providerId]: c };
      }
      const i = [l];
      return { ...o, [l.providerId]: i };
    },
    {}
  ), a = [];
  for (const [o, l] of Object.entries(
    n
  )) {
    const i = xn([
      e[o]
    ]);
    l.forEach((m) => {
      Ea(
        i,
        Number(o),
        m.parentPathKey,
        m
      );
    });
    const c = i[0];
    a.push(c);
  }
  return a;
}, Ca = (t, e, r) => {
  const n = [e.providerName, ...r, t].join(".");
  return {
    label: t,
    description: "",
    parentPathKey: r.join(" > "),
    creativeTypeIdList: [],
    creativeTypeIdSerialized: "",
    isAllCreativeType: !1,
    isLeaf: !1,
    cpm: 0,
    value: n,
    preservedValue: n,
    isProvider: !1,
    providerId: e.providerId,
    providerName: e.providerName ?? "",
    providerLogoUrl: e.providerLogoUrl ?? "",
    subRows: []
  };
}, Ea = (t, e, r, n) => {
  const a = r.split(">").map((l) => l.trim());
  if (a.length <= 0)
    return t;
  const o = t.filter(
    (l) => l.providerId === e
  )[0];
  return o ? Xt(
    o.subRows,
    a.slice(),
    n,
    o,
    // provider data
    []
  ) : t;
}, Xt = (t, e, r, n, a) => {
  if (e.length > 0) {
    const o = e.splice(0, 1)[0], l = a.slice();
    l.push(o);
    const i = t.find((c) => c.label === o);
    if (i)
      Xt(
        i.subRows,
        e,
        r,
        n,
        l
      );
    else {
      const c = Ca(
        o,
        n,
        a
      );
      t.push(c), Xt(c.subRows, e, r, n, l);
    }
  } else
    t.push(r);
}, Oa = async () => {
  var t;
  try {
    const e = await ve().get("/v3/audience/prebid/provider/details/list"), { totalRecords: r, filteredRecords: n, prebidSegmentData: a } = e.data.data;
    return {
      totalRecords: r,
      filteredRecords: n,
      prebidSegmentData: xn(a)
    };
  } catch (e) {
    return Promise.reject((t = e == null ? void 0 : e.response) == null ? void 0 : t.data);
  }
}, ka = async ({
  prebidAudienceSegmentId: t,
  providerDetails: e
}) => {
  var r;
  try {
    const n = await ve().get("/v3/audience/prebid/segment/details/list", {
      params: { prebidAudienceSegmentId: t }
    }), { totalRecords: a, filteredRecords: o, prebidSegmentData: l } = n.data.data;
    return {
      totalRecords: a,
      filteredRecords: o,
      prebidSegmentData: In(
        l,
        e
      )
    };
  } catch (n) {
    return Promise.reject((r = n == null ? void 0 : n.response) == null ? void 0 : r.data);
  }
}, Da = async ({
  queryKey: t,
  signal: e,
  meta: r
}) => {
  var i;
  const { searchValue: n, prebidAudienceSegmentIdList: a } = t[0], { CancelToken: o } = Le, l = o.source();
  e == null || e.addEventListener("abort", () => {
    l.cancel("v3/audience/prebid/details/search/list - Request cancelled");
  });
  try {
    const c = await ve().post(
      "/v3/audience/prebid/details/search/list",
      { searchField: n, prebidAudienceSegmentIdList: a },
      {
        cancelToken: l.token
      }
    ), { prebidSegmentData: m, totalRecords: y, filteredRecords: p } = c.data.data;
    return {
      totalRecords: y,
      filteredRecords: p,
      prebidSegmentData: Pa(
        m,
        r
      )
    };
  } catch (c) {
    return Promise.reject((i = c.response) == null ? void 0 : i.data);
  }
}, _a = {
  keys: (t) => [t]
}, Ta = {
  keys: (t) => [t]
}, Na = {
  keys: (t) => [t]
}, Ua = {
  keys: (t) => [t]
}, Fa = {
  keys: (t) => [t]
}, lt = {
  keys: (t) => [t]
}, Ba = {
  keys: (t) => [t]
}, za = {
  keys: (t) => [t]
}, Ma = {
  keys: (t) => [t]
}, $a = {
  keys: (t) => [t]
}, Wa = {
  keys: (t) => [t]
}, Va = {
  keys: (t) => [t]
}, Ka = {
  keys: (t) => [t]
}, qa = {
  keys: (t) => [t]
}, Ha = {
  keys: (t) => [t]
}, Ya = {
  keys: (t) => [t]
}, bn = (t) => {
  var e, r;
  (r = qe) == null || r(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, Ga = (t) => ke(
  _a.keys({
    scope: "getPrebidProviderData"
  }),
  Oa,
  {
    onError: bn,
    enabled: t == null ? void 0 : t.enabled
  }
), Ja = (t, e) => ke(
  Ta.keys({
    scope: "getPrebidSearchSegmentData",
    searchValue: t
  }),
  Da,
  {
    onError: bn,
    enabled: e == null ? void 0 : e.enabled,
    meta: e == null ? void 0 : e.meta
  }
), Qa = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const n = t[r], a = {
      type: "workspace",
      activeCampaignsCount: n.activeCampaignsCount,
      // This will be false when workspace's advertiser access to availalbe to the user but not workspace.
      isAccess: n.isAccess,
      logoUrl: n.logoUrl,
      label: n.organizationName,
      value: `${n.owId}`,
      ownerUserEmail: n.ownerUserEmail,
      ownerUserName: n.ownerUserName,
      status: n.status,
      statusId: n.statusId,
      subRows: Za(n.customers)
    };
    e.push(a);
  }
  return e;
}, Za = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const n = t[r], a = {
      type: "advertiser",
      activeCampaignsCount: n.activeCampaignsCount,
      // It will be always true because backend only sends advertiser user has accesst to
      isAccess: !0,
      logoUrl: n.logoUrl,
      label: n.organizationName,
      value: `${n.owId}`,
      ownerUserEmail: n.ownerUserEmail,
      ownerUserName: n.ownerUserName,
      status: n.status,
      statusId: n.statusId,
      subRows: []
    };
    e.push(a);
  }
  return e;
}, Xa = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const n = t[r], a = {
      type: "workspace",
      activeCampaignsCount: 0,
      // It will be always true because this API doesn't send the flag so we will always assume user has access to workspace
      // but need to ask BE to support it in this API if this API will be used where we are checking for access to the user
      isAccess: !0,
      logoUrl: n.logoUrl,
      label: n.workspaceName,
      value: `${n.owId}`,
      ownerUserEmail: n.ownerUserEmail,
      ownerUserName: n.ownerUserName,
      status: n.status,
      statusId: n.statusId,
      subRows: []
    };
    e.push(a);
  }
  return e;
}, Er = (t) => {
  const e = {};
  for (const [r] of Object.entries(t ?? {}))
    e[r] = !0;
  return e;
}, eo = async ({
  queryKey: t,
  signal: e,
  pageParam: r = 1
}) => {
  var c;
  const { scope: n, isSelectAll: a = !1, ...o } = t[0], { CancelToken: l } = Le, i = l.source();
  e == null || e.addEventListener("abort", () => {
    i.cancel("/v3/ua/customers/list/multi-level - Request cancelled");
  });
  try {
    const m = await ve().get("/v3/ua/customers/list/multi-level", {
      params: {
        ...o,
        pageNo: a === !0 ? -1 : r
      },
      cancelToken: i.token
    }), { data: y, totalRecords: p, filteredRecords: f } = m.data.data;
    return {
      totalRecords: p,
      filteredRecords: f,
      data: Qa(y)
    };
  } catch (m) {
    return Promise.reject((c = m == null ? void 0 : m.response) == null ? void 0 : c.data);
  }
}, to = async ({
  queryKey: t,
  signal: e
}) => {
  var l;
  const { scope: r, ...n } = t[0], { CancelToken: a } = Le, o = a.source();
  e == null || e.addEventListener("abort", () => {
    o.cancel("/v3/ua/customers/workspaces/list - Request cancelled");
  });
  try {
    const i = await ve().get("/v3/ua/customers/workspaces/list", {
      params: {
        ...n
      },
      cancelToken: o.token
    }), { data: c } = i.data;
    return {
      totalRecords: c == null ? void 0 : c.length,
      filteredRecords: c == null ? void 0 : c.length,
      data: Xa(c ?? [])
    };
  } catch (i) {
    return Promise.reject((l = i == null ? void 0 : i.response) == null ? void 0 : l.data);
  }
}, Sn = (t) => {
  var e, r;
  (r = qe) == null || r(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, ro = (t, e) => jt(
  Ua.keys({
    ...t,
    scope: "getCustomerMultilevelData"
  }),
  eo,
  {
    onError: Sn,
    enabled: e == null ? void 0 : e.enabled,
    getNextPageParam: (n, a) => a.reduce((l, i) => {
      var c;
      return l += ((c = i == null ? void 0 : i.data) == null ? void 0 : c.length) ?? 0, l;
    }, 0) < ((n == null ? void 0 : n.filteredRecords) ?? -1) ? a.length + 1 : null
  }
), no = (t, e) => ke(
  Fa.keys({
    ...t,
    scope: "getCustomerWorkspaceData"
  }),
  to,
  {
    onError: Sn,
    enabled: e == null ? void 0 : e.enabled
  }
), so = (t) => {
  if (!Array.isArray(t))
    return [];
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const n = t[r], a = {
      value: `${n.ioId}`,
      label: n.ioName,
      ioBudgetTypeId: n.ioBudgetTypeId,
      ioStatusId: n.ioStatusId,
      status: "",
      type: "IO",
      owId: n.owId,
      uowId: n.uowId,
      lastModified: n.lastModified,
      startTime: 0,
      endTime: 0,
      timezoneId: 0,
      creativeTypeId: -1,
      isLeaf: n.campaignCount <= 0,
      subRowsCount: n.campaignCount,
      subRows: []
    };
    a.subRows = ao(
      n.campaigns,
      // send copy of parent to child and not reference to avoid cycle
      Object.assign({}, a)
    ), e.push(a);
  }
  return e;
}, ao = (t, e) => {
  if (!Array.isArray(t))
    return [];
  const r = [];
  for (let n = 0; n < t.length; n++) {
    const a = t[n], o = {
      value: `${a.id}`,
      label: a.name,
      ioBudgetTypeId: a.ioBudgetTypeId,
      ioStatusId: a.ioStatusId,
      status: a.status,
      type: "Campaign",
      owId: a.owId,
      uowId: 0,
      lastModified: a.modifiedAt,
      startTime: a.startTime,
      endTime: a.endTime,
      creativeTypeId: a.creativeTypeId,
      timezoneId: (a == null ? void 0 : a.timezoneId) ?? 0,
      isLeaf: !0,
      subRowsCount: 0,
      subRows: [],
      parent: e
    };
    r.push(o);
  }
  return r;
}, Or = (t) => {
  const e = {};
  for (const [r] of Object.entries(t ?? {}))
    e[r] = !0;
  return e;
}, kr = {
  audience: "/v3/cmp/io/campaign/served/list",
  basic: "/v3/cmp/io/campaign/basic/list",
  conversion: "/v3/cmp/io/campaign/basic/list"
}, oo = async ({
  queryKey: t,
  signal: e,
  pageParam: r = 1
}) => {
  var y;
  const { scope: n, isSelectAll: a = !1, useCase: o, ...l } = t[0], { CancelToken: i } = Le, c = i.source(), m = kr[o] ?? kr.basic;
  e == null || e.addEventListener("abort", () => {
    c.cancel(`${m} - Request cancelled`);
  });
  try {
    const p = await ve().post(
      m,
      {
        ...l,
        pageNo: a === !0 ? -1 : r
      },
      {
        cancelToken: c.token
      }
    ), { ioCampaignsList: f, totalRecords: I, filteredRecords: b } = p.data.data;
    return {
      totalRecords: I,
      filteredRecords: b,
      ioCampaignsList: so(f)
    };
  } catch (p) {
    return Promise.reject((y = p == null ? void 0 : p.response) == null ? void 0 : y.data);
  }
}, io = (t) => {
  var e, r;
  (r = qe) == null || r(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, lo = (t, e) => jt(
  Na.keys({
    ...t,
    scope: "getIOCampaignListDataKey"
  }),
  oo,
  {
    onError: io,
    enabled: e == null ? void 0 : e.enabled,
    getNextPageParam: (n, a) => a.reduce((l, i) => {
      var c;
      return l += ((c = i == null ? void 0 : i.ioCampaignsList) == null ? void 0 : c.length) ?? 0, l;
    }, 0) < ((n == null ? void 0 : n.filteredRecords) ?? -1) ? a.length + 1 : null,
    meta: e == null ? void 0 : e.meta
  }
), co = (t) => {
  const e = {
    appId: -1,
    // need to get actual appId
    appName: "Marketplace",
    appIcon: "logo/marketplace.png",
    appUrl: "/marketplace",
    showInDrawer: !1
  }, r = {
    appId: -2,
    appName: "Messages",
    appIcon: "logo/messages.png",
    appUrl: "/messages",
    showInDrawer: !1
  };
  return Array.isArray(t) ? [...t.map((a) => ({ ...a, showInDrawer: !0 })), e, r, vt] : [e, r, vt];
}, uo = async ({
  queryKey: t,
  signal: e
}) => {
  var a;
  t[0];
  const { CancelToken: r } = Le, n = r.source();
  e == null || e.addEventListener("abort", () => {
    n.cancel("/v3/ua/profile - Request cancelled");
  });
  try {
    const o = await ve().get("/v3/ua/profile", {
      cancelToken: n.token
    }), { data: l } = o.data;
    return l;
  } catch (o) {
    return Promise.reject((a = o == null ? void 0 : o.response) == null ? void 0 : a.data);
  }
}, po = async ({
  queryKey: t,
  signal: e
}) => {
  var a;
  t[0];
  const { CancelToken: r } = Le, n = r.source();
  e == null || e.addEventListener("abort", () => {
    n.cancel("/v3/ua/chatbot - Request cancelled");
  });
  try {
    const o = await ve().get("/v3/ua/chatbot", {
      cancelToken: n.token
    }), { data: l } = o.data;
    return l;
  } catch (o) {
    return Promise.reject((a = o == null ? void 0 : o.response) == null ? void 0 : a.data);
  }
}, fo = async ({
  queryKey: t,
  signal: e
}) => {
  var a;
  t[0];
  const { CancelToken: r } = Le, n = r.source();
  e == null || e.addEventListener("abort", () => {
    n.cancel("/v3/ua/user/allowed-applications - Request cancelled");
  });
  try {
    const o = await ve().get("/v3/ua/user/allowed-applications", {
      cancelToken: n.token
    }), { data: l } = o.data;
    return co(l ?? []);
  } catch (o) {
    return Promise.reject((a = o == null ? void 0 : o.response) == null ? void 0 : a.data);
  }
}, go = async ({
  queryKey: t,
  signal: e
}) => {
  try {
    const { loggedInOwId: r } = t[0], { CancelToken: n } = Le, a = n.source();
    e == null || e.addEventListener("abort", () => {
      a.cancel(
        `/v3/ua/customer/config/${r} - Request cancelled`
      );
    });
    const o = await ve().get(`/v3/ua/customer/config/${r}`, {
      cancelToken: a.token
    }), { data: l } = o.data;
    return l ?? {};
  } catch (r) {
    return Promise.reject((r == null ? void 0 : r.response) || r);
  }
}, mo = async () => {
  var t;
  try {
    const e = await ve().post("/v3/ua/logout"), { data: r } = e.data;
    return r;
  } catch (e) {
    return Promise.reject((t = e == null ? void 0 : e.response) == null ? void 0 : t.data);
  }
}, ho = async (t, e, r) => {
  var n;
  try {
    const a = new URL("/api", t), l = await Le.create({
      baseURL: a.toString(),
      headers: {
        Authorization: `Bearer ${e}`
      },
      signal: r
    }).get("/validate-user"), { message: i } = l.data;
    return i;
  } catch (a) {
    return r.aborted ? Promise.reject(a) : Promise.reject((n = a == null ? void 0 : a.response) == null ? void 0 : n.data);
  }
}, yo = async (t, e, r) => {
  var n;
  try {
    const a = new URL("/api", t), o = Le.create({
      baseURL: a.toString(),
      headers: {
        "Content-Type": void 0,
        Authorization: dr
      },
      signal: r
    }), l = new URLSearchParams();
    l.append("grant_type", "refresh_token"), l.append("refresh_token", e);
    const c = (await o.post("/v3/ua/oauth/token", l)).data ?? {};
    if (c.access_token && c.refresh_token)
      return c;
    throw new js("refresh token not valid");
  } catch (a) {
    return r.aborted ? Promise.reject(a) : Promise.reject((n = a == null ? void 0 : a.response) == null ? void 0 : n.data);
  }
}, wo = async ({
  queryKey: t,
  signal: e,
  meta: r
}) => {
  var o, l;
  t[0];
  const { CancelToken: n } = Le, a = n.source();
  e == null || e.addEventListener("abort", () => {
    a.cancel("/v3/ua/profile - Request cancelled");
  });
  try {
    const i = await ((o = r == null ? void 0 : r.instance) == null ? void 0 : o.get("/v3/ua/profile", {
      cancelToken: a.token
    })), { data: c } = i.data;
    return c;
  } catch (i) {
    return Promise.reject((l = i == null ? void 0 : i.response) == null ? void 0 : l.data);
  }
}, er = (t, e) => {
  const r = new URL("/api", t.originURL), n = Le.create({
    baseURL: r.toString(),
    headers: {
      authorization: `Bearer ${t.token}`,
      [t.owIdHeaderKey]: t.owId
    }
  });
  return ja(n, t.originURL ?? ""), wn(n), e == null || e(n, t.token, t.owId), n;
}, vo = (t) => ke(
  lt.keys({
    scope: "getProfileData"
  }),
  uo,
  {
    enabled: t == null ? void 0 : t.enabled,
    staleTime: 1 / 0
  }
), xo = (t) => ke(
  lt.keys({
    scope: "getChatBotConfig"
  }),
  po,
  {
    enabled: t == null ? void 0 : t.enabled,
    staleTime: 1 / 0
  }
), Io = (t) => ke(
  lt.keys({
    scope: "getAllowedApplications"
  }),
  fo,
  {
    enabled: t == null ? void 0 : t.enabled,
    staleTime: 1 / 0
  }
), bo = (t, e) => ke(
  Ba.keys({
    scope: "getCustomerConfig",
    loggedInOwId: t
  }),
  go,
  {
    enabled: e == null ? void 0 : e.enabled,
    staleTime: 1 / 0
  }
), So = ({
  authData: t,
  owId: e,
  originURL: r,
  onComplete: n
}) => {
  const [a, o] = u.useState(
    null
  ), l = u.useRef(null), i = It(
    (p) => n == null ? void 0 : n(p)
  );
  u.useEffect(() => {
    if (!t || !e)
      return;
    if (localStorage.setItem(fe.AUTH, JSON.stringify(t)), localStorage.setItem(fe.LAST_OWID, JSON.stringify(e)), Pe())
      localStorage.setItem(
        fe.LEGACY_OWIDS_ARRAY,
        JSON.stringify([Number(e)])
      );
    else {
      const f = JSON.parse(
        localStorage.getItem(fe.LEGACY_OWIDS_ARRAY) ?? "[]"
      ), I = f.indexOf(Number(e));
      I >= 0 ? l.current = I : (f.push(Number(e)), l.current = f.length - 1), localStorage.setItem(
        fe.LEGACY_OWIDS_ARRAY,
        JSON.stringify(f)
      );
    }
    const p = er({
      token: t.access_token ?? "",
      originURL: r ?? "",
      owIdHeaderKey: on,
      owId: Number(e)
    });
    o(() => p);
  }, [o, t, r, e, i]);
  const { data: c, isFetching: m, isError: y } = ke(
    lt.keys({ scope: "getProfileData" }),
    wo,
    {
      meta: {
        instance: a
      },
      enabled: a !== null
    }
  );
  u.useEffect(() => {
    if (a !== null && !m) {
      if (y) {
        i({
          error: "Failed to fetch profile data",
          owIdIndex: -1,
          isError: !0
        });
        return;
      }
      if (c) {
        const p = {
          // profile data
          ...c,
          // auth data
          apiToken: t.access_token,
          refreshToken: t.refresh_token,
          owId: Number(e),
          expiresAt: t.expires_in,
          //
          domainURL: cr(r)
        };
        localStorage.setItem(
          fe.LEGACY_AUTH,
          JSON.stringify(p)
        ), i({
          profileData: c,
          owIdIndex: Pe() ? 0 : l.current ?? 0,
          isError: !1
        });
      }
    }
  }, [
    m,
    y,
    a,
    c,
    e,
    t,
    i,
    r
  ]);
}, Ro = async ({
  signal: t,
  queryKey: e,
  meta: r
}) => {
  var l;
  e[0];
  const { CancelToken: n } = Le, a = n.source();
  t == null || t.addEventListener("abort", () => {
    a.cancel("/v3/ua/init - Request cancelled");
  });
  const o = r == null ? void 0 : r.axiosInstance;
  try {
    const i = await o.get("/v3/ua/init", {
      cancelToken: a.token
    }), { data: c } = i.data;
    return c;
  } catch (i) {
    return Promise.reject((l = i == null ? void 0 : i.response) == null ? void 0 : l.data);
  }
}, jo = async ({
  queryKey: t,
  signal: e,
  meta: r
}) => {
  var l;
  t[0];
  const { CancelToken: n } = Le, a = n.source();
  e == null || e.addEventListener("abort", () => {
    a.cancel("/v3/ua/st/chatbot - Request cancelled");
  });
  const o = r == null ? void 0 : r.axiosInstance;
  try {
    const i = await o.get("/v3/ua/st/chatbot", {
      cancelToken: a.token
    }), { data: c } = i.data;
    return c;
  } catch (i) {
    return Promise.reject((l = i == null ? void 0 : i.response) == null ? void 0 : l.data);
  }
}, Ao = (t, e) => ke(
  lt.keys({
    scope: "getInitData"
  }),
  Ro,
  {
    enabled: e == null ? void 0 : e.enabled,
    staleTime: 1 / 0,
    meta: {
      axiosInstance: t
    }
  }
), Lo = (t, e) => ke(
  lt.keys({
    scope: "getInitChatBotConfig"
  }),
  jo,
  {
    enabled: e == null ? void 0 : e.enabled,
    staleTime: 1 / 0,
    meta: {
      axiosInstance: t
    }
  }
), Po = async ({
  queryKey: t,
  signal: e,
  pageParam: r = 1
}) => {
  var i;
  const { scope: n, ...a } = t[0], { CancelToken: o } = Le, l = o.source();
  e == null || e.addEventListener("abort", () => {
    l.cancel("/v3/ua/user/allowed-organizations - Request cancelled");
  });
  try {
    const c = await ve().get("/v3/ua/user/allowed-organizations", {
      params: {
        ...a,
        pageNo: r
      },
      cancelToken: l.token
    }), { data: m } = c.data;
    return m ?? [];
  } catch (c) {
    return Promise.reject((i = c == null ? void 0 : c.response) == null ? void 0 : i.data);
  }
}, Co = (t) => {
  var e, r;
  (r = qe) == null || r(
    t.errorObjects ? (e = t.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, Eo = (t, e) => jt(
  za.keys({
    ...t,
    scope: "__getAllowedOrganizationList"
  }),
  Po,
  {
    onError: Co,
    enabled: e == null ? void 0 : e.enabled,
    getNextPageParam: (n, a) => a.reduce((l, i) => {
      var c;
      return l += ((c = i == null ? void 0 : i.data) == null ? void 0 : c.length) ?? 0, l;
    }, 0) < ((n == null ? void 0 : n.filteredRecords) ?? -1) ? a.length + 1 : null
  }
), Oo = async ({
  pageParam: t = 1,
  queryKey: e
}) => {
  const { scope: r, isSelectAll: n, ...a } = e[0] || {};
  try {
    return (await ve().post("/v3/cmp/io/basic/list", {
      ...a,
      pageNo: n ? -1 : t
    })).data.data;
  } catch (o) {
    return Promise.reject(o.response);
  }
}, ko = (t, e) => {
  var n;
  const r = jt(
    Ya.keys({
      ...t,
      scope: "getIOBasicList"
    }),
    Oo,
    {
      getNextPageParam: (a, o) => {
        const l = o.reduce(
          (i, c) => {
            var m;
            return i + Number(((m = c == null ? void 0 : c.ioBasicDetailsList) == null ? void 0 : m.length) ?? 0);
          },
          0
        );
        return (a == null ? void 0 : a.filteredRecords) !== void 0 && l < (a == null ? void 0 : a.filteredRecords) ? o.length + 1 : null;
      },
      enabled: (e == null ? void 0 : e.enabled) ?? !0
    }
  );
  if (r.isError) {
    const a = r.error;
    qe(
      a != null && a.errorObjects ? (n = a == null ? void 0 : a.errorObjects[0]) == null ? void 0 : n.error : "Something went wrong!",
      {
        variant: "error"
      }
    );
  }
  return r;
}, Dr = new Intl.NumberFormat("en-us", {
  maximumFractionDigits: 1,
  minimumFractionDigits: 0,
  notation: "compact"
}), Do = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0
}), _o = ({
  totalReach: t,
  isReachDataAvailable: e = !1
}) => {
  const r = (t ?? 0) > 0;
  if (e && r)
    return "Reach breakdown is unavailable for this segment";
  if (e && !r)
    return "Segment is available, but reach and/or cost data is currently unavailable";
  if (!e && !r)
    return "Reach and/or cost data for this segment is currently unavailable";
  if (!e && r)
    return "Reach breakdown is unavailable for this segment";
}, To = (t) => Object.values(t ?? {}).filter((e) => e > 0).length > 0, Rn = (t) => {
  const { data: e } = t, {
    totalReach: r,
    cpm: n,
    reachMetadata: a,
    isReachDataAvailable: o,
    lastUpdatedDate: l
  } = e, i = typeof r == "number", c = typeof n == "number", m = [
    { label: "iOS Device Reach", value: a == null ? void 0 : a.iosDevicesReach },
    {
      label: "Android Device Reach",
      value: a == null ? void 0 : a.androidDevicesReach
    },
    { label: "Cookie Reach", value: a == null ? void 0 : a.cookiesReach }
  ], p = u.useMemo(
    () => To(a),
    [a]
  ) ? /* @__PURE__ */ s.jsx(R, { sx: { width: 100 }, children: /* @__PURE__ */ s.jsx(
    "ul",
    {
      style: {
        listStyle: "none",
        listStylePosition: "outside",
        paddingLeft: "0"
      },
      children: m.map(
        (f) => f.value ? /* @__PURE__ */ s.jsxs("li", { children: [
          /* @__PURE__ */ s.jsx(A, { children: f.label }),
          ":",
          " ",
          /* @__PURE__ */ s.jsx(A, { weight: "demi", children: Dr.format(f.value) })
        ] }, f.label) : null
      )
    }
  ) }) : /* @__PURE__ */ s.jsx(A, { children: _o({ totalReach: r, isReachDataAvailable: o }) });
  return /* @__PURE__ */ s.jsx(
    R,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        flexShrink: 0,
        gap: 8
      },
      children: /* @__PURE__ */ s.jsxs(
        R,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "end",
            flexShrink: 0,
            gap: 4
          },
          children: [
            /* @__PURE__ */ s.jsxs(
              R,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  flexShrink: 0,
                  gap: 8
                },
                children: [
                  /* @__PURE__ */ s.jsx(Te, { title: p, arrow: !0, children: /* @__PURE__ */ s.jsx(
                    Ve,
                    {
                      color: "secondary",
                      size: "small",
                      label: /* @__PURE__ */ s.jsxs(
                        R,
                        {
                          Component: "span",
                          sx: { display: "flex", alignItems: "center", gap: 2 },
                          children: [
                            /* @__PURE__ */ s.jsx(Hr, { fontSize: 18, sx: { textColor: "neutral-500" } }),
                            /* @__PURE__ */ s.jsx(A, { weight: "demi", children: i ? Dr.format(r) : "-" }),
                            !!o && /* @__PURE__ */ s.jsx(
                              ot,
                              {
                                variant: "dot",
                                size: "small",
                                color: "success",
                                sx: { ml: 2 }
                              }
                            )
                          ]
                        }
                      )
                    }
                  ) }),
                  /* @__PURE__ */ s.jsx(
                    Te,
                    {
                      title: c ? null : "Cost data for this segment is currently unavailable.",
                      arrow: !0,
                      children: /* @__PURE__ */ s.jsx(
                        Ve,
                        {
                          color: "secondary",
                          size: "small",
                          label: /* @__PURE__ */ s.jsxs(
                            R,
                            {
                              Component: "span",
                              sx: { display: "flex", alignItems: "center", gap: 2 },
                              children: [
                                /* @__PURE__ */ s.jsx(
                                  Ft,
                                  {
                                    fontSize: 18,
                                    sx: { textColor: "neutral-500" },
                                    "aria-label": "CPM in Dollars: "
                                  }
                                ),
                                /* @__PURE__ */ s.jsx(A, { weight: "demi", children: c ? Do.format(n) : "-" })
                              ]
                            }
                          )
                        }
                      )
                    }
                  )
                ]
              }
            ),
            !!l && /* @__PURE__ */ s.jsxs(
              A,
              {
                component: "div",
                variant: "label",
                sx: { textColor: "neutral-600", textAlign: "right" },
                children: [
                  "Last updated:",
                  " ",
                  new Date(l).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short"
                  })
                ]
              }
            )
          ]
        }
      )
    }
  );
}, No = "_breadcrumbItem_1kqe8_1", Uo = {
  breadcrumbItem: No
}, Fo = (t) => {
  var l;
  const { data: e, hideDescription: r, disableTooltip: n, sx: a } = t, o = (l = e.parentPathKey) == null ? void 0 : l.split(">").map((i) => i.trim());
  return /* @__PURE__ */ s.jsxs(
    R,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        width: 100,
        gap: 8,
        overflow: "hidden",
        ...a
      },
      children: [
        /* @__PURE__ */ s.jsx(
          Te,
          {
            arrow: !0,
            enterDelay: 500,
            enterNextDelay: 500,
            title: n ? null : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Ht,
                {
                  "aria-label": "breadcrumb",
                  sx: { mb: 4 },
                  separator: /* @__PURE__ */ s.jsx(
                    Gt,
                    {
                      fontSize: 20,
                      sx: { textColor: "neutral-400" }
                    }
                  ),
                  maxItems: 999,
                  children: o == null ? void 0 : o.map((i, c) => /* @__PURE__ */ s.jsx(A, { weight: "demi", children: i }, c))
                }
              ),
              /* @__PURE__ */ s.jsx(A, { children: e.description })
            ] }),
            sx: { width: 100 },
            children: /* @__PURE__ */ s.jsxs(
              R,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                  gap: 8,
                  width: 100
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    ze,
                    {
                      size: 36,
                      variant: "square",
                      src: e.partnerLogoUrl,
                      alt: e.name,
                      imgProps: {
                        style: { objectFit: "contain" },
                        sx: { bgColor: "neutral-0" }
                      }
                    }
                  ),
                  /* @__PURE__ */ s.jsxs(
                    R,
                    {
                      sx: {
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        width: 100,
                        gap: 4
                      },
                      children: [
                        /* @__PURE__ */ s.jsx(
                          Ht,
                          {
                            "aria-label": "breadcrumb",
                            separator: /* @__PURE__ */ s.jsx(Gt, { fontSize: 20, sx: { textColor: "neutral-400" } }),
                            maxItems: 3,
                            slotProps: {
                              // @ts-ignore
                              collapsedButton: {
                                disabled: !0
                              }
                            },
                            itemsBeforeCollapse: 2,
                            classes: {
                              root: je({ overflow: "hidden" }),
                              ol: je({
                                flexWrap: "nowrap",
                                overflow: "hidden"
                              }),
                              li: Uo.breadcrumbItem
                            },
                            children: o == null ? void 0 : o.map((i, c) => /* @__PURE__ */ s.jsx(
                              A,
                              {
                                weight: "demi",
                                noWrap: !0,
                                sx: { display: "block", overflow: "hidden" },
                                children: i
                              },
                              c
                            ))
                          }
                        ),
                        !r && /* @__PURE__ */ s.jsx(
                          A,
                          {
                            variant: "label",
                            noWrap: !0,
                            lineHeight: "single-line",
                            sx: {
                              display: "block",
                              overflow: "hidden",
                              textColor: "neutral-600"
                            },
                            children: e.description
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ s.jsx(Rn, { data: e })
      ]
    }
  );
}, Bo = (t) => {
  const { row: e } = t;
  return /* @__PURE__ */ s.jsx(A, { variant: "bodySmall", gutterBottom: !1, sx: { ml: 4 }, children: e.original.label });
}, zo = (t) => {
  var r, n, a, o, l, i;
  const { row: e } = t;
  return /* @__PURE__ */ s.jsxs(
    R,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        py: 2,
        pl: 4,
        width: 100,
        overflow: "hidden"
      },
      children: [
        /* @__PURE__ */ s.jsx(R, { sx: { flexShrink: 0 }, children: /* @__PURE__ */ s.jsx(
          ze,
          {
            size: 36,
            variant: "square",
            src: e.original.logoUrl,
            alt: e.original.name,
            imgProps: {
              style: { objectFit: "contain" },
              sx: { bgColor: "neutral-0" }
            }
          }
        ) }),
        /* @__PURE__ */ s.jsxs(
          R,
          {
            sx: {
              display: "inline-flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 8,
              width: 100,
              overflow: "hidden"
            },
            children: [
              /* @__PURE__ */ s.jsxs(
                R,
                {
                  sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    flexShrink: 0
                  },
                  children: [
                    /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
                      /* @__PURE__ */ s.jsx(A, { weight: "demi", variant: "bodySmall", gutterBottom: !1, children: e.original.label }),
                      e.original.customPartner === !0 && /* @__PURE__ */ s.jsx(zs, { fontSize: 16, sx: { textColor: "neutral-500" } })
                    ] }),
                    e.original.customPartner === !0 && /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 12 }, children: [
                      /* @__PURE__ */ s.jsxs(
                        A,
                        {
                          component: "span",
                          variant: "label",
                          sx: { textColor: "neutral-500" },
                          children: [
                            /* @__PURE__ */ s.jsx(A, { weight: "demi", children: "Seat ID" }),
                            " ",
                            e.original.seatId
                          ]
                        }
                      ),
                      (((r = e.original.subRows) == null ? void 0 : r.length) ?? 0) <= 0 && ((a = (n = e.original.subRows) == null ? void 0 : n[0]) == null ? void 0 : a.type) !== "noResultsLeaf" ? /* @__PURE__ */ s.jsx(s.Fragment, {}) : null
                    ] })
                  ]
                }
              ),
              (o = e.original.subRows) != null && o.length && ((i = (l = e.original.subRows) == null ? void 0 : l[0]) == null ? void 0 : i.type) !== "noResultsLeaf" && !e.getIsExpanded() ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
                /* @__PURE__ */ s.jsx(
                  A,
                  {
                    component: "span",
                    variant: "label",
                    sx: { textColor: "neutral-400" },
                    children: "•"
                  }
                ),
                /* @__PURE__ */ s.jsx(A, { children: "Providers:" }),
                /* @__PURE__ */ s.jsxs(
                  R,
                  {
                    sx: { display: "flex", gap: 12, width: 100, overflow: "hidden" },
                    children: [
                      /* @__PURE__ */ s.jsx(
                        R,
                        {
                          sx: {
                            maxWidth: 100,
                            display: "flex",
                            gap: 12,
                            overflow: "hidden"
                          },
                          children: e.original.subRows.slice(0, 3).map((c, m) => /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", gap: 4 }, children: [
                            /* @__PURE__ */ s.jsx(
                              ze,
                              {
                                size: 18,
                                variant: "square",
                                src: c.logoUrl,
                                alt: c.name,
                                classes: {
                                  fallback: je({ bgColor: "transparent" }),
                                  img: je({ bgColor: "neutral-0" }),
                                  colorDefault: je({ bgColor: "transparent" })
                                },
                                imgProps: {
                                  style: { objectFit: "contain" }
                                },
                                children: /* @__PURE__ */ s.jsx(
                                  Ms,
                                  {
                                    fontSize: 18,
                                    sx: { textColor: "neutral-500" }
                                  }
                                )
                              }
                            ),
                            /* @__PURE__ */ s.jsx(A, { sx: { whiteSpace: "nowrap" }, children: c.name })
                          ] }, m))
                        }
                      ),
                      e.original.subRows.length > 3 && /* @__PURE__ */ s.jsxs(A, { sx: { flexShrink: 0 }, children: [
                        "+ ",
                        e.original.subRows.length - 3,
                        " more"
                      ] })
                    ]
                  }
                )
              ] }) : null
            ]
          }
        )
      ]
    }
  );
};
var xt = /* @__PURE__ */ ((t) => (t[t.ALL = 1] = "ALL", t[t.READY_ONLY = 2] = "READY_ONLY", t))(xt || {});
const Mo = (t) => {
  const e = {};
  for (const [r] of Object.entries(t ?? {}))
    e[r] = !0;
  return e;
}, $o = (t) => Object.keys(t.providerIds).length > 0 || Object.keys(t.priceRangeIds).length > 0 || Object.keys(t.reachRangeIds).length > 0 || Object.keys(t.availabilityId).length > 0 || Object.keys(t.verticalIds).length > 0, Ct = (t) => {
  if (t && Object.values(t).length > 0)
    return Object.keys(t).join(",");
}, jn = (t, e, r) => {
  var o;
  let a = Number.parseInt(
    ((o = Object.keys(t.availabilityId)) == null ? void 0 : o[0]) ?? `${xt.ALL}`,
    10
  ) !== xt.ALL;
  return r && (a = !0), {
    partnerIds: Number.isInteger(e) ? `${e}` : void 0,
    verticalIds: Ct(t.verticalIds),
    providerIds: Ct(t.providerIds),
    priceRangeIds: Ct(t.priceRangeIds),
    reachRangeIds: Ct(t.reachRangeIds),
    showOnlyReadySegments: a
  };
}, An = (t) => {
  var r;
  const e = (r = Object.keys(t)) == null ? void 0 : r[0];
  if (e)
    return `-${e}`;
};
let pt = 0;
const Ln = (t, e) => (pt = pt + 1, {
  value: `noResultsLeaf-${pt}`,
  preservedValue: `noResultsLeaf-${pt}`,
  label: "",
  description: null,
  parentPathKey: null,
  id: pt,
  name: "",
  logoUrl: null,
  type: "noResultsLeaf",
  placeholderType: e,
  subRows: [],
  isLeaf: !0,
  isPartnerPublic: null,
  partnerId: t.partnerId,
  partnerLogoUrl: null,
  cpm: null,
  totalReach: null,
  lastUpdatedDate: null,
  reachMetadata: null,
  isReachDataAvailable: null,
  customPartner: !1
}), Wo = (t, e) => !Array.isArray(t) || !t.length ? [Ln(e, "segment")] : t.map((r) => ({
  value: `${r.leafNode ? "segment" : "segmentGroup"}-${r.segmentId}`,
  preservedValue: `${r.segmentId}`,
  label: r.taxonomyValue,
  description: r.description,
  parentPathKey: r.pathKey,
  id: r.segmentId,
  name: r.taxonomyValue,
  logoUrl: null,
  type: r.leafNode ? "segment" : "segmentGroup",
  subRows: [],
  isLeaf: r.leafNode,
  isPartnerPublic: null,
  partnerId: e.partnerId,
  partnerLogoUrl: e.partnerLogoUrl,
  cpm: r.cpm || null,
  totalReach: r.totalReach || null,
  lastUpdatedDate: r.lastUpdatedDate ? Date.parse(r.lastUpdatedDate).valueOf() : null,
  reachMetadata: r.reachMetadata || null,
  isReachDataAvailable: r.dataAvailable || null,
  customPartner: !1
})), Vo = (t, e, r, n) => !Array.isArray(t) || !t.length ? [Ln(e, "provider")] : t.map((a) => ({
  value: n ? n(a) : `provider-${a.providerId}`,
  preservedValue: `${a.providerId}`,
  label: a.providerName,
  description: a.providerDescription,
  parentPathKey: null,
  id: a.providerId,
  name: a.providerName,
  logoUrl: a.providerLogoUrl,
  partnerLogoUrl: e.partnerLogoUrl || null,
  type: "provider",
  subRows: [],
  isLeaf: r || !1,
  isPartnerPublic: null,
  partnerId: e.partnerId,
  cpm: null,
  totalReach: null,
  lastUpdatedDate: null,
  isReachDataAvailable: null,
  verticalIdList: a.verticalIdList,
  customPartner: !1
})), Pn = (t, e, r) => Array.isArray(t) ? t.sort((n, a) => n.order - a.order).map((n) => ({
  value: `partner-${n.partnerId}`,
  preservedValue: `${n.partnerId}`,
  label: n.partnerName,
  description: n.partnerDescription,
  id: n.partnerId,
  name: n.partnerName,
  logoUrl: n.partnerLogoUrl,
  partnerLogoUrl: n.partnerLogoUrl || null,
  parentPathKey: null,
  isLeaf: !1,
  subRows: Vo(
    n.providerList,
    n,
    e,
    r
  ),
  type: "partner",
  isPartnerPublic: n.isPartnerPublic,
  partnerId: n.partnerId,
  cpm: null,
  totalReach: null,
  lastUpdatedDate: null,
  isReachDataAvailable: null,
  seatId: n.seatId,
  verticalIdList: n.verticalIdList,
  customPartner: n.customPartner
})) : [], Ko = (t) => Array.isArray(t) ? t.map(
  (e) => ({
    value: `${e.segmentId}`,
    preservedValue: `${e.segmentId}`,
    label: e.taxonomyValue,
    description: e.description,
    id: e.segmentId,
    name: e.taxonomyValue,
    logoUrl: e.logoUrl,
    partnerLogoUrl: e.logoUrl,
    parentPathKey: e.pathKey,
    isLeaf: !0,
    subRows: [],
    type: "segment",
    isPartnerPublic: null,
    partnerId: e.partnerId,
    cpm: e.cpm || null,
    totalReach: e.totalReach || null,
    lastUpdatedDate: e.lastUpdatedDate ? Date.parse(e.lastUpdatedDate).valueOf() : null,
    reachMetadata: e.reachMetadata || null,
    isReachDataAvailable: e.dataAvailable || null,
    customPartner: !1
  })
) : [], qo = (t, e, r) => {
  const n = Object.keys(e).length > 0, a = Object.keys(r).length > 0;
  if (n || a) {
    let o = t;
    return n && (o = o.filter(
      (i) => {
        var c;
        return (c = i.verticalIdList) == null ? void 0 : c.find((m) => e[m]);
      }
    )), o = o.map((i) => {
      if (Array.isArray(i.subRows) && i.subRows.length > 0) {
        let c = i.subRows;
        return a && (c = c.filter((m) => r[m.id])), n && (c = c.filter(
          (m) => {
            var y;
            return (y = m.verticalIdList) == null ? void 0 : y.find((p) => e[p]);
          }
        )), { ...i, subRows: c };
      }
      return i;
    }), o.filter(
      (i) => Array.isArray(i.subRows) && i.subRows.length > 0
    );
  }
  return t;
}, Ho = (t) => {
  const { search: e, filters: r, placeholderType: n = "segment" } = t;
  let o = (e == null ? void 0 : e.length) > 0 || $o(r) ? "No segments found. We can't find any items matching your filters criteria." : "No segments found.";
  return n === "provider" && (o = "No providers found."), /* @__PURE__ */ s.jsx(A, { variant: "bodySmall", gutterBottom: !1, children: o });
}, Yo = (t) => {
  const { row: e } = t;
  return /* @__PURE__ */ s.jsx(A, { variant: "bodySmall", gutterBottom: !1, sx: { ml: 4 }, children: e.original.label });
}, Go = (t) => {
  const { disableTooltip: e, row: r } = t;
  return /* @__PURE__ */ s.jsxs(
    R,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        width: 100,
        gap: 8,
        overflow: "hidden"
      },
      children: [
        /* @__PURE__ */ s.jsx(
          Te,
          {
            title: e ? null : /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", flexDirection: "column", gap: 4 }, children: [
              /* @__PURE__ */ s.jsx(
                A,
                {
                  variant: "bodySmall",
                  gutterBottom: !1,
                  sx: {
                    display: "block"
                  },
                  weight: "demi",
                  children: r.original.label
                }
              ),
              /* @__PURE__ */ s.jsx(
                A,
                {
                  component: "span",
                  variant: "label",
                  sx: {
                    textColor: "neutral-600",
                    display: "block"
                  },
                  children: r.original.description
                }
              )
            ] }),
            arrow: !0,
            sx: { width: 100 },
            children: /* @__PURE__ */ s.jsxs(
              R,
              {
                sx: {
                  width: 100,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  gap: 4
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    A,
                    {
                      noWrap: !0,
                      variant: "bodySmall",
                      gutterBottom: !1,
                      weight: "demi",
                      sx: {
                        display: "block",
                        overflow: "hidden"
                      },
                      children: r.original.label
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    A,
                    {
                      noWrap: !0,
                      component: "span",
                      variant: "label",
                      gutterBottom: !1,
                      sx: {
                        textColor: "neutral-600",
                        display: "block",
                        overflow: "hidden"
                      },
                      children: r.original.description
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ s.jsx(Rn, { data: r.original })
      ]
    }
  );
}, Jo = Oe.DefaultListOptionItemWrapper({
  disableCheckbox: !0,
  selectionStyle: "none"
}), Qo = (t) => {
  const { row: e, filters: r, search: n, disableTooltip: a } = t;
  return e.original.type === "noResultsLeaf" ? /* @__PURE__ */ s.jsx(
    Ho,
    {
      search: n,
      filters: r,
      placeholderType: e.original.placeholderType
    }
  ) : e.original.type === "partner" ? /* @__PURE__ */ s.jsx(zo, { row: e }) : e.original.type === "provider" ? /* @__PURE__ */ s.jsx(Yo, { row: e }) : e.original.type === "segmentGroup" ? /* @__PURE__ */ s.jsx(Bo, { row: e }) : e.original.type === "segment" ? /* @__PURE__ */ s.jsx(Go, { row: e, disableTooltip: a }) : null;
}, Zo = {
  onClick: (t) => {
    t.preventDefault(), t.stopPropagation();
  },
  onKeyDown: (t) => {
    t.preventDefault(), t.stopPropagation();
  },
  role: "button",
  tabIndex: -1,
  style: { pointerEvents: "auto" }
}, Xo = (t) => {
  const {
    rowObject: e,
    search: r,
    filters: n,
    selectedPartnerId: a,
    isMaxSelection: o,
    maxSelectCount: l,
    maxSelectCountTooltip: i,
    rowSelection: c
  } = t, { row: m, isDisabled: y } = e;
  let p = "";
  return y && (a && a !== m.original.partnerId ? p = "Users can select segments from only one data partner within a single segment audience" : o && m.original.type === "segment" && !c[m.original.value] && (p = (i == null ? void 0 : i.replaceAll(
    "{{maxSelectCount}}",
    o && l ? `${l}` : ""
  )) ?? "")), /* @__PURE__ */ s.jsx(
    Te,
    {
      arrow: !0,
      title: p,
      enterDelay: 500,
      enterNextDelay: 500,
      children: /* @__PURE__ */ s.jsx(
        R,
        {
          sx: { width: 100, display: "flex", alignItems: "center" },
          style: { maxWidth: "100%" },
          ...y ? Zo : {},
          children: r.length ? /* @__PURE__ */ s.jsx(
            Fo,
            {
              data: e.row.original,
              disableTooltip: p.length > 0
            }
          ) : /* @__PURE__ */ s.jsx(
            Qo,
            {
              row: e.row,
              filters: n,
              search: r,
              disableTooltip: p.length > 0
            }
          )
        }
      )
    }
  );
}, ei = (t) => {
  const {
    search: e,
    sortBy: r,
    filters: n,
    selectedPartnerId: a,
    sx: o = {},
    showOnlyNonZeroSegments: l,
    showOnlyReadSegementsAlways: i
  } = t, c = async (m) => {
    var y, p, f;
    m.stopPropagation();
    try {
      const I = await Di({
        ...jn(
          n,
          a,
          i
        ),
        searchField: e.join(","),
        sortBy: An(r),
        showOnlyNonZeroSegments: l
      }), { fileUrl: b } = I.data || {};
      if (!I.success || !b)
        throw I;
      const w = document.createElement("a");
      w.setAttribute("href", b), w.setAttribute("download", "segment-search-results.csv"), w.click();
    } catch (I) {
      (f = qe) == null || f(
        ((p = (y = I == null ? void 0 : I.errorObjects) == null ? void 0 : y[0]) == null ? void 0 : p.error) || "Something went wrong. Please try again later.",
        {
          variant: "error"
        }
      );
    }
  };
  return /* @__PURE__ */ s.jsx(
    We,
    {
      variant: "text",
      size: "small",
      startIcon: /* @__PURE__ */ s.jsx($s, {}),
      onClick: c,
      sx: { whiteSpace: "nowrap", ...o },
      children: "Download Results"
    }
  );
}, ti = Oe.DefaultListOptionItemWrapper({
  slotProps: {
    checkbox: {
      indeterminateIcon: /* @__PURE__ */ s.jsx(Dt, {}),
      checkedIcon: /* @__PURE__ */ s.jsx(Dt, {}),
      icon: /* @__PURE__ */ s.jsx(Yr, {})
    }
  },
  arrowPosition: "right"
}), ri = (t) => {
  const { data: e, dispatch: r } = t, {
    data: n = [],
    isLoading: a,
    isFetching: o,
    isError: l
  } = Wi(), i = u.useMemo(() => {
    if (!(a || o))
      return n.length <= 0 ? "noRows" : l ? "error" : void 0;
  }, [n, l, o, a]);
  return /* @__PURE__ */ s.jsx(
    bt,
    {
      size: "small",
      data: n,
      rowCount: n.length ?? 5,
      multiple: !1,
      loading: a || o,
      overlay: i,
      hideSearch: !0,
      value: e,
      renderListItem: ti,
      getRowId: (c) => `${c.id}`,
      getOptionLabel: (c) => c.displayName,
      onChange: (c) => {
        const m = typeof c == "function" ? c(e) : c;
        r == null || r({
          type: "SET_AVABILITY",
          payload: {
            data: m
          }
        });
      },
      slotProps: {
        BoxProps: {
          className: je({ py: 12 })
        },
        SelectAllBoxProps: { sx: { borderTop: 0 } }
      },
      allowClearingSingleSelect: !0
    }
  );
}, ni = Oe.DefaultListOptionItemWrapper({
  arrowPosition: "right",
  selectionStyle: "partial"
}), Cn = u.forwardRef((t) => {
  var p;
  const { data: e, dispatch: r } = t, { isLoading: n, isFetching: a, isError: o, data: l } = Bi(), i = u.useMemo(() => {
    if (!(n || a))
      return ((l == null ? void 0 : l.partnerProviderList.length) ?? 0) <= 0 ? "noRows" : o ? "error" : void 0;
  }, [l, o, n, a]), [c, m] = u.useState(""), y = Oe.useSelectAdvanceApiRef();
  return u.useEffect(() => {
    c.length ? y.current.tableInstance.setExpanded(!0) : y.current.tableInstance.setExpanded(!1);
  }, [c, y]), /* @__PURE__ */ s.jsx(
    bt,
    {
      apiRef: y,
      size: "small",
      data: (l == null ? void 0 : l.partnerProviderList) ?? [],
      rowCount: ((p = l == null ? void 0 : l.partnerProviderList) == null ? void 0 : p.length) ?? 5,
      multiple: !0,
      loading: n || a,
      overlay: i,
      inputValue: c,
      slotProps: {
        InputBaseProps: {
          placeholder: "Search partner or provider",
          value: c,
          onChange: (f) => {
            var I;
            m(((I = f.target) == null ? void 0 : I.value) ?? "");
          },
          endAdornment: c.length > 0 ? /* @__PURE__ */ s.jsx(Fe, { size: "small", onClick: () => m(""), children: /* @__PURE__ */ s.jsx(ir, {}) }) : null
        }
      },
      renderListItem: ni,
      getSubRows: (f) => {
        var I;
        return (((I = f.subRows) == null ? void 0 : I.length) ?? 0) > 0 ? f.subRows : void 0;
      },
      getRowCanExpand: (f) => {
        var I;
        return (((I = f.original.subRows) == null ? void 0 : I.length) ?? 0) > 0;
      },
      getOptionDisabled: (f) => {
        var I, b;
        return f.subRows.length === 1 && ((b = (I = f.subRows) == null ? void 0 : I[0]) == null ? void 0 : b.type) === "noResultsLeaf" ? !0 : f.type === "noResultsLeaf";
      },
      disabledItemsFocusable: !0,
      renderOption: (f) => si(f.row),
      value: e,
      onChange: (f) => {
        const I = typeof f == "function" ? f(e) : f;
        r == null || r({
          type: "SET_PROVIDER",
          payload: { data: I }
        });
      },
      getRowId: (f) => `${f.type === "provider" ? f.id : `partner-${f.id}`}`,
      enableGlobalFilter: !0,
      enableColumnFilters: !0,
      filterFromLeafRows: !0,
      columns: [
        {
          accessorKey: "id",
          enableGlobalFilter: !1
        },
        {
          accessorKey: "value",
          enableGlobalFilter: !1
        },
        {
          accessorKey: "label",
          enableGlobalFilter: !0
        }
      ]
    }
  );
});
Cn.displayName = "ProviderSelect";
const si = (t) => /* @__PURE__ */ s.jsxs(R, { sx: { width: 100, display: "flex", alignItems: "center", gap: 4 }, children: [
  t.original.type === "partner" && /* @__PURE__ */ s.jsx(
    ze,
    {
      size: 24,
      variant: "square",
      src: t.original.logoUrl,
      alt: t.original.name,
      imgProps: {
        style: { objectFit: "contain" }
      },
      sx: { bgColor: "transparent" }
    }
  ),
  /* @__PURE__ */ s.jsx(A, { component: "span", variant: "bodySmall", gutterBottom: !1, children: t.original.label })
] }), ai = {
  political: "green",
  healthcare: "purple",
  specialty: "blue"
}, oi = {
  political: /* @__PURE__ */ s.jsx(Ws, { fontSize: 20, sx: { textColor: "primary-500" } }),
  healthcare: /* @__PURE__ */ s.jsx(Vs, { fontSize: 20, sx: { textColor: "primary-500" } }),
  specialty: /* @__PURE__ */ s.jsx(Ks, { fontSize: 20, sx: { textColor: "primary-500" } })
}, ii = Oe.DefaultListOptionItemWrapper({
  slotProps: {
    checkbox: {
      indeterminateIcon: /* @__PURE__ */ s.jsx(Dt, {}),
      checkedIcon: /* @__PURE__ */ s.jsx(Dt, {}),
      icon: /* @__PURE__ */ s.jsx(Yr, {})
    }
  },
  arrowPosition: "right"
}), li = (t) => {
  const { data: e, dispatch: r } = t, {
    data: n = [],
    isLoading: a,
    isFetching: o,
    isError: l
  } = Vi(), i = u.useMemo(() => {
    if (!(a || o))
      return n.length <= 0 ? "noRows" : l ? "error" : void 0;
  }, [n, l, o, a]);
  return /* @__PURE__ */ s.jsx(
    bt,
    {
      size: "small",
      data: n,
      rowCount: n.length ?? 5,
      multiple: !1,
      loading: a || o,
      overlay: i,
      hideSearch: !0,
      value: e,
      renderListItem: ii,
      getRowId: (c) => `${c.id}`,
      getOptionLabel: (c) => c.label,
      onChange: (c) => {
        const m = typeof c == "function" ? c(e) : c;
        r == null || r({
          type: "SET_VERTICAL",
          payload: {
            data: m
          }
        });
      },
      allowClearingSingleSelect: !0,
      slotProps: {
        BoxProps: {
          className: je({ py: 12 })
        }
      },
      renderOption: (c) => ci(c.row)
    }
  );
}, ci = (t) => {
  var n, a;
  const e = oi[((n = t.original.name) == null ? void 0 : n.toLowerCase()) || ""], r = ai[((a = t.original.name) == null ? void 0 : a.toLowerCase()) || ""];
  return /* @__PURE__ */ s.jsxs(R, { sx: { width: 100, display: "flex", alignItems: "center", gap: 4 }, children: [
    /* @__PURE__ */ s.jsx(cs, { variant: r, sx: { display: "flex" }, children: e || null }),
    /* @__PURE__ */ s.jsx(A, { component: "span", variant: "bodySmall", gutterBottom: !1, children: t.original.label })
  ] });
}, di = Oe.DefaultListOptionItemWrapper({
  arrowPosition: "right"
}), ui = (t) => {
  const { data: e, dispatch: r } = t, { data: n, isError: a, isFetching: o, isLoading: l } = Mi(), i = u.useMemo(() => {
    if (!(l || o))
      return ((n == null ? void 0 : n.length) ?? 0) <= 0 ? "noRows" : a ? "error" : void 0;
  }, [n, a, o, l]);
  return /* @__PURE__ */ s.jsx(
    bt,
    {
      size: "small",
      data: n ?? [],
      rowCount: (n == null ? void 0 : n.length) ?? 5,
      multiple: !0,
      loading: l || o,
      overlay: i,
      hideSearch: !0,
      value: e,
      renderListItem: di,
      getRowId: (c) => `${c.id}`,
      getOptionLabel: (c) => c.displayName,
      onChange: (c) => {
        const m = typeof c == "function" ? c(e) : c;
        r == null || r({
          type: "SET_PRICE",
          payload: {
            data: m
          }
        });
      },
      allowClearingSingleSelect: !0,
      slotProps: {
        BoxProps: {
          className: je({ py: 12 })
        },
        SelectAllBoxProps: { sx: { borderTop: 0 } }
      }
    }
  );
}, pi = Oe.DefaultListOptionItemWrapper({
  arrowPosition: "right"
}), fi = (t) => {
  const { data: e, dispatch: r } = t, { data: n, isFetching: a, isLoading: o, isError: l } = $i(), i = u.useMemo(() => {
    if (!(o || a))
      return ((n == null ? void 0 : n.length) ?? 0) <= 0 ? "noRows" : l ? "error" : void 0;
  }, [n, l, a, o]);
  return /* @__PURE__ */ s.jsx(
    bt,
    {
      size: "small",
      data: n ?? [],
      rowCount: (n == null ? void 0 : n.length) ?? 5,
      multiple: !0,
      loading: o || a,
      overlay: i,
      hideSearch: !0,
      renderListItem: pi,
      value: e,
      getRowId: (c) => `${c.id}`,
      getOptionLabel: (c) => c.displayName,
      onChange: (c) => {
        const m = typeof c == "function" ? c(e) : c;
        r == null || r({
          type: "SET_REACH",
          payload: {
            data: m
          }
        });
      },
      slotProps: {
        BoxProps: {
          className: je({ py: 12 })
        },
        SelectAllBoxProps: { sx: { borderTop: 0 } }
      }
    }
  );
}, gi = (t) => mi(t), mi = (t) => {
  const { activeTab: e, filters: r, dispatch: n } = t;
  switch (e) {
    case "vertical":
      return /* @__PURE__ */ s.jsx(li, { data: r.verticalIds, dispatch: n });
    case "source":
      return /* @__PURE__ */ s.jsx(Cn, { data: r.providerIds, dispatch: n });
    case "price":
      return /* @__PURE__ */ s.jsx(ui, { data: r.priceRangeIds, dispatch: n });
    case "reach":
      return /* @__PURE__ */ s.jsx(fi, { data: r.reachRangeIds, dispatch: n });
    case "availability":
      return /* @__PURE__ */ s.jsx(ri, { data: r.availabilityId, dispatch: n });
    default:
      return null;
  }
}, hi = (t) => {
  const {
    activeTab: e,
    setActiveTab: r,
    filters: n,
    search: a,
    showOnlyReadSegementsAlways: o
  } = t, l = ur.filter((i) => !(i.value === "availability" && o === !0));
  return console.log(l, o), u.useLayoutEffect(() => {
    var i;
    a.length || r(
      (i = l == null ? void 0 : l.find(
        (c) => !_t.includes(c.filterKey)
      )) == null ? void 0 : i.value
    );
  }, [a]), /* @__PURE__ */ s.jsx(R, { sx: { py: 12, width: 100 }, children: /* @__PURE__ */ s.jsx(rr, { value: e, orientation: "vertical", children: l.map((i) => {
    const c = n[i.filterKey], m = Object.values(c).length, y = m > 0 ? /* @__PURE__ */ s.jsxs(
      A,
      {
        component: "span",
        variant: "label",
        sx: { textColor: "neutral-600" },
        weight: "normal",
        children: [
          "(",
          m,
          ")"
        ]
      }
    ) : null;
    return /* @__PURE__ */ s.jsx(
      at,
      {
        sx: {
          display: a.length <= 0 && _t.find(
            (p) => p === i.filterKey
          ) !== void 0 ? "none" : "flex",
          alignItems: "start"
        },
        label: /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
          /* @__PURE__ */ s.jsx(A, { component: "span", children: i.label }),
          y
        ] }),
        value: i.value,
        onClick: () => r(i.value)
      },
      i.value
    );
  }) }) });
}, yi = (t, e) => {
  const { type: r, payload: n } = e;
  switch (r) {
    case "SET_AVABILITY":
      return { ...t, availabilityId: n.data };
    case "SET_PRICE":
      return { ...t, priceRangeIds: n.data };
    case "SET_REACH":
      return { ...t, reachRangeIds: n.data };
    case "SET_PROVIDER":
      return { ...t, providerIds: n.data };
    case "SET_VERTICAL":
      return { ...t, verticalIds: n.data };
    case "SET":
      return n;
    default:
      return t;
  }
}, wi = () => Ye.useRef({}), En = Ye.forwardRef((t, e) => {
  var w;
  const {
    initialFilters: r = it,
    onChange: n,
    onClose: a,
    searchFilter: o,
    showOnlyReadSegementsAlways: l
  } = t, [i, c] = Ye.useReducer(yi, r), [m, y] = Ye.useState((w = ur[0]) == null ? void 0 : w.value), p = () => {
    c({ type: "SET", payload: it });
  }, f = (S) => {
    c({
      type: S,
      payload: {
        data: {}
      }
    });
  }, I = (S) => {
    c({
      type: "SET",
      payload: S
    });
  };
  Ye.useEffect(() => {
    o.length || _t.forEach(
      (S) => f(Ra[S])
    );
  }, [o]), ha(e, () => ({
    clearFilters: p,
    removeFilter: f,
    setFilter: I
  }));
  const b = Ye.useMemo(
    () => ds(r, i),
    [r, i]
  );
  return /* @__PURE__ */ s.jsx(
    us,
    {
      footer: /* @__PURE__ */ s.jsxs(
        R,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            padding: 12,
            gap: 12,
            borderTop: 1,
            width: 100
          },
          children: [
            /* @__PURE__ */ s.jsx(
              We,
              {
                color: "secondary",
                onClick: (S) => {
                  S.stopPropagation(), S.preventDefault(), a({ reason: "cancel" });
                },
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ s.jsx(
              We,
              {
                onClick: (S) => {
                  S.stopPropagation(), S.preventDefault(), n(i), a({ reason: "close" });
                },
                disabled: b,
                children: "Apply"
              }
            )
          ]
        }
      ),
      children: /* @__PURE__ */ s.jsx(
        ps,
        {
          sidebarVariant: "permanent",
          sidebarAnchor: "left",
          defaultSidebarWidth: 100,
          hideResizerHandle: !0,
          classes: {
            content: je({
              maxWidth: 100
            })
          },
          sidebar: /* @__PURE__ */ s.jsx(
            hi,
            {
              activeTab: m,
              setActiveTab: y,
              filters: i,
              search: o,
              showOnlyReadSegementsAlways: l
            }
          ),
          children: /* @__PURE__ */ s.jsx(
            gi,
            {
              activeTab: m,
              filters: i,
              dispatch: c
            }
          )
        }
      )
    }
  );
});
En.displayName = "FilterLayout";
const vi = "_SelectAdvancePopper_1rjkr_1", xi = {
  SelectAdvancePopper: vi
}, Ii = (t) => {
  const { popupState: e, filterRef: r, ...n } = t;
  return /* @__PURE__ */ s.jsx(
    nr,
    {
      ...St(e),
      placement: "bottom-end",
      slotProps: {
        root: {
          classes: {
            root: xi.SelectAdvancePopper
          }
        }
      },
      children: /* @__PURE__ */ s.jsx(En, { ...n, ref: r })
    }
  );
}, bi = Oe.DefaultListOptionItemWrapper({
  arrowPosition: "right",
  disableCheckbox: !0
}), Si = (t) => {
  const { onChange: e, sorting: r, popupState: n, onClose: a } = t;
  return (
    /* @ts-ignore */
    /* @__PURE__ */ s.jsx(
      Wr,
      {
        ...St(n),
        placement: "bottom-end",
        size: "medium",
        data: Pr,
        rowCount: Pr.length ?? 2,
        renderListItem: bi,
        multiple: !1,
        loading: !1,
        hideSearch: !0,
        value: r,
        renderOption: ({ row: o }) => Ri(o),
        getRowId: (o) => `${o.value}`,
        getOptionLabel: (o) => o.value,
        onChange: (o) => {
          const l = typeof o == "function" ? o(r) : o;
          e(l), a();
        },
        allowClearingSingleSelect: !0,
        style: { maxWidth: "auto", width: 150 }
      }
    )
  );
}, Ri = (t) => /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
  t.original.icon,
  " ",
  /* @__PURE__ */ s.jsx(A, { children: t.original.label })
] }), ji = (t) => {
  const { filters: e, onChangeFilter: r } = t;
  return ur.reduce(
    (a, o) => {
      if (e) {
        const l = e[o.filterKey], i = Object.values(l).length;
        if (i > 0)
          return [...a, { ...o, count: i }];
      }
      return a;
    },
    []
  ).map((a) => /* @__PURE__ */ s.jsx(
    Ve,
    {
      variant: "filled",
      size: "small",
      color: "secondary",
      onDelete: () => {
        const o = {
          ...e,
          [a.filterKey]: {}
        };
        r == null || r(o);
      },
      label: /* @__PURE__ */ s.jsxs(A, { weight: "normal", children: [
        a.label,
        " (",
        a.count,
        ")"
      ] })
    },
    a.filterKey
  ));
}, Ai = (t) => {
  if (t) {
    const e = Object.values(t);
    for (let r = 0; r < e.length; r++) {
      const n = e[r] ?? {};
      if (Object.values(n).length > 0)
        return !0;
    }
    return !1;
  }
  return !1;
}, Li = (t) => t ? Object.values(t).reduce((r, n) => (r += Object.values(n).length, r), 0) : 0, Pi = (t) => {
  const {
    searchFilter: e,
    rowSelection: r,
    filters: n,
    sorting: a,
    onChangeFilter: o,
    onChangeSorting: l,
    searchSegmentCount: i,
    parentPopupState: c,
    showOnlyReadSegementsAlways: m
  } = t, y = u.useMemo(
    () => Object.keys(r).length,
    [r]
  ), p = Ai(n), f = u.useMemo(
    () => Object.values(a ?? {}).length > 0,
    [a]
  ), I = wi(), b = ht({
    variant: "popper",
    popupId: "segment-filter-popover",
    parentPopupState: c
  }), w = ht({
    variant: "popper",
    popupId: "segment-sorting-popover",
    parentPopupState: c
  }), S = kt(b), N = kt(w), k = S.onClick, T = N.onClick;
  S.onClick = (z) => {
    w.close(), k(z);
  }, N.onClick = (z) => {
    b.close(), T(z);
  }, u.useLayoutEffect(() => {
    if (e.length === 0) {
      w.close();
      const z = _t.reduce(
        (W, V) => ({ ...W, [V]: it[V] }),
        {}
      );
      o((W) => ({ ...W, ...z }));
    }
  }, [e]);
  const G = y === 1 ? `${y} segment selected` : `${y} segments selected`, F = e.length > 0 && (i ?? 0) > 0, X = (i ?? 0) > 1 ? `${i} results found` : i === 1 ? `${i} result found` : "";
  return /* @__PURE__ */ s.jsxs(R, { sx: { p: 16, display: "flex", alignItems: "center", gap: 8 }, children: [
    /* @__PURE__ */ s.jsx(A, { component: "span", variant: "bodySmall", gutterBottom: !1, children: G }),
    F ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        A,
        {
          sx: {
            textColor: "neutral-400"
          },
          children: "•"
        }
      ),
      X
    ] }) : null,
    /* @__PURE__ */ s.jsxs(R, { sx: { marginLeft: "auto", display: "flex", gap: 8 }, children: [
      p || f ? /* @__PURE__ */ s.jsx(
        Fe,
        {
          size: "small",
          onClick: () => {
            l({}), o(it);
          },
          children: /* @__PURE__ */ s.jsx(qs, {})
        }
      ) : null,
      /* @__PURE__ */ s.jsx(
        ji,
        {
          filters: n,
          onChangeFilter: (z) => {
            o(z), b.close();
          }
        }
      ),
      e.length > 0 ? /* @__PURE__ */ s.jsx(
        yt,
        {
          onClickAway: () => {
            w.isOpen && w.close();
          },
          children: /* @__PURE__ */ s.jsx(
            ot,
            {
              size: "small",
              color: "secondary",
              badgeContent: Object.values(a).length ?? 0,
              children: /* @__PURE__ */ s.jsx(
                Fe,
                {
                  ...N,
                  color: "secondary",
                  size: "small",
                  selected: w.isOpen,
                  children: /* @__PURE__ */ s.jsx(Hs, {})
                }
              )
            }
          )
        }
      ) : null,
      /* @__PURE__ */ s.jsx(
        yt,
        {
          onClickAway: () => {
            b.close();
          },
          children: /* @__PURE__ */ s.jsxs(R, { children: [
            /* @__PURE__ */ s.jsx(
              ot,
              {
                size: "small",
                color: "secondary",
                badgeContent: Li(n),
                children: /* @__PURE__ */ s.jsx(
                  Fe,
                  {
                    ...S,
                    color: "secondary",
                    size: "small",
                    selected: b.isOpen,
                    children: /* @__PURE__ */ s.jsx(Ys, {})
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx(
              Ii,
              {
                popupState: b,
                filterRef: I,
                initialFilters: n,
                onChange: (z) => {
                  o(z);
                },
                onClose: b.close,
                searchFilter: e,
                showOnlyReadSegementsAlways: m
              }
            )
          ] })
        }
      ),
      /* @__PURE__ */ s.jsx(
        Si,
        {
          popupState: w,
          onChange: l,
          sorting: a,
          onClose: w.close
        }
      )
    ] })
  ] });
}, _r = 50, Tr = 10, Ci = u.forwardRef((t, e) => {
  var x, L, q, J, ce, O;
  const {
    initialData: r,
    onChange: n,
    inputStartAdornment: a,
    maxSelectCount: o,
    maxSelectCountTooltip: l = "Maximum limit of {{maxSelectCount}} segments in one segment group is reached",
    selectedPartnerId: i,
    showOnlyNonZeroSegments: c = !1,
    showOnlyReadSegementsAlways: m = !1,
    showDownloadSearchSegementsCTA: y = !0,
    ...p
  } = t, f = Oe.useSelectAdvanceApiRef(), [I, b] = u.useState([]), w = u.useRef(I);
  w.current = I;
  const [S, N] = u.useState(
    Mo(r)
  ), k = u.useRef(S);
  k.current = S;
  const T = u.useRef(
    new Map(Object.entries(r ?? {}))
  ), [G, F] = u.useState(void 0), [X, z] = u.useState({}), [W, V] = u.useState([]), C = u.useRef(W), [H, oe] = u.useState(""), [re, Q] = u.useState({}), [ie, xe] = u.useState(it), ne = u.useRef(
    /* @__PURE__ */ new Map()
  );
  C.current = W;
  const D = ht({
    variant: "popper",
    popupId: "segmentAudienceSelection"
  });
  u.useEffect(() => {
    D.isOpen || (V([]), oe(""), xe(it), Q({}));
  }, [D.isOpen]);
  const M = u.useMemo(
    () => {
      var g, P;
      return i || T.current.size && ((P = (g = Array.from(T.current.values())) == null ? void 0 : g[0]) == null ? void 0 : P.partnerId) || null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S, i]
  ), he = (g) => {
    T.current.delete(g);
    const P = { ...S };
    delete P[g], N(P), typeof n == "function" && n(
      Object.fromEntries(T.current.entries()),
      "apiAction"
    );
  }, pe = (g) => {
    try {
      const P = f.current.tableInstance.getRow(g);
      P && (T.current.set(P.id, P.original), N({ ...S, [P.id]: !0 }), typeof n == "function" && n(
        Object.fromEntries(T.current.entries()),
        "apiAction"
      ));
    } catch (P) {
      console.log(P), console.log("cannot add row that is not part of current dataset");
    }
  }, Ie = (g) => {
    const P = {};
    T.current.clear();
    for (const [U, K] of Object.entries(g))
      P[U] = !0, T.current.set(U, K);
    N(P), typeof n == "function" && n(
      Object.fromEntries(T.current.entries()),
      "apiAction"
    );
  };
  u.useImperativeHandle(e, () => ({
    getRowSelection: () => k.current,
    getRowSelectionData: () => T.current,
    getCurrentData: () => w.current,
    removeSelection: he,
    setSelection: pe,
    reinitializeRowSelection: Ie,
    getSegmentCache: () => ne.current,
    clearSegmentCache: () => ne.current.clear(),
    setSearch: V
  }));
  const Y = Fi({
    providerIds: ie.providerIds,
    verticalIds: ie.verticalIds
  }), h = zi({
    params: {
      searchField: W,
      pageSize: _r,
      sortBy: An(re),
      ...jn(
        ie,
        M,
        m
      ),
      showOnlyNonZeroSegments: c
    },
    enabled: !!W.length
  });
  u.useEffect(() => {
    var g, P, U, K, $, me, ye, we, Ee, se;
    if (f.current.tableInstance.resetExpanded(), W.length)
      (P = (g = h.data) == null ? void 0 : g.pages) != null && P.length && !(($ = (K = (U = h.data) == null ? void 0 : U.pages) == null ? void 0 : K[0]) != null && $.filteredRecords) && !h.isInitialLoading && !h.isError ? F("noResult") : !((we = (ye = (me = h.data) == null ? void 0 : me.pages) == null ? void 0 : ye[0]) != null && we.filteredRecords) && !h.isInitialLoading && !h.isError ? F(void 0) : h.data ? (F(void 0), b(
        ((Ee = h.data) == null ? void 0 : Ee.pages.map((Ne) => Ne.data).flat()) || []
      )) : h.isError ? F("error") : h.isInitialLoading && (F(void 0), b([]));
    else {
      const Ne = ((se = Y.data) == null ? void 0 : se.data) ?? [];
      Ne.length <= 0 && Y.isLoading === !1 && !Y.isError ? F("noRows") : Y.data ? (F(void 0), b(Ne)) : Y.isError && F("error");
    }
  }, [
    Y.isLoading,
    Y.data,
    Y.isError,
    h.isLoading,
    h.isFetching,
    h.data,
    h.isInitialLoading,
    h.isError,
    W,
    f,
    F,
    b
  ]);
  const B = async ({
    row: g,
    insertNestedData: P
  }) => {
    var U, K;
    z(($) => ({ ...$, [g.id]: !0 }));
    try {
      let $ = [];
      if (ne.current.has(g.original.preservedValue))
        $ = ne.current.get(
          g.original.preservedValue
        );
      else {
        const ye = g.original.type === "provider" ? g.original.id : (K = (U = g.getParentRows().find((se) => se.original.type === "provider")) == null ? void 0 : U.original) == null ? void 0 : K.id;
        if (!ye)
          throw "No provider ID available";
        const we = g.getParentRows().find((se) => se.original.type === "partner");
        $ = await ki({
          parentId: g.original.type !== "provider" ? g.original.id : void 0,
          partnerId: g.original.partnerId,
          providerId: ye,
          partner: (we == null ? void 0 : we.original) || g.original,
          showOnlyNonZeroSegments: c,
          showOnlyReadySegments: m
        }) || [], ne.current.set(g.original.preservedValue, $);
      }
      const me = [...g.getParentRows(), g].map((ye) => ye.id);
      b((ye) => P({
        existingRows: ye ?? [],
        subRowsToInsert: $,
        path: me,
        getRowId: (we) => we.value,
        subRowKey: "subRows"
      }));
    } catch ($) {
      console.log($);
    }
    z(($) => {
      const me = { ...$ };
      return delete me[g.id], me;
    });
  }, te = () => {
    const g = T.current.entries(), P = f.current.tableInstance.getRowModel().rowsById, U = {};
    for (const K of g) {
      const [$, me] = K;
      P[$] && (U[$] = me);
    }
    return U;
  }, le = (g) => {
    var Ee;
    const P = typeof g == "function" ? g(S) : g, U = Object.keys(P), K = te(), $ = Object.keys(K), me = f.current.tableInstance.getRowModel().rowsById, ye = U.filter(
      (se) => K[se] === void 0
    ), we = $.filter(
      (se) => P[se] === void 0
    );
    for (const se of ye)
      (Ee = me[se]) != null && Ee.original && T.current.set(se, me[se].original);
    for (const se of we)
      T.current.delete(se);
    N(g), typeof n == "function" && n(
      Object.fromEntries(T.current.entries()),
      "userAction"
    );
  }, j = u.useRef(S);
  u.useEffect(() => {
    var P, U, K;
    let g = null;
    if (Object.values(j.current).length + 1 === Object.values(S).length && (g = Object.keys(S).filter(
      ($) => !j.current[$]
    )[0] || null), M) {
      const $ = (K = (U = (P = f.current) == null ? void 0 : P.tableInstance) == null ? void 0 : U.getExpandedRowModel()) == null ? void 0 : K.rowsById;
      $ && (f.current.tableInstance.setExpanded((me) => Object.entries(me).reduce(
        (we, Ee) => $[Ee[0]] && $[Ee[0]].original.partnerId === M ? { ...we, [Ee[0]]: !0 } : we,
        {}
      )), g && f.current.virtualizer.getVirtualItems);
    }
  }, [M]), u.useEffect(() => {
    j.current = S;
  }, [S]), u.useEffect(() => {
    W.length || Q({});
  }, [W]);
  const _ = u.useMemo(
    () => Object.keys(S || {}).length,
    [S]
  );
  return /* @__PURE__ */ s.jsx(
    yt,
    {
      onClickAway: () => {
        D.close();
      },
      children: /* @__PURE__ */ s.jsxs(R, { sx: { width: 100, maxWidth: 100 }, ...fs(D), children: [
        /* @__PURE__ */ s.jsx(
          gs,
          {
            value: W,
            inputValue: H,
            onChange: (g, P) => {
              const U = [], K = P.map(($) => $.trim()).filter(Boolean).filter(($) => U.indexOf($) >= 0 ? !1 : (U.push($), !0)).slice(0, Tr);
              V(K), oe("");
            },
            onInputChange: (g) => {
              var P;
              oe((P = g.target) == null ? void 0 : P.value);
            },
            limitTags: -1,
            splitCharacter: ",",
            onPaste: (g) => {
              const U = g.clipboardData.getData("text").trim().split(",").map((K) => K.trim()).filter(Boolean).slice(0, Math.max(Tr - W.length, 0));
              V((K) => {
                const $ = [...K, ...U], me = [];
                return $.filter((we) => me.indexOf(we) >= 0 ? !1 : (me.push(we), !0));
              });
            },
            placeholder: W.length ? void 0 : "Search comma separated segments or browse to add",
            InputProps: {
              startAdornment: /* @__PURE__ */ s.jsxs(
                R,
                {
                  sx: { display: "flex", alignItems: "center", flexShrink: 0 },
                  children: [
                    /* @__PURE__ */ s.jsx(
                      Gr,
                      {
                        fontSize: 24,
                        sx: { textColor: "neutral-400", my: 4 }
                      }
                    ),
                    a || null
                  ]
                }
              ),
              endAdornment: !!W.length && /* @__PURE__ */ s.jsxs(
                R,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center"
                  },
                  onFocus: (g) => {
                    g.stopPropagation(), g.preventDefault();
                  },
                  children: [
                    y ? /* @__PURE__ */ s.jsx(
                      ei,
                      {
                        search: W,
                        sortBy: re,
                        sx: { mr: 8 },
                        filters: ie,
                        selectedPartnerId: M,
                        showOnlyNonZeroSegments: c,
                        showOnlyReadSegementsAlways: m
                      }
                    ) : null,
                    /* @__PURE__ */ s.jsx(
                      Fe,
                      {
                        size: "small",
                        color: "secondary",
                        disableFocusRipple: !0,
                        borderRadius: "circle",
                        sx: { padding: 0 },
                        style: { marginTop: -1 },
                        onClick: () => {
                          V([]);
                        },
                        children: /* @__PURE__ */ s.jsx(ir, {})
                      }
                    )
                  ]
                }
              ),
              sx: {
                alignItems: "center"
              }
            },
            renderTags: (g, P) => g.map((U, K) => /* @__PURE__ */ ya(
              Ve,
              {
                ...P({ index: K }),
                color: "secondary",
                key: K,
                label: U,
                clickable: !0,
                size: "small"
              }
            )),
            sx: { width: 100, maxWidth: 100, alignItems: "center" }
          }
        ),
        /* @__PURE__ */ s.jsx(
          Wr,
          {
            ...p,
            size: "small",
            data: h.isInitialLoading || Y.isInitialLoading ? [] : I ?? [],
            apiRef: f,
            rowCount: W.length > 0 ? ((q = (L = (x = h.data) == null ? void 0 : x.pages) == null ? void 0 : L[0]) == null ? void 0 : q.filteredRecords) || 5 : I.length ?? 5,
            multiple: !0,
            hideSearch: !0,
            loading: W.length ? h.isInitialLoading || h.isLoading || h.isFetchingNextPage : Y.isLoading,
            hideSelectNav: !0,
            pageSize: W.length ? void 0 : _r,
            onFetchRows: W.length && !h.isFetchingNextPage && !h.error ? () => {
              setTimeout(() => {
                C.current.length && h.fetchNextPage();
              }, 0);
            } : void 0,
            renderContentTop: /* @__PURE__ */ s.jsx(
              Pi,
              {
                searchFilter: W,
                rowSelection: S,
                filters: ie,
                sorting: re,
                onChangeFilter: (g) => xe(g),
                onChangeSorting: (g) => Q(g),
                searchSegmentCount: (ce = (J = h == null ? void 0 : h.data) == null ? void 0 : J.pages[0]) == null ? void 0 : ce.filteredRecords,
                parentPopupState: D,
                showOnlyReadSegementsAlways: m
              }
            ),
            overlay: G,
            renderListItem: Jo,
            renderListItemSkeleton: () => /* @__PURE__ */ s.jsx(
              R,
              {
                sx: { py: 8, px: 12 },
                style: { width: "100%", height: "fit-content" },
                children: /* @__PURE__ */ s.jsx(Ze, { height: 32 })
              }
            ),
            onFetchSubRows: B,
            enableSubRowSelection: !1,
            getSubRows: (g) => {
              var P;
              return (((P = g.subRows) == null ? void 0 : P.length) ?? 0) > 0 ? g.subRows : void 0;
            },
            getRowCanExpand: (g) => {
              var P;
              return !(((P = g.original) == null ? void 0 : P.isLeaf) ?? !1);
            },
            getOptionDisabled: p.getOptionDisabled || ((g) => !!M && M !== g.partnerId || g.type === "noResultsLeaf" || g.type === "segment" && !!o && _ >= o && !S[g.value]),
            disabledItemsFocusable: !0,
            renderOption: (g) => Xo({
              rowObject: g,
              search: W,
              filters: ie,
              selectedPartnerId: M,
              maxSelectCountTooltip: l,
              isMaxSelection: !!o && _ >= o,
              maxSelectCount: o,
              rowSelection: S
            }),
            isRowLoading: X,
            value: S,
            onChange: le,
            slotProps: {
              ...p.slotProps,
              PaperProps: {
                sx: { width: 100, maxWidth: 100 },
                ...(O = p.slotProps) == null ? void 0 : O.PaperProps
              }
            },
            ...St(D)
          }
        )
      ] })
    }
  );
});
Ci.displayName = "SegmentSelect";
let Nr;
const Ei = async ({
  queryKey: t
}) => {
  var e;
  try {
    const { verticalIds: r, providerIds: n } = t[0] || {}, a = Nr || await ve().get("/v3/audience/segment/partner-provider/list");
    Nr = a;
    const { totalRecords: o, filteredRecords: l, partnerProviderList: i } = a.data.data;
    return {
      totalRecords: o,
      filteredRecords: l,
      data: qo(
        Pn(i),
        r ?? {},
        n ?? {}
      )
    };
  } catch (r) {
    return Promise.reject((e = r == null ? void 0 : r.response) == null ? void 0 : e.data);
  }
}, Oi = async ({
  queryKey: t,
  pageParam: e = 1
}) => {
  var r;
  try {
    const {
      sortBy: n,
      searchField: a,
      pageSize: o,
      // avability Id
      showOnlyReadySegments: l,
      showOnlyNonZeroSegments: i,
      reachRangeIds: c,
      verticalIds: m,
      priceRangeIds: y,
      providerIds: p,
      partnerIds: f
    } = t[0] || {}, I = await ve().get("/v3/audience/segment/search/list", {
      params: {
        sortBy: n,
        searchField: encodeURIComponent((a == null ? void 0 : a.join(",")) ?? ""),
        noOfEntries: o,
        pageNo: e,
        // avability Id
        showOnlyReadySegments: l,
        showOnlyNonZeroSegments: i,
        reachRangeIds: c,
        verticalIds: m,
        priceRangeIds: y,
        providerIds: p,
        partnerIds: f
      }
    }), { filteredRecords: b, segmentsList: w } = I.data.data;
    return {
      filteredRecords: b,
      data: Ko(w)
    };
  } catch (n) {
    return Promise.reject((r = n == null ? void 0 : n.response) == null ? void 0 : r.data);
  }
}, ki = async (t) => {
  var n;
  const { partner: e, ...r } = t;
  try {
    const a = await ve().get("/v3/audience/segment/list-by-parent-id", {
      params: r
    });
    return Wo(a.data.data || [], e);
  } catch (a) {
    return Promise.reject(((n = a == null ? void 0 : a.response) == null ? void 0 : n.data) || a);
  }
}, Di = async (t) => {
  var e;
  try {
    return (await ve().get("/v3/audience/segment/search/list-download", {
      params: t
    })).data;
  } catch (r) {
    return Promise.reject((e = r == null ? void 0 : r.response) == null ? void 0 : e.data);
  }
}, _i = async () => {
  var t;
  try {
    const e = await ve().get("/v3/audience/segment/partner-provider/list"), { totalRecords: r, filteredRecords: n, partnerProviderList: a } = e.data.data;
    return {
      totalRecords: r,
      filteredRecords: n,
      partnerProviderList: Pn(
        a,
        void 0,
        (o) => `${o.providerId}`
      )
    };
  } catch (e) {
    return Promise.reject(((t = e == null ? void 0 : e.response) == null ? void 0 : t.data) || e);
  }
}, Ti = async () => {
  var t;
  try {
    return (await ve().get("/v3/audience/static/segment/price-range")).data.data;
  } catch (e) {
    return Promise.reject(((t = e == null ? void 0 : e.response) == null ? void 0 : t.data) || e);
  }
}, Ni = async () => {
  var t;
  try {
    return (await ve().get("/v3/audience/static/segment/reach-range")).data.data;
  } catch (e) {
    return Promise.reject(((t = e == null ? void 0 : e.response) == null ? void 0 : t.data) || e);
  }
}, Ui = async () => {
  var t;
  try {
    return (await ve().get("/v3/ua/static/verticals")).data.data;
  } catch (e) {
    return Promise.reject(((t = e == null ? void 0 : e.response) == null ? void 0 : t.data) || e);
  }
}, On = (t) => {
  var e, r, n;
  (n = qe) == null || n(
    ((r = (e = t == null ? void 0 : t.errorObjects) == null ? void 0 : e[0]) == null ? void 0 : r.error) || "Something went wrong!",
    {
      variant: "error"
    }
  );
}, Fi = (t) => {
  const { providerIds: e, verticalIds: r } = t || {};
  return ke({
    queryKey: Ma.keys({
      scope: "getSegmentedPartnerAndProviderList",
      providerIds: e,
      verticalIds: r
    }),
    queryFn: Ei,
    onError: On
  });
}, Bi = () => ke({
  queryKey: Wa.keys({
    scope: "getSegmentedPartnerProviderFilterList"
  }),
  queryFn: _i,
  cacheTime: 1 / 0,
  staleTime: 1 / 0
}), zi = (t) => {
  const { params: e, enabled: r = !0 } = t;
  return jt({
    queryKey: $a.keys({
      ...e,
      scope: "getSegmentsBySearchKeyword"
    }),
    queryFn: Oi,
    getNextPageParam: (a, o) => {
      if (o.reduce((i, c) => {
        var m;
        return i += ((m = c == null ? void 0 : c.data) == null ? void 0 : m.length) ?? 0, i;
      }, 0) < ((a == null ? void 0 : a.filteredRecords) ?? -1))
        return o.length + 1;
    },
    onError: On,
    enabled: r
  });
}, Mi = () => ke({
  queryKey: Va.keys({
    scope: "getSegmentedPriceFilterList"
  }),
  queryFn: Ti,
  staleTime: 1 / 0
}), $i = () => ke({
  queryKey: Ka.keys({
    scope: "getSegmentedReachFilterList"
  }),
  queryFn: Ni,
  staleTime: 1 / 0
}), Wi = () => ke({
  queryKey: [{ scope: "segmentedAvailabilityFilterList" }],
  queryFn: async () => [
    {
      displayName: "All Segments",
      id: xt.ALL,
      order: "1"
    },
    {
      displayName: "Show Only Ready",
      id: xt.READY_ONLY,
      order: "2"
    }
  ],
  staleTime: 1 / 0
}), Vi = () => ke({
  queryKey: qa.keys({
    scope: "getSegmentedVerticalFilterList"
  }),
  queryFn: Ui,
  staleTime: 1 / 0
}), Ki = "https://www3.doubleclick.net", ld = () => {
  const [t, e] = u.useState(!1), [r, n] = u.useState(!0), a = async () => {
    try {
      await fetch(Ki, {
        method: "HEAD",
        mode: "no-cors",
        cache: "no-store"
      }), e(!1);
    } catch {
      e(!0);
    } finally {
      n(!1);
    }
  };
  return u.useEffect(() => {
    a();
  }, []), {
    isLoading: r,
    isAdblockerEnabled: t
  };
}, qi = Oe.DefaultListOptionItemWrapper(
  {
    disableCheckbox: !0,
    selectionStyle: "none"
  }
), Hi = (t, e, r) => {
  if (t.original.isProvider)
    return /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ s.jsx(R, { sx: { pr: 8, py: 8 }, children: /* @__PURE__ */ s.jsx(
        ze,
        {
          size: 32,
          variant: "square",
          src: t.original.providerLogoUrl,
          alt: t.original.providerName,
          imgProps: {
            style: { objectFit: "cover" }
          }
        }
      ) }),
      /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", flexDirection: "column" }, children: [
        /* @__PURE__ */ s.jsx(A, { children: t.original.label }),
        /* @__PURE__ */ s.jsx(A, { variant: "label", sx: { textColor: "neutral-500" }, children: t.original.description })
      ] })
    ] });
  const n = Array.isArray(t.subRows) ? t.subRows.some((o) => o.original.isLeaf === !0) : !1, a = Array.isArray(t.subRows) ? t.subRows.every((o) => o.original.isAllCreativeType === !0) : !1;
  if (n) {
    const o = Math.max(...t.original.subRows.map((c) => c.cpm)), l = t.getIsSomeSelected() || t.getIsAllSubRowsSelected(), i = o === 0;
    return /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
      /* @__PURE__ */ s.jsx(A, { children: t.original.label }),
      /* @__PURE__ */ s.jsx(
        Ve,
        {
          label: /* @__PURE__ */ s.jsx(A, { weight: "normal", children: `${o.toFixed(
            2
          )} (CPM)` }),
          color: "secondary",
          icon: /* @__PURE__ */ s.jsx(Ft, {}),
          size: "small"
        }
      ),
      e && l && a === !1 && /* @__PURE__ */ s.jsx(Te, { title: r, placement: "top", arrow: !0, children: /* @__PURE__ */ s.jsx(Gs, { color: "warning", fontSize: 24 }) }),
      /* @__PURE__ */ s.jsx(
        Te,
        {
          title: i ? `DV ${t.original.label} segments are free for all campaigns, except IAS-targeted ones. IAS Segments can be selected after removing any existing DV Segments.` : "This signifies the total cost of the segments within this specific category",
          placement: "top",
          arrow: !0,
          children: /* @__PURE__ */ s.jsx(Js, { fontSize: 20, sx: { textColor: "neutral-400" } })
        }
      )
    ] });
  }
  return /* @__PURE__ */ s.jsx("span", { children: t.original.label });
}, Yi = "Only one creative type (Display or Video) is supported per campaign; So, avoid grouping respective pre-bid segments in one audience.", Gi = u.forwardRef((t, e) => {
  var pe, Ie, Y;
  const { onChange: r, warningText: n = Yi, ...a } = t;
  let { initialData: o } = t;
  const l = Oe.useSelectAdvanceApiRef(), [i, c] = u.useState([]), m = u.useRef(i);
  m.current = i;
  const [y, p] = u.useState(
    Aa(o)
  ), f = u.useRef(y);
  f.current = y;
  const I = u.useRef(
    new Map(
      Object.entries(o ?? {})
    )
  ), [b, w] = u.useState(void 0), [S, N] = u.useState({}), [k, T] = u.useState(""), G = Rt(k, 250), F = u.useRef(/* @__PURE__ */ new Map()), X = (h) => {
    I.current.delete(h);
    const B = { ...y };
    delete B[h], p(B), typeof r == "function" && r(
      Object.fromEntries(I.current.entries()),
      "apiAction"
    );
  }, z = (h) => {
    try {
      const B = l.current.tableInstance.getRow(h);
      B && (I.current.set(B.id, B.original), p({ ...y, [B.id]: !0 }), typeof r == "function" && r(
        Object.fromEntries(I.current.entries()),
        "apiAction"
      ));
    } catch (B) {
      console.log(B), console.log("cannot add row that is not part of current dataset");
    }
  }, W = (h) => {
    o = h;
    const B = {};
    I.current.clear();
    for (const [te, le] of Object.entries(h))
      B[te] = !0, I.current.set(te, le);
    p(B), typeof r == "function" && r(
      Object.fromEntries(I.current.entries()),
      "apiAction"
    );
  }, V = u.useMemo(
    () => {
      var h, B;
      return Object.keys(y).length > 0 ? (B = (h = Array.from(I.current.values())) == null ? void 0 : h[0]) == null ? void 0 : B.providerId : null;
    },
    [y]
  );
  u.useImperativeHandle(e, () => ({
    getRowSelection: () => f.current,
    getRowSelectionData: () => I.current,
    getCurrentData: () => m.current,
    removeSelection: X,
    setSelection: z,
    reinitializeRowSelection: W,
    getSegmentCache: () => F.current,
    clearSegmentCache: () => F.current.clear(),
    setSearch: T,
    getSelectedProviderId: () => V ?? null
  }));
  const C = u.useMemo(() => {
    var h;
    if (Object.keys(y).length > 0) {
      const B = Array.from(
        I.current.values()
      ).filter((le) => !le.isAllCreativeType);
      if (B.length === 0)
        return !1;
      const te = (h = B[0]) == null ? void 0 : h.creativeTypeIdSerialized;
      for (const le of B)
        if (le.creativeTypeIdSerialized !== te)
          return !0;
    }
    return !1;
  }, [y]), H = Ga(), oe = u.useMemo(() => H.isSuccess ? H.data.prebidSegmentData.reduce(
    (h, B) => (h[B.providerId] = {
      providerId: B.providerId,
      providerLogoUrl: B.providerLogoUrl,
      providerName: B.providerName,
      description: B.description
    }, h),
    {}
  ) : {}, [H.isSuccess, H.data]), re = Ja(G, {
    enabled: !!G && Object.keys(oe).length >= 1,
    meta: oe
  });
  u.useEffect(() => {
    var h, B, te, le;
    G ? (l.current.tableInstance.setExpanded(!0), (((te = re.data) == null ? void 0 : te.prebidSegmentData) ?? []).length <= 0 && re.isLoading === !1 ? w("noResult") : w(void 0), c(((le = re.data) == null ? void 0 : le.prebidSegmentData) ?? [])) : (l.current.tableInstance.resetExpanded(), (((h = H.data) == null ? void 0 : h.prebidSegmentData) ?? []).length <= 0 && H.isLoading === !1 ? w("noRows") : w(void 0), c(((B = H.data) == null ? void 0 : B.prebidSegmentData) ?? []));
  }, [
    H.isLoading,
    re.isLoading,
    (pe = H.data) == null ? void 0 : pe.prebidSegmentData,
    (Ie = re.data) == null ? void 0 : Ie.prebidSegmentData,
    G,
    l,
    w,
    c
  ]), u.useEffect(() => {
    V && l.current.tableInstance.getCoreRowModel().rows.forEach(
      (h) => h.original.providerId !== V ? h.toggleExpanded(!1) : null
    );
  }, [V, l]);
  const Q = async ({
    row: h,
    insertNestedData: B
  }) => {
    N((te) => ({ ...te, [h.id]: !0 }));
    try {
      let te = [];
      if (F.current.has(h.original.preservedValue))
        te = F.current.get(
          h.original.preservedValue
        );
      else {
        const j = await ka({
          prebidAudienceSegmentId: Number(h.original.preservedValue),
          providerDetails: {
            providerId: h.original.providerId,
            providerName: h.original.providerName,
            providerLogoUrl: h.original.providerLogoUrl,
            description: "",
            childSegments: []
          }
        });
        te = j.prebidSegmentData, F.current.set(
          h.original.preservedValue,
          j.prebidSegmentData
        );
      }
      const le = [...h.getParentRows(), h].map((j) => j.id);
      c((j) => B({
        existingRows: j ?? [],
        subRowsToInsert: te,
        path: le,
        getRowId: (_) => _.value,
        subRowKey: "subRows"
      }));
    } catch (te) {
      console.log(te);
    }
    N((te) => {
      const le = { ...te };
      return delete le[h.id], le;
    });
  }, ie = () => {
    const h = I.current.entries(), B = l.current.tableInstance.getRowModel().rowsById, te = {};
    for (const le of h) {
      const [j, _] = le;
      B[j] && (te[j] = _);
    }
    return te;
  }, xe = (h) => {
    var q;
    const B = typeof h == "function" ? h(y) : h, te = Object.keys(B), le = ie(), j = Object.keys(le), _ = l.current.tableInstance.getRowModel().rowsById, x = te.filter(
      (J) => le[J] === void 0
    ), L = j.filter(
      (J) => B[J] === void 0
    );
    for (const J of x)
      (q = _[J]) != null && q.original && I.current.set(J, _[J].original);
    for (const J of L)
      I.current.delete(J);
    p(h), typeof r == "function" && r(
      Object.fromEntries(I.current.entries()),
      "userAction"
    );
  }, ne = u.useMemo(
    () => Object.keys(y).length,
    [y]
  ), D = (h) => V && h.providerId !== V ? /* @__PURE__ */ s.jsx(A, { children: "Users can select segments from only one vendor within a single pre-bid audience" }) : "", M = (h) => V ? h.providerId !== V : !1, he = (h) => {
    var B;
    return V === h.original.providerId || !V ? !(((B = h.original) == null ? void 0 : B.isLeaf) ?? !1) : !1;
  };
  return (
    // @ts-ignore
    /* @__PURE__ */ s.jsx(
      ms,
      {
        size: "small",
        ...a,
        data: i ?? [],
        apiRef: l,
        rowCount: i.length ?? 5,
        inputValue: k,
        multiple: !0,
        hideSelectNav: !0,
        hideSearch: !1,
        getOptionDisabled: M,
        getOptionTooltip: D,
        loading: G ? re.isLoading : H.isLoading,
        renderContentTop: /* @__PURE__ */ s.jsxs(A, { sx: { px: 16, pt: 8, pb: 0 }, children: [
          ne,
          " Segment",
          ne > 1 ? "s" : "",
          " Selected"
        ] }),
        overlay: b,
        renderListItem: qi,
        onFetchSubRows: Q,
        enableSubRowSelection: !1,
        getSubRows: (h) => {
          var B;
          return (((B = h.subRows) == null ? void 0 : B.length) ?? 0) > 0 ? h.subRows : void 0;
        },
        getRowCanExpand: he,
        renderOption: (h) => Hi(h.row, C, n),
        isRowLoading: S,
        value: y,
        onChange: xe,
        onInputChange: (h, B, te) => {
          te !== "reset" && T(B);
        },
        slotProps: {
          ...a.slotProps,
          PaperProps: {
            style: {
              maxWidth: "576px",
              width: "calc(100% - 64px)"
            },
            ...(Y = a.slotProps) == null ? void 0 : Y.PaperProps
          }
        }
      }
    )
  );
});
Gi.displayName = "SelectPrebidSegment";
const Ji = "_icons_1c6xj_1", Qi = "_status_1c6xj_6", nt = {
  icons: Ji,
  status: Qi
}, kn = {
  11: Jr,
  13: Qs,
  14: Zs,
  15: Xs,
  17: ea
}, Ur = {
  draft: /* @__PURE__ */ s.jsx(ta, { color: "info" }),
  pending: /* @__PURE__ */ s.jsx(Xr, { color: "warning" }),
  paused: /* @__PURE__ */ s.jsx(en, { color: "warning" }),
  running: /* @__PURE__ */ s.jsx(ra, { color: "success" }),
  expired: /* @__PURE__ */ s.jsx(tn, { color: "secondary" }),
  deleted: /* @__PURE__ */ s.jsx(rn, { color: "secondary" }),
  rejected: /* @__PURE__ */ s.jsx(nn, { color: "error" }),
  failed: /* @__PURE__ */ s.jsx(na, {})
}, Zi = Oe.DefaultListOptionItemWrapper(
  {
    disableCheckbox: !0,
    disableRowExpansion: !0,
    selectionStyle: "all"
  }
), Xi = (t) => {
  if (t.original.type === "IO")
    return /* @__PURE__ */ s.jsxs(
      R,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          width: 100,
          overflow: "hidden"
        },
        children: [
          t.original.ioBudgetTypeId === 1 ? /* @__PURE__ */ s.jsx(
            Qr,
            {
              color: "primary",
              sx: { flexShrink: 0 },
              className: nt.icons
            }
          ) : /* @__PURE__ */ s.jsx(
            Zr,
            {
              color: "primary",
              sx: { flexShrink: 0 },
              className: nt.icons
            }
          ),
          /* @__PURE__ */ s.jsx(
            be,
            {
              sx: { ml: 8, mr: 4 },
              TypgraphyProps: {
                weight: "demi"
              },
              arrow: !0,
              children: t.original.label
            }
          ),
          /* @__PURE__ */ s.jsxs(
            R,
            {
              sx: { display: "flex", alignItems: "center", gap: 4, flexShrink: 0 },
              children: [
                /* @__PURE__ */ s.jsx(A, { sx: { textColor: "neutral-400" }, children: "•" }),
                /* @__PURE__ */ s.jsx(A, { variant: "label", sx: { textColor: "neutral-400" }, children: "ID" }),
                /* @__PURE__ */ s.jsx(A, { children: t.original.value })
              ]
            }
          )
        ]
      }
    );
  if (t.original.type === "Campaign") {
    const e = (
      // @ts-ignore
      kn[t.original.creativeTypeId]
    ), r = (
      // @ts-ignore
      Ur[t.original.status] ?? Ur.draft
    );
    return /* @__PURE__ */ s.jsxs(
      R,
      {
        sx: {
          display: "flex",
          alignItems: "start",
          overflow: "hidden",
          width: 100
        },
        children: [
          e ? /* @__PURE__ */ s.jsx(e, { color: "primary", className: nt.icons }) : /* @__PURE__ */ s.jsx(
            Jr,
            {
              className: nt.icons,
              sx: { visibility: "hidden" }
            }
          ),
          /* @__PURE__ */ s.jsxs(
            R,
            {
              sx: {
                display: "flex",
                flexDirection: "column",
                ml: 8,
                overflow: "hidden",
                width: 100
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  be,
                  {
                    TypgraphyProps: {
                      weight: "demi"
                    },
                    arrow: !0,
                    children: t.original.label
                  }
                ),
                /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
                  /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
                    /* @__PURE__ */ s.jsx(
                      A,
                      {
                        variant: "label",
                        weight: "demi",
                        sx: { textColor: "neutral-500" },
                        children: "ID"
                      }
                    ),
                    /* @__PURE__ */ s.jsx(A, { component: "span", variant: "label", children: t.original.value })
                  ] }),
                  /* @__PURE__ */ s.jsx(A, { sx: { textColor: "neutral-400" }, children: "•" }),
                  /* @__PURE__ */ s.jsxs(
                    R,
                    {
                      sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        fontSize: 14
                      },
                      children: [
                        r,
                        /* @__PURE__ */ s.jsx(
                          A,
                          {
                            className: nt.status,
                            variant: "label",
                            component: "span",
                            children: t.original.status
                          }
                        )
                      ]
                    }
                  )
                ] })
              ]
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ s.jsx(R, {});
}, el = u.forwardRef((t, e) => {
  var j, _;
  const {
    onChange: r,
    params: n,
    useCase: a = "basic",
    multiple: o = !1,
    prepopulate: l = !1,
    TextFieldProps: i,
    slotProps: c,
    enabled: m = !0,
    enableLocalSearch: y = !1,
    enableLazyLoading: p = !0,
    getOptionDisabled: f,
    initialData: I,
    ...b
  } = t;
  let { initialData: w } = t;
  const S = It((x, L, q) => {
    r == null || r(x, L, q);
  }), N = u.useState(0)[1], k = Oe.useSelectAdvanceApiRef(), [T, G] = u.useState(""), F = Rt(T, 250), X = u.useRef(!1), z = u.useRef(!1), [W, V] = u.useState(
    Or(w)
  ), C = u.useRef(W);
  C.current = W;
  const H = u.useRef(
    new Map(Object.entries(w ?? {}))
  ), [oe, re] = u.useState(!1), Q = u.useCallback(
    (x) => {
      G(x), re(!1);
    },
    [G]
  ), {
    data: ie,
    isLoading: xe,
    isFetching: ne,
    fetchNextPage: D
  } = lo(
    {
      ...n,
      useCase: a,
      noOfEntries: Ia,
      searchField: y ? void 0 : F,
      isSelectAll: p ? oe : !0
    },
    {
      enabled: m
    }
  ), M = u.useMemo(() => {
    var x;
    return ((x = ie == null ? void 0 : ie.pages) == null ? void 0 : x.reduce(
      (L, q) => [...L, ...q.ioCampaignsList],
      []
    )) ?? [];
  }, [ie]), he = u.useRef(M);
  he.current = M, u.useEffect(() => {
    if (oe && M.length > 0) {
      const x = {};
      H.current.clear(), M.forEach((L) => {
        var q, J;
        if ((((q = L.subRows) == null ? void 0 : q.length) ?? 0) > 0)
          (J = L.subRows) == null || J.forEach((ce) => {
            ((f == null ? void 0 : f(ce)) ?? !1) === !0 && !(w != null && w[ce.value]) || (x[ce.value] = !0, H.current.set(ce.value, ce));
          });
        else {
          if (((f == null ? void 0 : f(L)) ?? !1) === !0 && !(w != null && w[L.value]))
            return;
          x[L.value] = !0, H.current.set(L.value, L);
        }
      }), V(x), C.current = x, S(
        Object.fromEntries(H.current.entries()),
        "userAction",
        !0
      );
    }
  }, [oe, M, w, f, S]), u.useEffect(() => {
    var x, L, q;
    if (l === !1) {
      z.current = !0;
      return;
    } else if (w && X.current === !1 && z.current === !1) {
      X.current = !0, z.current = !0;
      return;
    } else if (M.length > 0 && z.current === !1) {
      for (let J = 0; J < ((M == null ? void 0 : M.length) ?? 0); J++)
        if ((((L = (x = M[J]) == null ? void 0 : x.subRows) == null ? void 0 : L.length) ?? 0) > 0) {
          const ce = (q = M[J]) == null ? void 0 : q.subRows[0];
          if (ce) {
            V({ [ce.value]: !0 }), H.current.set(ce.value, ce), S(
              Object.fromEntries(H.current.entries()),
              "prepopulate"
            ), setTimeout(() => N((O) => O + 1)), z.current = !0;
            return;
          }
        }
      S(
        Object.fromEntries(H.current.entries()),
        "prepopulate"
      ), setTimeout(() => N((J) => J + 1)), z.current = !0;
    }
  }, [
    M,
    l,
    V,
    S,
    N,
    w
  ]);
  const pe = u.useMemo(() => {
    if (!(xe || ne)) {
      if (!Array.isArray(M))
        return "error";
      if (((M == null ? void 0 : M.length) ?? 0) <= 0)
        return T ? "noResult" : "noRows";
    }
  }, [M, xe, ne, T]), Ie = () => {
    const x = H.current.entries(), L = k.current.tableInstance.getRowModel().rowsById, q = {};
    for (const J of x) {
      const [ce, O] = J;
      L[ce] && (q[ce] = O);
    }
    return q;
  }, Y = (x) => {
    var U, K;
    const L = typeof x == "function" ? x(W) : x;
    if (o === !1) {
      const $ = Object.keys(L)[0], ye = (U = k.current.tableInstance.getRowModel().rowsById[$]) == null ? void 0 : U.original;
      H.current.clear(), H.current.set($, ye), V(x), S(
        Object.fromEntries(H.current.entries()),
        "userAction"
      );
      return;
    }
    const q = Object.keys(L), J = Ie(), ce = Object.keys(J), O = k.current.tableInstance.getRowModel().rowsById, g = q.filter(
      ($) => J[$] === void 0
    ), P = ce.filter(
      ($) => L[$] === void 0
    );
    for (const $ of g)
      (K = O[$]) != null && K.original && H.current.set($, O[$].original);
    for (const $ of P)
      H.current.delete($);
    V(x), S(
      Object.fromEntries(H.current.entries()),
      "userAction"
    );
  }, h = (x) => {
    H.current.delete(x);
    const L = { ...W };
    delete L[x], V(L), S(
      Object.fromEntries(H.current.entries()),
      "apiAction"
    );
  }, B = (x) => {
    try {
      const L = k.current.tableInstance.getRow(x);
      L && (H.current.set(L.id, L.original), V({ ...W, [L.id]: !0 }), S(
        Object.fromEntries(H.current.entries()),
        "apiAction"
      ));
    } catch (L) {
      console.log(L), console.log("cannot add row that is not part of current dataset");
    }
  }, te = (x) => {
    w = x;
    const L = Or(w);
    H.current = new Map(
      Object.entries(w ?? {})
    ), V(L), C.current = L;
  }, le = (x = !0) => {
    z.current = !x, Q("");
    const L = /* @__PURE__ */ new Map(), q = {};
    for (const J of H.current.entries()) {
      const [ce, O] = J;
      ((f == null ? void 0 : f(O)) ?? !1) === !0 && (L.set(ce, O), q[ce] = !0);
    }
    V(q), C.current = q, H.current = L;
  };
  return u.useEffect(() => {
    k.current.tableInstance.setExpanded(!0);
  }, [k]), u.useImperativeHandle(e, () => ({
    getRowSelection: () => C.current,
    getRowSelectionData: () => H.current,
    getCurrentData: () => (he == null ? void 0 : he.current) ?? [],
    removeSelection: h,
    setSelection: B,
    reinitializeRowSelection: te,
    setSearch: Q,
    selectAll: () => re(!0),
    reset: le
  })), // @ts-ignore
  /* @__PURE__ */ s.jsx(
    Ke,
    {
      size: "medium",
      ...i,
      select: "advanceSelect",
      placeholder: "Select Campaign",
      SelectProps: {
        slotProps: {
          ...c,
          InputBaseProps: {
            placeholder: "Search by IO Name, IO ID, Campaign ID, Name, Status",
            ...c == null ? void 0 : c.InputBaseProps
          }
        },
        ...b,
        getOptionDisabled: f,
        data: M ?? [],
        apiRef: k,
        inputValue: T,
        multiple: o,
        loading: xe || ne,
        enableSubRowSelection: !0,
        getSubRows: (x) => {
          var L;
          return (((L = x.subRows) == null ? void 0 : L.length) ?? 0) > 0 ? x.subRows : void 0;
        },
        getRowCanExpand: (x) => {
          var L;
          return !(((L = x.original) == null ? void 0 : L.isLeaf) ?? !1);
        },
        overlay: pe,
        onInputChange: (x, L, q) => {
          q !== "reset" && Q(L);
        },
        rowCount: p === !0 ? (((_ = (j = ie == null ? void 0 : ie.pages) == null ? void 0 : j[0]) == null ? void 0 : _.filteredRecords) ?? 1) - 1 : (M == null ? void 0 : M.length) ?? 5,
        onFetchRows: () => D(),
        renderValue: () => {
          const x = Object.keys(C.current);
          if (o)
            return x.length ? `${x.length} Selected` : "​";
          {
            const L = x[0] ?? "", q = H.current.get(L), J = (
              // @ts-ignore
              kn[q.creativeTypeId]
            );
            return /* @__PURE__ */ s.jsxs(
              R,
              {
                Component: "span",
                sx: { display: "flex", gap: 4, overflow: "hidden" },
                children: [
                  /* @__PURE__ */ s.jsx(R, { Component: "span", sx: { display: "flex", flexShrink: 0 }, children: J ? /* @__PURE__ */ s.jsx(J, { color: "primary", className: nt.icons }) : null }),
                  /* @__PURE__ */ s.jsx(
                    be,
                    {
                      TypgraphyProps: {
                        component: "span"
                      },
                      children: (q == null ? void 0 : q.label) ?? "​"
                    }
                  )
                ]
              }
            );
          }
        },
        renderListItem: Zi,
        renderOption: ({ row: x }) => Xi(x),
        onSelectAll: (x) => {
          x && re(!0);
        },
        onClearAll: () => {
          setTimeout(() => {
            const x = /* @__PURE__ */ new Map(), L = {};
            for (const q of H.current.entries()) {
              const [J, ce] = q;
              ((f == null ? void 0 : f(ce)) ?? !1) === !0 && (x.set(J, ce), L[J] = !0);
            }
            V(L), C.current = L, H.current = x, S(
              Object.fromEntries(H.current.entries()),
              "userAction"
            );
          }, 0);
        }
      },
      value: W,
      onChange: Y
    }
  );
});
el.displayName = "SelectIOCampaignList";
const tl = "_root_wkzkn_1", rl = "_superUser_wkzkn_14", nl = "_workspaceUser_wkzkn_18", sl = "_advertiserUser_wkzkn_22", al = "_message_wkzkn_26", ol = "_chip_wkzkn_35", il = "_link_wkzkn_39", $e = {
  root: tl,
  superUser: rl,
  workspaceUser: nl,
  advertiserUser: sl,
  message: al,
  chip: ol,
  link: il
};
class ll {
  constructor(e) {
    ee(this, "originURLFallback");
    ee(this, "legacyMode");
    ee(this, "deploymentEnvironment");
    this.originURLFallback = e.originURLFallback, this.legacyMode = e.legacyMode, this.deploymentEnvironment = e.deploymentEnvironment;
  }
  get originURL() {
    return lr(this.originURLFallback);
  }
  get owIdHeaderKey() {
    return on;
  }
  get OwIdFromPath() {
    return this.legacyMode ? un() : pn();
  }
  get svgHostURL() {
    return this.deploymentEnvironment === "prod" ? ln : cn;
  }
}
const Dn = u.createContext(
  null
), At = () => u.useContext(Dn), cd = (t) => {
  const {
    originURLFallback: e,
    legacyMode: r = !0,
    disableRedirectWhenWorkspaceIsSuspended: n = !1
  } = t, { children: a, ...o } = t, [l, i] = u.useState(null), c = { ...o, disableRedirectWhenWorkspaceIsSuspended: n }, m = o.deploymentEnvironment;
  return u.useEffect(() => {
    const y = new ll({
      originURLFallback: e,
      legacyMode: r,
      deploymentEnvironment: m
    });
    i(y);
  }, [e, r, m]), l && /* @__PURE__ */ s.jsx(
    Dn.Provider,
    {
      value: {
        rootProps: c,
        instance: l
      },
      children: a
    }
  );
};
class tr {
  constructor(e) {
    ee(this, "userConfig");
    ee(this, "secret");
    ee(this, "initDatadog", (e, r) => {
      var n, a;
      if ((n = this == null ? void 0 : this.secret) != null && n.applicationId && ((a = this == null ? void 0 : this.secret) != null && a.clientToken)) {
        const o = {
          trackUserInteractions: !0,
          traceSampleRate: 100,
          trackViewsManually: !0,
          // allowedTracingUrls: [originURL],
          ...e,
          // cannot override these parameters
          ...this.secret,
          site: "datadoghq.com",
          service: this.userConfig.appName,
          version: this.userConfig.appVersion,
          env: this.userConfig.env
        };
        if (ct.init(o), o.trackViewsManually)
          try {
            ct.startView(window.location.pathname);
          } catch (l) {
            console.error(l);
          }
      }
    });
    ee(this, "setUser", (e) => {
      ct.setUser({
        id: `${e.owId}`,
        name: e.userName,
        email: e.userEmail,
        organization: e.organizationName,
        customer_id: `${e.owId}`,
        user_email: e.userEmail
      });
    });
    this.userConfig = e, this.secret = {
      applicationId: e.applicationId,
      clientToken: e.clientToken
    };
  }
  getDatadogInstance() {
    return ct;
  }
}
ee(tr, "onReady", (e) => {
  ct.onReady(e);
});
const _n = u.createContext(null), cl = () => u.useContext(_n);
class dl {
  constructor(e) {
    ee(this, "originURLFallback");
    ee(this, "deploymentEnvironment");
    this.originURLFallback = e.originURLFallback, this.deploymentEnvironment = e.deploymentEnvironment;
  }
  get originURL() {
    return lr(this.originURLFallback);
  }
  get iqmPlatformBasicAuth() {
    return dr;
  }
  get svgHostURL() {
    return this.deploymentEnvironment === "prod" ? ln : cn;
  }
}
const Tn = u.createContext(
  null
), Nn = () => u.useContext(Tn), dd = (t) => {
  const { originURLFallback: e, deploymentEnvironment: r } = t, { children: n, ...a } = t, [o, l] = u.useState(null), i = { ...a };
  return u.useEffect(() => {
    const c = new dl({
      originURLFallback: e,
      deploymentEnvironment: r
    });
    l(c);
  }, [e, r]), o && /* @__PURE__ */ s.jsx(
    Tn.Provider,
    {
      value: {
        rootProps: i,
        instance: o
      },
      children: n
    }
  );
}, ud = (t) => {
  var k, T, G, F, X, z, W, V, C, H, oe, re, Q, ie, xe, ne, D, M;
  const { children: e } = t, r = At(), n = Nn(), [a, o] = u.useState(
    null
  ), [l, i] = u.useState(""), [c, m] = u.useState(!0), y = ((T = (k = r == null ? void 0 : r.rootProps) == null ? void 0 : k.dataDogCredentials) == null ? void 0 : T.applicationId) || ((F = (G = n == null ? void 0 : n.rootProps) == null ? void 0 : G.dataDogCredentials) == null ? void 0 : F.applicationId), p = ((z = (X = r == null ? void 0 : r.rootProps) == null ? void 0 : X.dataDogCredentials) == null ? void 0 : z.clientToken) || ((V = (W = n == null ? void 0 : n.rootProps) == null ? void 0 : W.dataDogCredentials) == null ? void 0 : V.clientToken), f = ((C = r == null ? void 0 : r.rootProps) == null ? void 0 : C.appName) || ((H = n == null ? void 0 : n.rootProps) == null ? void 0 : H.appName), I = ((oe = r == null ? void 0 : r.rootProps) == null ? void 0 : oe.appVersion) || ((re = n == null ? void 0 : n.rootProps) == null ? void 0 : re.appVersion), b = ((Q = r == null ? void 0 : r.rootProps) == null ? void 0 : Q.deploymentEnvironment) || ((ie = n == null ? void 0 : n.rootProps) == null ? void 0 : ie.deploymentEnvironment), w = ((xe = r == null ? void 0 : r.rootProps) == null ? void 0 : xe.dataDogConfig) || ((ne = n == null ? void 0 : n.rootProps) == null ? void 0 : ne.dataDogConfig), S = ((D = r == null ? void 0 : r.instance) == null ? void 0 : D.originURL) || ((M = n == null ? void 0 : n.instance) == null ? void 0 : M.originURL), N = !r && !n;
  return u.useEffect(() => {
    tr.onReady(() => {
      if (N) {
        i(
          "DataDogProvider:Did you import the AppRootProvider or InitRootProvider context"
        ), m(!1);
        return;
      } else if (!y || !p) {
        i(
          "DataDogProvider: You have not pass credentials to datadog"
        ), m(!1);
        return;
      }
      const he = new tr({
        clientToken: p,
        applicationId: y,
        appName: f ?? "",
        appVersion: I ?? "",
        env: b ?? "stage"
      });
      he.initDatadog(w ?? {}, S), o(he), m(!1);
    });
  }, [
    N,
    y,
    p,
    f,
    I,
    b,
    w,
    S
  ]), c ? "initializing datadog" : l || /* @__PURE__ */ s.jsx(_n.Provider, { value: a, children: e });
}, ul = {
  alignment: "right",
  horizontal_padding: 20,
  vertical_padding: 20,
  hide_default_launcher: !0
}, Fr = ({
  intercomId: t,
  settings: e = ul
}) => {
  (function() {
    const r = window, n = r.Intercom;
    if (typeof n == "function")
      n("reattach_activator"), n("update", r.intercomSettings);
    else {
      const a = document, o = function(...i) {
        o.c(i);
      };
      o.q = [], o.c = function(i) {
        o.q.push(i);
      }, r.Intercom = o;
      const l = function() {
        const i = a.createElement("script");
        i.type = "text/javascript", i.async = !0, i.src = "https://widget.intercom.io/widget/" + t;
        const c = a.getElementsByTagName("script")[0];
        c.parentNode.insertBefore(i, c);
      };
      document.readyState === "complete" ? l() : r.attachEvent ? r.attachEvent("onload", l) : r.addEventListener("load", l, !1);
    }
  })(), window.intercomSettings = {
    app_id: t,
    ...e
  };
};
class Br {
  constructor(e) {
    ee(this, "parmas");
    ee(this, "bootIntercom", () => {
      try {
        window == null || window.Intercom("boot", {
          app_id: this.parmas.intercomId,
          ...this.parmas
        });
      } catch {
        process.env.NODE_ENV !== "production" && console.log("Error booting intercom");
      }
    });
    ee(this, "shutdownIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "shutdown");
    });
    ee(this, "onIntercomShow", (e) => {
      window == null || window.Intercom("onShow", e);
    });
    ee(this, "onIntercomHide", (e) => {
      window == null || window.Intercom("onHide", e);
    });
    ee(this, "hideIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "hide");
    });
    ee(this, "showIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "show");
    });
    ee(this, "onIntercomeUnreadCountChange", (e) => {
      window == null || window.Intercom("onUnreadCountChange", e);
    });
    this.parmas = e;
  }
}
const Un = u.createContext(null), pl = () => u.useContext(Un), pr = u.createContext({});
process.env.NODE_ENV !== "production" && (pr.displayName = "InitContext");
const fl = () => u.useContext(pr);
class gl {
  constructor(e) {
    ee(this, "legacyMode");
    ee(this, "initData");
    ee(this, "intercomId");
    ee(this, "initRootInst");
    this.intercomId = e.intercomId, this.legacyMode = e.legacyMode, this.initData = e.initData, this.initRootInst = e.initRootInst, this.legacyMode && hn(this.initData), mn(this.initData);
  }
  get favicon() {
    return this.initData.smallLogoUrl;
  }
  get showOrganizationName() {
    return this.initData.isIncludeOrganizationName;
  }
  get organizationName() {
    return this.initData.organizationName;
  }
  get organizationLogo() {
    return this.initData.largeLogoUrl;
  }
  get organizationID() {
    var e, r;
    return ((e = this.initData) == null ? void 0 : e.orgId) || ((r = this.initData) == null ? void 0 : r.wsId);
  }
  get loggedInOwId() {
    return this.initData.owId;
  }
  get originURL() {
    return this.initRootInst.originURL;
  }
  get iqmPlatformBasicAuth() {
    return this.initRootInst.iqmPlatformBasicAuth;
  }
  get helpURL() {
    var e, r, n, a;
    return ((a = (n = (r = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : r.help_url) == null ? void 0 : n[0]) == null ? void 0 : a.url) ?? "";
  }
  get headerLinks() {
    var e, r, n, a;
    return Array.isArray((r = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : r.header) ? (a = (n = this.initData) == null ? void 0 : n.pages) == null ? void 0 : a.header : [];
  }
  get footerLinks() {
    var e, r, n, a;
    return Array.isArray((r = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : r.footer) ? (a = (n = this.initData) == null ? void 0 : n.pages) == null ? void 0 : a.footer : [];
  }
  get landingPageImage() {
    var e, r, n;
    return ((n = (r = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : r.landingPages) == null ? void 0 : n[0]) ?? "";
  }
  get organizationType() {
    var e;
    return (e = this.initData) != null && e.ihpOwner ? Be.SUPER : Be.WORKSPACE;
  }
  get passwordNote() {
    return this.initData.passwordNote;
  }
  get workspaceURLSuffix() {
    return this.initData.workspaceURLSuffix;
  }
  get owId() {
    return this.initData.owId;
  }
  get svgHostURL() {
    return this.initRootInst.svgHostURL;
  }
}
const ml = (t, e) => {
  const r = new URL("/api", t.originURL), n = Le.create({
    baseURL: r.toString()
  });
  return wn(n), e == null || e(n), n;
}, pd = (t) => {
  var T;
  const { children: e } = t, r = Nn(), [n, a] = u.useState(!0), [o, l] = u.useState(""), [i, c] = u.useState(null), [m, y] = u.useState(
    null
  ), [p, f] = u.useState(!1);
  u.useEffect(() => {
    var F;
    if (!r) {
      a(!1), l(
        "InitProvider:Did you import the InitRootProvider context"
      ), f(!0);
      return;
    }
    const G = ml(
      {
        originURL: ((F = r == null ? void 0 : r.instance) == null ? void 0 : F.originURL) ?? ""
      },
      (X) => {
        var z, W;
        (W = (z = r == null ? void 0 : r.rootProps) == null ? void 0 : z.attachInterceptorsToInstance) == null || W.call(z, X);
      }
    );
    y(() => G);
  }, [r]);
  const I = Ao(m, {
    enabled: m !== null
  }), b = Lo(m, {
    enabled: m !== null
  }), w = I.isFetching || b.isFetching || I.isLoading || b.isLoading, S = I.isError || b.isError;
  u.useEffect(() => {
    if (!w) {
      if (S) {
        a(!1), l("Error loading data"), f(!0), process.env.NODE_ENV !== "production" && (I.isError && console.error(I.error), b.isError && console.error(b.error));
        return;
      }
      if (I.data && b.data) {
        const G = new gl({
          initData: I.data,
          initRootInst: r.instance,
          intercomId: b.data.chatbotAppId,
          legacyMode: r.rootProps.legacyMode ?? !0
        });
        c(G), a(!1);
        return;
      }
      l("Error occured while loading app init data"), a(!1), f(!0);
    }
  }, [
    w,
    S,
    I.data,
    b.data,
    I.error,
    b.error,
    I.isError,
    b.isError,
    m,
    r
  ]);
  const N = Pe() ? "App Initialzing..." : null, k = Pe() ? o : p ? "Error Loading App" : null;
  return /* @__PURE__ */ s.jsx(
    pr.Provider,
    {
      value: {
        initMeta: i,
        apiInstance: m
      },
      children: n ? N : o !== "" ? k : /* @__PURE__ */ s.jsx(
        Fn,
        {
          enableIntercom: (T = r == null ? void 0 : r.rootProps) == null ? void 0 : T.enableIntercom,
          children: e
        }
      )
    }
  );
}, Fn = (t) => {
  const { enableIntercom: e = !0, children: r } = t, { appMeta: n } = Ge(), { initMeta: a } = fl(), [o, l] = u.useState(null);
  return u.useEffect(() => {
    let i;
    if (e && (n != null && n.intercomId))
      return Fr({ intercomId: n.intercomId }), i = new Br({
        email: n == null ? void 0 : n.userEmail,
        intercomId: n == null ? void 0 : n.intercomId,
        name: n == null ? void 0 : n.userDisplayName,
        owId: n == null ? void 0 : n.loggedInOwId
      }), i && (i.bootIntercom(), i.hideIntercom()), l(i), () => {
        i == null || i.shutdownIntercom();
      };
  }, [
    e,
    n == null ? void 0 : n.userEmail,
    n == null ? void 0 : n.intercomId,
    n == null ? void 0 : n.userDisplayName,
    n == null ? void 0 : n.loggedInOwId
  ]), u.useEffect(() => {
    let i;
    if (e && (a != null && a.intercomId))
      return Fr({ intercomId: a.intercomId }), i = new Br({
        intercomId: a.intercomId
      }), i && i.bootIntercom(), l(i), () => {
        i == null || i.shutdownIntercom();
      };
  }, [e, a == null ? void 0 : a.intercomId]), /* @__PURE__ */ s.jsx(Un.Provider, { value: o, children: r });
}, fr = u.createContext({});
process.env.NODE_ENV !== "production" && (fr.displayName = "AppContext");
const Ge = () => u.useContext(fr);
class hl {
  constructor(e) {
    ee(this, "authData");
    ee(this, "profileData");
    ee(this, "orgsHirerachy");
    ee(this, "currentApp");
    ee(this, "appRootInst");
    ee(this, "legacyMode");
    ee(this, "useNewCrossLoginURL");
    ee(this, "initData");
    ee(this, "allowedApps");
    ee(this, "customerConfigData");
    ee(this, "intercomId");
    ee(this, "refetchFunction");
    /**
     * @deprecated
     * @returns string
     */
    ee(this, "prepareAppSwitchingURLLegacy", (e, r) => {
      const [n] = mt(this.loggedInOwId), a = new URL(
        `${e.appUrl}/u/${n}/`,
        this.originURL
      );
      return a.hash = r, a.toString();
    });
    ee(this, "prepareAppSwitchingURLNew", (e, r) => {
      const n = new URL(
        `${e.appUrl}/u/${this.loggedInOwId}/`,
        this.originURL
      );
      return n.hash = r, n.toString();
    });
    ee(this, "prepareAppSwitchingURL", (e, r = "") => this.legacyMode ? this.prepareAppSwitchingURLLegacy(e, r) : this.prepareAppSwitchingURLNew(e, r));
    /**
     *
     * @depricated
     * @return string
     */
    ee(this, "prepareOrganizationSwitchingURLLegacy", (e) => {
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (window.location.href.includes(e.workspaceDomain)) {
        const [n, a] = mt(e.owId), o = Tt();
        if (n === -1 && o >= 0) {
          const l = [...a, e.owId];
          return localStorage.setItem(
            fe.LEGACY_OWIDS_ARRAY,
            JSON.stringify(l)
          ), rt(
            window.location.href,
            o,
            l.length - 1
          ).replace(window.location.hash, "");
        } else if (n >= 0 && o >= 0)
          return rt(
            window.location.href,
            o,
            n
          ).replace(window.location.hash, "");
        return window.location.href;
      } else {
        const n = new URLSearchParams();
        return n.set("ow", `${e.owId}`), n.set("apiToken", btoa(this.authToken)), n.set("refreshToken", btoa(this.refreshToken)), n.set("expiresAt", `${this.authTokenExpiryInMilliseconds / 1e3}`), n.set("redirect_to", this.currentApp), `https://${e.workspaceDomain}/#/login?${n.toString()}`;
      }
    });
    /**
     *
     * @depricated
     * @return string
     */
    ee(this, "prepareOrganizationSwitchingURLLegacyWithNewCrossLogin", (e) => {
      var n, a;
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (window.location.href.includes(e.workspaceDomain)) {
        const [o, l] = mt(e.owId), i = Tt();
        if (o === -1 && i >= 0) {
          const c = [...l, e.owId];
          return localStorage.setItem(
            fe.LEGACY_OWIDS_ARRAY,
            JSON.stringify(c)
          ), rt(
            window.location.href,
            i,
            c.length - 1
          ).replace(window.location.hash, "");
        } else if (o >= 0 && i >= 0)
          return rt(
            window.location.href,
            i,
            o
          ).replace(window.location.hash, "");
        return window.location.href;
      } else {
        const o = ((a = (n = this.allowedApps) == null ? void 0 : n[this.currentApp]) == null ? void 0 : a.appUrl) ?? "", l = {
          ...this.authData,
          refreshToken: btoa(this.authData.refreshToken),
          accessToken: btoa(this.authData.accessToken),
          owId: e.owId,
          redirectAppName: o
        }, i = new URLSearchParams(
          l
        );
        return `https://${e.workspaceDomain}/#/cross-login?${i.toString()}`;
      }
    });
    ee(this, "prepareOrganizationSwitchingURLNew", (e) => {
      var n, a;
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (window.location.href.includes(e.workspaceDomain))
        return rt(
          window.location.href,
          this.loggedInOwId,
          e.owId
        ).replace(window.location.hash, "");
      {
        const o = ((a = (n = this.allowedApps) == null ? void 0 : n[this.currentApp]) == null ? void 0 : a.appUrl) ?? "", l = {
          ...this.authData,
          refreshToken: btoa(this.authData.refreshToken),
          accessToken: btoa(this.authData.accessToken),
          owId: e.owId,
          redirectAppName: o
        }, i = new URLSearchParams(
          l
        );
        return `https://${e.workspaceDomain}/#/cross-login?${i}`;
      }
    });
    ee(this, "prepareOrganizationSwitchingURL", (e) => this.legacyMode ? this.useNewCrossLoginURL ? this.prepareOrganizationSwitchingURLLegacyWithNewCrossLogin(
      e
    ) : this.prepareOrganizationSwitchingURLLegacy(e) : this.prepareOrganizationSwitchingURLNew(e));
    this.intercomId = e.intercomId, this.currentApp = e.currentApp, this.appRootInst = e.appRootInst, this.legacyMode = e.legacyMode, this.useNewCrossLoginURL = e.useNewCrossLoginURL, this.allowedApps = yl(e.allowedApps), this.refetchFunction = e.refetchQueries, this.authData = e.authData, this.profileData = e.profileData, this.customerConfigData = e.customerConfigData;
    const r = {
      organizationName: this.profileData.organizationName,
      owId: this.profileData.owId,
      // todo - figure out a way to get this data from init
      workspaceDomain: window.location.host,
      isAccess: !1
    };
    this.orgsHirerachy = [
      ...Bn(this.profileData.parentOrganization),
      r
    ], this.initData = this.legacyMode ? fn() : gn();
  }
  get favicon() {
    return this.initData.favicon;
  }
  get appHelpURL() {
    return this.initData.helpURL ?? "";
  }
  get userEmail() {
    return this.profileData.email ?? "";
  }
  get userAvatar() {
    return this.profileData.userAvatar;
  }
  get isUserOrganizationOwner() {
    return this.profileData.isOwnerUser;
  }
  get userDisplayName() {
    return this.profileData.displayName ?? "";
  }
  get userFirstName() {
    return this.profileData.firstName ?? "";
  }
  get userLastName() {
    return this.profileData.lastName ?? "";
  }
  get isBetaUser() {
    return this.profileData.isBetaUser;
  }
  get organizationName() {
    return this.profileData.organizationName ?? "";
  }
  get organizationLogo() {
    return this.profileData.organizationLogo;
  }
  get organizationTimezone() {
    return this.profileData.organizationTimezone;
  }
  get organizationType() {
    return this.profileData.isPlatformOwnerOrg ? Be.SUPER : this.profileData.isWorkspaceOwnerOrg ? Be.WORKSPACE : Be.ADVERTISER;
  }
  get isInfobarEnabled() {
    return this.organizationType === "SUPER" || this.organizationType === "WORKSPACE" ? !0 : this.organizationType === "ADVERTISER" && this.profileData.parentOrganization;
  }
  get loggedInOwId() {
    return this.profileData.owId;
  }
  get organizationHirerachy() {
    return this.orgsHirerachy;
  }
  get authToken() {
    return this.authData.accessToken;
  }
  get authTokenExpiryInMilliseconds() {
    return this.authData.expiresIn * 1e3;
  }
  get refreshToken() {
    return this.authData.refreshToken;
  }
  get originURL() {
    return this.appRootInst.originURL;
  }
  get owIdHeaderKey() {
    return this.appRootInst.owIdHeaderKey;
  }
  get isOnlyImpressionBasedCustomer() {
    return this.profileData.isOnlyImpressionBasedCustomer ?? !1;
  }
  get isWorkspaceSuspended() {
    var e, r;
    return ((r = (e = this.profileData) == null ? void 0 : e.failureDetails) == null ? void 0 : r.status) === "SUSPENDED";
  }
  get workspaceSuspendedReason() {
    var e, r, n, a;
    if (this.isWorkspaceSuspended)
      return {
        reason: ((r = (e = this.profileData) == null ? void 0 : e.failureDetails) == null ? void 0 : r.reason) ?? "",
        supportEmail: ((a = (n = this.profileData) == null ? void 0 : n.failureDetails) == null ? void 0 : a.supportEmail) ?? ""
      };
  }
  get isVldEnable() {
    return this.customerConfigData.isVldEnabled ?? !1;
  }
  get isBidShadingEnabled() {
    return this.customerConfigData.isBidShadingEnabled ?? !0;
  }
  get hadVldGenerated() {
    return this.customerConfigData.hadVldGenerated ?? !1;
  }
  get isPldEnable() {
    return this.customerConfigData.isPldEnabled ?? !1;
  }
  get hadPldGenerated() {
    return this.customerConfigData.hadPldGenerated ?? !1;
  }
  get pldMarkupTypeId() {
    return this.customerConfigData.pldMarkupTypeId;
  }
  get pldMarkupValue() {
    return this.customerConfigData.pldMarkupValue ?? 0;
  }
  get pldRateForDiscount() {
    return this.customerConfigData.pldRateForDiscount ?? 0;
  }
  get pldMarkupPercentageForDiscount() {
    return this.customerConfigData.pldMarkupPercentageForDiscount ?? 0;
  }
  get vertical() {
    return this.customerConfigData.vertical ?? "political";
  }
  // This could be 1=absolute and 2=precentage
  get vldMarkupTypeId() {
    return this.customerConfigData.vldMarkupTypeId ?? 1;
  }
  get vldMarkupValue() {
    return this.customerConfigData.vldMarkupValue ?? 0;
  }
  get pgCampaignFees() {
    return this.customerConfigData.pgCampaignFees ?? 0;
  }
  get pgWorkspaceShare() {
    return this.customerConfigData.pgWorkspaceShare ?? 0;
  }
  getAppData(e) {
    return this.allowedApps[e];
  }
  refetchData(e) {
    var r;
    return (r = this == null ? void 0 : this.refetchFunction) == null ? void 0 : r.call(this, e);
  }
  logout() {
    Xe();
    const e = new URL(
      vt.appUrl,
      this.appRootInst.originURL
    ).toString();
    window.location.href = Pe() ? window.location.href : e;
  }
}
const Bn = (t) => {
  let e = [];
  if (t) {
    const { parentOrganization: r, ...n } = t;
    return r && (e = Bn(r)), e.push(n), e;
  }
  return [];
}, yl = (t) => t.reduce(
  (e, r) => (e[r.appName] = r, e),
  {}
), wl = (t, e, r, n, a) => t ? vl(e, r, n, a) : xl(e, r, n, a), vl = (t, e, r, n) => {
  const [a] = mt(t), o = new URL(`${r.appUrl}/u/${a}/`, e);
  return o.hash = n, o.toString();
}, xl = (t, e, r, n) => {
  const a = new URL(`${r.appUrl}/u/${t}/`, e);
  return a.hash = n, a.toString();
}, fd = (t) => {
  var oe, re, Q, ie, xe;
  const { children: e } = t, r = At(), n = cl(), a = (oe = r == null ? void 0 : r.rootProps) == null ? void 0 : oe.legacyMode, [o, l] = u.useState(!0), [i, c] = u.useState(""), [m, y] = u.useState(
    null
  ), [p, f] = u.useState(
    null
  ), [I, b] = u.useState(!1), [w, S] = u.useState(null), N = u.useMemo(() => {
    var D;
    const ne = (D = r == null ? void 0 : r.instance) == null ? void 0 : D.originURL;
    return new URL(vt.appUrl, ne).toString();
  }, [(re = r == null ? void 0 : r.instance) == null ? void 0 : re.originURL]), k = (Q = r == null ? void 0 : r.instance) == null ? void 0 : Q.originURL;
  u.useEffect(() => {
    var M, he, pe;
    const ne = new AbortController();
    if (!r) {
      l(!1), c(
        "AppProvider:Did you import the AppRootProvider context"
      ), b(!0);
      return;
    }
    let D;
    if (((M = r == null ? void 0 : r.rootProps) == null ? void 0 : M.legacyMode) === !0 ? D = Zt() : D = Qt(), D === null) {
      l(!1), c("Error Validating the user"), process.env.NODE_ENV !== "production" && console.error("failed reading auth details from localstorage"), Pe() || (Xe(), window.location.replace(N));
      return;
    }
    if (((he = r == null ? void 0 : r.instance) == null ? void 0 : he.OwIdFromPath) === null) {
      l(!1), c("Error fetching owId"), Pe() || (Xe(), window.location.replace(N));
      return;
    }
    return ho(
      ((pe = r.instance) == null ? void 0 : pe.originURL) ?? "",
      D.accessToken,
      ne.signal
    ).then(() => {
      var Y, h, B;
      const Ie = er(
        {
          token: (D == null ? void 0 : D.accessToken) ?? "",
          originURL: ((Y = r == null ? void 0 : r.instance) == null ? void 0 : Y.originURL) ?? "",
          owIdHeaderKey: ((h = r == null ? void 0 : r.instance) == null ? void 0 : h.owIdHeaderKey) ?? "",
          owId: ((B = r == null ? void 0 : r.instance) == null ? void 0 : B.OwIdFromPath) ?? 1 / 0
        },
        (te, le, j) => {
          var _, x;
          (x = (_ = r == null ? void 0 : r.rootProps) == null ? void 0 : _.attachInterceptorsToInstance) == null || x.call(
            _,
            te,
            le,
            j
          ), Cr(te);
        }
      );
      S(D), f(() => Ie);
    }).catch((Ie) => {
      var Y;
      Ie.name !== "CanceledError" && yo(
        ((Y = r.instance) == null ? void 0 : Y.originURL) ?? "",
        (D == null ? void 0 : D.refreshToken) ?? "",
        ne.signal
      ).then((h) => {
        var x, L, q, J, ce, O;
        const B = {
          owId: ((x = r == null ? void 0 : r.instance) == null ? void 0 : x.OwIdFromPath) ?? 1 / 0,
          access_token: h.access_token,
          refresh_token: h.refresh_token,
          scope: h.scope,
          token_type: h.token_type,
          expires_in: h.expires_in
        }, le = {
          ...JSON.parse(
            localStorage.getItem(fe.LEGACY_AUTH) ?? ""
          ),
          owId: ((L = r == null ? void 0 : r.instance) == null ? void 0 : L.OwIdFromPath) ?? 1 / 0,
          apiToken: h.access_token,
          refreshToken: h.refresh_token,
          expiresAt: h.expires_in
        };
        localStorage.setItem(
          fe.AUTH,
          JSON.stringify(B)
        ), localStorage.setItem(
          fe.LEGACY_AUTH,
          JSON.stringify(le)
        );
        const j = {
          accessToken: h.access_token,
          refreshToken: h.refresh_token,
          expiresIn: h.expires_in,
          tokenType: h.token_type,
          scope: h.scope,
          // @ts-ignore
          owId: ((q = r == null ? void 0 : r.instance) == null ? void 0 : q.OwIdFromPath) ?? 1 / 0
        }, _ = er(
          {
            token: (j == null ? void 0 : j.accessToken) ?? "",
            originURL: ((J = r == null ? void 0 : r.instance) == null ? void 0 : J.originURL) ?? "",
            owIdHeaderKey: ((ce = r == null ? void 0 : r.instance) == null ? void 0 : ce.owIdHeaderKey) ?? "",
            owId: ((O = r == null ? void 0 : r.instance) == null ? void 0 : O.OwIdFromPath) ?? 1 / 0
          },
          (g, P, U) => {
            var K, $;
            ($ = (K = r == null ? void 0 : r.rootProps) == null ? void 0 : K.attachInterceptorsToInstance) == null || $.call(
              K,
              g,
              P,
              U
            ), Cr(g);
          }
        );
        S(j), f(() => _);
      }).catch(() => {
        l(!1), c("Invalid token"), Pe() || (Xe(), window.location.replace(N));
      });
    }), () => ne.abort();
  }, [r, N]);
  const T = vo({
    enabled: p !== null
  }), G = Io({
    enabled: p !== null
  }), F = xo({
    enabled: p !== null
  }), X = bo(
    ((ie = r == null ? void 0 : r.instance) == null ? void 0 : ie.OwIdFromPath) ?? 1 / 0,
    {
      enabled: p !== null
    }
  ), z = T.isFetching || G.isFetching || F.isFetching || X.isFetching, W = T.isError || G.isError || F.isError || X.isError, V = It((ne) => {
    const D = [];
    if (ne.indexOf("profile") >= 0) {
      const M = T.refetch;
      D.push(M());
    }
    if (ne.indexOf("allowedApps") >= 0) {
      const M = G.refetch;
      D.push(M());
    }
    if (ne.indexOf("chatbot") >= 0) {
      const M = F.refetch;
      D.push(M());
    }
    if (ne.indexOf("customerConfig") >= 0) {
      const M = X.refetch;
      D.push(M());
    }
    return Promise.allSettled(D);
  });
  u.useEffect(() => {
    var ne, D, M, he;
    if (p !== null && !z) {
      if (W) {
        if (T.isError && F.isError && X.isError && G.isError === !1 && G.data && (G.data || []).find(
          (Ie) => {
            var Y;
            return Ie.appName === ((Y = r == null ? void 0 : r.rootProps) == null ? void 0 : Y.appName);
          }
        ) === void 0) {
          if (c("User does not have access to this app"), l(!1), b(!0), !Pe()) {
            const Ie = (G.data || []).find(
              (h) => h.appName === "Dashboard"
            ), Y = wl(
              a,
              (ne = r == null ? void 0 : r.instance) == null ? void 0 : ne.OwIdFromPath,
              ((D = r == null ? void 0 : r.instance) == null ? void 0 : D.originURL) ?? "",
              Ie,
              ""
            );
            window.location.replace(Y);
          }
          return;
        }
        l(!1), c("Error loading data"), b(!0), process.env.NODE_ENV !== "production" && (T.isError && console.error(T.error), G.isError && console.error(G.error), F.isError && console.error(F.error), X.isError && console.error(X.error));
        return;
      }
      if (T.data && G.data && F.data && X.data && w) {
        const pe = new hl({
          profileData: T.data,
          authData: w,
          intercomId: F.data.chatbotAppId,
          customerConfigData: X.data ?? {},
          appRootInst: r.instance,
          currentApp: (M = r.rootProps) == null ? void 0 : M.appName,
          legacyMode: r.rootProps.legacyMode ?? !0,
          useNewCrossLoginURL: r.rootProps.useNewCrossLoginURL ?? !1,
          allowedApps: G.data,
          refetchQueries: V
        });
        if (G.data.find(
          (Y) => {
            var h;
            return Y.appName === ((h = r == null ? void 0 : r.rootProps) == null ? void 0 : h.appName);
          }
        ) === void 0) {
          if (c("User does not have access to this app"), l(!1), !Pe()) {
            const Y = pe.getAppData("Dashboard"), h = pe.prepareAppSwitchingURL(Y);
            window.location.replace(h);
          }
          return;
        }
        if (pe.isWorkspaceSuspended && !(r != null && r.rootProps.disableRedirectWhenWorkspaceIsSuspended)) {
          const Y = pe == null ? void 0 : pe.getAppData("Marketplace");
          if (!Pe() && Y) {
            const h = pe.prepareAppSwitchingURL(
              Y,
              "/suspended"
            );
            window.location.replace(h);
            return;
          } else
            c("workspace is suspended"), l(!1);
        }
        if (n == null || n.setUser({
          owId: pe.loggedInOwId,
          userEmail: pe.userEmail,
          userName: pe.userDisplayName,
          organizationName: pe.organizationName
        }), y(pe), l(!1), a)
          try {
            const h = {
              ...{
                apiToken: w.accessToken,
                refreshToken: w.refreshToken,
                owId: ((he = r == null ? void 0 : r.instance) == null ? void 0 : he.OwIdFromPath) ?? 1 / 0,
                expiresAt: w.expiresIn
              },
              ...T.data,
              domainURL: cr(k)
            };
            localStorage.setItem(
              fe.LEGACY_AUTH,
              JSON.stringify(h)
            );
          } catch {
          }
        return;
      }
      c("Error occured while loading app init data"), l(!1), b(!0);
    }
  }, [
    z,
    W,
    T.data,
    G.data,
    F.data,
    X.data,
    T.error,
    G.error,
    X.error,
    F.error,
    T.isError,
    F.isError,
    G.isError,
    X.isError,
    w,
    p,
    n,
    r,
    V,
    a,
    k
  ]), u.useEffect(() => {
    const ne = () => {
      const D = a ? Zt() : Qt();
      !(D != null && D.accessToken) && Pe() === !1 && (Xe(), window.location.replace(N));
    };
    return window.addEventListener(
      "storage",
      ne
    ), () => {
      window.removeEventListener(
        "storage",
        ne
      );
    };
  }, [a, N]);
  const C = Pe() ? "App Initialzing..." : null, H = Pe() ? i : I ? "Error Loading App" : null;
  return /* @__PURE__ */ s.jsx(
    fr.Provider,
    {
      value: {
        appMeta: m,
        apiInstance: p,
        allowedApps: G.data ?? []
      },
      children: o ? C : i !== "" ? H : /* @__PURE__ */ s.jsx(
        Fn,
        {
          enableIntercom: (xe = r == null ? void 0 : r.rootProps) == null ? void 0 : xe.enableIntercom,
          children: e
        }
      )
    }
  );
}, Il = {
  [Be.ADVERTISER]: $e.advertiserUser,
  [Be.WORKSPACE]: $e.workspaceUser,
  [Be.SUPER]: $e.superUser
}, bl = u.forwardRef(
  function(e, r) {
    var m, y;
    const { className: n, ...a } = e, { appMeta: o } = Ge(), [l, i] = u.useState(o == null ? void 0 : o.isInfobarEnabled);
    if (!o)
      return process.env.NODE_ENV !== "production" ? /* @__PURE__ */ s.jsx(
        wt,
        {
          className: Ce($e.root, n),
          ref: r,
          ...a,
          icon: !1,
          variant: "filled",
          onClose: () => i(!1),
          classes: {
            ...a == null ? void 0 : a.classes,
            message: Ce($e.message, (m = a == null ? void 0 : a.classes) == null ? void 0 : m.message)
          },
          children: "Did you import the AppRootProvier and AppProvider Context"
        }
      ) : null;
    const c = o.organizationHirerachy.map((p) => {
      const f = p;
      return p.isAccess ? /* @__PURE__ */ s.jsx(
        be,
        {
          arrow: !0,
          TypgraphyProps: {
            sx: { display: "block", width: 100 },
            component: Vr,
            className: $e.link,
            onClick: () => {
              const I = o.prepareOrganizationSwitchingURL(f);
              window.open(I, "_blank");
            }
          },
          children: f.organizationName
        },
        f.owId
      ) : /* @__PURE__ */ s.jsx(
        be,
        {
          arrow: !0,
          TypgraphyProps: { sx: { display: "block" } },
          children: f.organizationName
        },
        f.owId
      );
    });
    return l ? /* @__PURE__ */ s.jsxs(
      wt,
      {
        className: Ce(
          $e.root,
          Il[o.organizationType],
          n
        ),
        ref: r,
        ...a,
        icon: !1,
        variant: "filled",
        onClose: () => i(!1),
        classes: {
          ...a == null ? void 0 : a.classes,
          message: Ce($e.message, (y = a == null ? void 0 : a.classes) == null ? void 0 : y.message)
        },
        children: [
          /* @__PURE__ */ s.jsx(
            Ve,
            {
              className: $e.chip,
              size: "small",
              label: o.isUserOrganizationOwner ? "Owner" : "User",
              sx: { flexShrink: 0 }
            }
          ),
          /* @__PURE__ */ s.jsx(A, { sx: { flexShrink: 0 }, children: "Logged in as" }),
          /* @__PURE__ */ s.jsx(
            be,
            {
              arrow: !0,
              TypgraphyProps: { weight: "demi" },
              sx: { maxWidth: 100 },
              children: o.userDisplayName || o.userEmail
            }
          ),
          /* @__PURE__ */ s.jsx(A, { sx: { flexShrink: 0 }, children: " in " }),
          /* @__PURE__ */ s.jsx(
            Ht,
            {
              "aria-label": "breadcrumb",
              separator: /* @__PURE__ */ s.jsx(Gt, {}),
              sx: { maxWidth: 100, overflow: "hidden" },
              classes: {
                ol: je({ flexWrap: "nowrap", overflow: "hidden", maxWidth: 100 }),
                li: je({ overflow: "hidden", maxWidth: 100 }),
                separator: je({ flexShrink: 0 })
              },
              children: c
            }
          )
        ]
      }
    ) : null;
  }
);
bl.displayName = "InfoBar";
const Sl = "_root_10bq1_1", Rl = "_title_10bq1_13", jl = "_icon_10bq1_20", Al = "_beta_10bq1_32", Ll = "_content_10bq1_42", Pl = "_nav_10bq1_49", Qe = {
  root: Sl,
  title: Rl,
  icon: jl,
  beta: Al,
  content: Ll,
  nav: Pl
}, Cl = () => {
  const [t, e] = u.useState(!1);
  u.useEffect(() => {
    if (!sessionStorage.getItem("responsiveAlertShown")) {
      const { matches: n } = window.matchMedia("(max-width: 1200px)");
      e(n);
    }
  }, []);
  const r = () => {
    e(!1), sessionStorage.setItem("responsiveAlertShown", "true");
  };
  return /* @__PURE__ */ s.jsx(
    hs,
    {
      maxWidth: "xs",
      open: t,
      onClose: () => e(!1),
      PaperProps: { sx: { py: 32 } },
      children: /* @__PURE__ */ s.jsxs(
        Kr,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center"
          },
          children: [
            /* @__PURE__ */ s.jsx(
              wa,
              {
                sx: { width: 75, height: "auto", textColor: "primary-500", mb: 24 }
              }
            ),
            /* @__PURE__ */ s.jsxs(
              R,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  gap: 8
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    A,
                    {
                      component: "h1",
                      variant: "bodyLarge",
                      weight: "demi",
                      gutterBottom: !1,
                      children: "Want a better Experience?"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(A, { component: "p", gutterBottom: !1, children: "Use a tablet or computer for a better and smoother platform experience." })
                ]
              }
            ),
            /* @__PURE__ */ s.jsx(We, { onClick: r, sx: { mt: 16 }, children: "Ok, Got It" })
          ]
        }
      )
    }
  );
}, El = () => {
  const t = pl(), { appMeta: e } = Ge(), [r, n] = u.useState(!1), [a, o] = u.useState(0);
  return u.useEffect(() => {
    t == null || t.onIntercomShow(() => {
      n(!0);
    }), t == null || t.onIntercomHide(() => {
      n(!1);
    }), t == null || t.onIntercomeUnreadCountChange((l) => {
      o(l);
    });
  }, [t, n]), e.intercomId ? /* @__PURE__ */ s.jsx(Te, { title: "Chat", arrow: !0, children: /* @__PURE__ */ s.jsx(ot, { badgeContent: a, children: /* @__PURE__ */ s.jsx(
    Fe,
    {
      color: "secondary",
      onClick: () => {
        r ? t == null || t.hideIntercom() : t == null || t.showIntercom();
      },
      children: /* @__PURE__ */ s.jsx(sa, {})
    }
  ) }) }) : null;
}, Ol = "_drawer_bv1mw_1", kl = "_appDrawer_bv1mw_14", Dl = "_appList_bv1mw_22", _l = "_appListItem_bv1mw_33", Tl = "_appListItemLink_bv1mw_38", Nl = "_appListItemLinkIcon_bv1mw_52", Ul = "_appListItemLinkText_bv1mw_55", Fl = "_active_bv1mw_77", Bl = "_disabled_bv1mw_85", He = {
  drawer: Ol,
  appDrawer: kl,
  appList: Dl,
  appListItem: _l,
  appListItemLink: Tl,
  appListItemLinkIcon: Nl,
  appListItemLinkText: Ul,
  active: Fl,
  disabled: Bl
}, zn = () => {
  const t = ht({
    variant: "popper",
    popupId: "appsPopper"
  }), { allowedApps: e, appMeta: r } = Ge(), n = At(), o = u.useMemo(() => e.filter((l) => l.showInDrawer), [e]).map((l) => {
    var y;
    const i = va[l.appName] ?? gt, c = ((y = n == null ? void 0 : n.rootProps) == null ? void 0 : y.appName) === l.appName, m = r.prepareAppSwitchingURL(l);
    return /* @__PURE__ */ s.jsx("li", { className: He.appListItem, children: /* @__PURE__ */ s.jsxs(
      Nt,
      {
        href: m,
        className: Ce(
          He.appListItemLink,
          c && [He.active]
        ),
        children: [
          i && /* @__PURE__ */ s.jsx(i, { fontSize: 48, className: He.appListItemLinkIcon }),
          /* @__PURE__ */ s.jsx(
            A,
            {
              component: "h2",
              variant: "bodySmall",
              weight: "demi",
              gutterBottom: !1,
              className: He.appListItemLinkText,
              children: l.appName
            }
          )
        ]
      }
    ) }, l.appId);
  });
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(Te, { title: "All your Apps", arrow: !0, children: /* @__PURE__ */ s.jsx(
      Fe,
      {
        color: "secondary",
        ...kt(t),
        selected: t.isOpen,
        children: /* @__PURE__ */ s.jsx(aa, {})
      }
    ) }),
    /* @__PURE__ */ s.jsx(nr, { ...St(t), placement: "bottom-end", children: /* @__PURE__ */ s.jsx(yt, { onClickAway: t.close, children: /* @__PURE__ */ s.jsx(qr, { className: Ce(He.drawer, He.appDrawer), children: /* @__PURE__ */ s.jsx("ul", { className: He.appList, children: o }) }) }) })
  ] });
};
zn.displayName = "AppsDrawer";
const zl = "_button_pyl2v_1", Ml = "_badge_pyl2v_7", $l = "_drawer_pyl2v_11", Wl = "_profileDrawer_pyl2v_24", Vl = "_avatar_pyl2v_32", Kl = "_workspace_pyl2v_38", ql = "_user_pyl2v_42", Hl = "_organization_pyl2v_43", Yl = "_info_pyl2v_52", Gl = "_skeleton_pyl2v_65", Jl = "_profileList_pyl2v_69", Ql = "_active_pyl2v_82", Zl = "_profileActions_pyl2v_96", Xl = "_noOrganizationAvailable_pyl2v_103", Re = {
  button: zl,
  badge: Ml,
  drawer: $l,
  profileDrawer: Wl,
  avatar: Vl,
  workspace: Kl,
  user: ql,
  organization: Hl,
  info: Yl,
  skeleton: Gl,
  profileList: Jl,
  active: Ql,
  profileActions: Zl,
  noOrganizationAvailable: Xl
}, Et = (t) => {
  const { variant: e = "allowedOrgs" } = t;
  return /* @__PURE__ */ s.jsxs(Nt, { href: "#", className: Ce(Re.organization, Re.skeleton), children: [
    /* @__PURE__ */ s.jsx(
      Ze,
      {
        variant: "circular",
        width: 40,
        height: 40,
        className: Re.avatar
      }
    ),
    /* @__PURE__ */ s.jsxs(R, { className: Re.info, children: [
      /* @__PURE__ */ s.jsx(Ze, { children: /* @__PURE__ */ s.jsx(
        be,
        {
          TypgraphyProps: {
            component: "h2",
            variant: "bodyMedium",
            weight: "demi",
            gutterBottom: !1
          },
          arrow: !0,
          children: "User Name - Proflie"
        }
      ) }),
      /* @__PURE__ */ s.jsxs(
        R,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ s.jsx(Ze, { children: /* @__PURE__ */ s.jsx(
              be,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: "userEmail@iqm.comuserEmail@iqm.com"
              }
            ) }),
            e === "allowedOrgs" && /* @__PURE__ */ s.jsx(
              Ze,
              {
                variant: "rounded",
                width: 18,
                height: 18,
                sx: { flexShrink: 0 },
                children: /* @__PURE__ */ s.jsx(Fe, { href: "/copyEmail", sx: { flexShrink: 0 }, size: "small", children: /* @__PURE__ */ s.jsx(sn, {}) })
              }
            )
          ]
        }
      ),
      e === "allowedOrgs" && /* @__PURE__ */ s.jsxs(
        R,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ s.jsx(Ze, { children: /* @__PURE__ */ s.jsx(
              A,
              {
                component: "label",
                variant: "bodySmall",
                gutterBottom: !1,
                sx: { textColor: "neutral-500", flexShrink: 0 },
                children: "Owner :"
              }
            ) }),
            /* @__PURE__ */ s.jsx(Ze, { children: /* @__PURE__ */ s.jsx(
              be,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: "Owner User Name"
              }
            ) })
          ]
        }
      )
    ] })
  ] });
}, gr = (t) => t.organizationType === "SUPER" || t.organizationType === "WORKSPACE" ? /* @__PURE__ */ s.jsx(
  ot,
  {
    color: "primary",
    overlap: "circular",
    variant: "dot",
    size: "small",
    badgeContent: /* @__PURE__ */ s.jsx(an, {}),
    classes: { badge: Re.badge },
    children: /* @__PURE__ */ s.jsx(
      ze,
      {
        size: t.size,
        className: Ce(Re.avatar, Re.workspace),
        src: t.src
      }
    )
  }
) : /* @__PURE__ */ s.jsx(ze, { size: t.size, className: Re.avatar, src: t.src }), Mn = (t) => t.customerType === "Advertiser" ? Be.ADVERTISER : t.customerType === "Workspace" ? Be.WORKSPACE : Be.SUPER, ec = (t) => {
  const { organizationDetails: e, prepareOrganizationSwitchingURL: r } = t, n = Mn(e), { copy: a } = ys(e.workspaceDomain);
  return /* @__PURE__ */ s.jsxs(
    Nt,
    {
      className: Ce(Re.organization),
      onClick: () => {
        const o = r(e);
        window.open(o, "_blank");
      },
      children: [
        /* @__PURE__ */ s.jsx(
          gr,
          {
            size: 40,
            organizationType: n,
            src: e == null ? void 0 : e.logoUrl
          }
        ),
        /* @__PURE__ */ s.jsxs(R, { className: Re.info, children: [
          /* @__PURE__ */ s.jsx(
            be,
            {
              TypgraphyProps: {
                component: "h2",
                variant: "bodyMedium",
                weight: "demi",
                gutterBottom: !1,
                align: "left"
              },
              arrow: !0,
              children: e == null ? void 0 : e.organizationName
            }
          ),
          /* @__PURE__ */ s.jsxs(
            R,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                width: 100,
                gap: 4
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  be,
                  {
                    TypgraphyProps: {
                      component: "h3",
                      variant: "bodySmall",
                      gutterBottom: !1
                    },
                    arrow: !0,
                    children: n === "WORKSPACE" ? e == null ? void 0 : e.workspaceDomain : e == null ? void 0 : e.workspaceOwnerOrganizationName
                  }
                ),
                n === "WORKSPACE" && /* @__PURE__ */ s.jsx(
                  Fe,
                  {
                    Component: "button",
                    sx: { flexShrink: 0 },
                    size: "small",
                    onClick: (o) => {
                      o.preventDefault(), o.stopPropagation(), a();
                    },
                    children: /* @__PURE__ */ s.jsx(sn, {})
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            R,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                width: 100,
                gap: 4
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  A,
                  {
                    component: "label",
                    variant: "bodySmall",
                    gutterBottom: !1,
                    sx: { textColor: "neutral-500", flexShrink: 0 },
                    children: "Owner :"
                  }
                ),
                /* @__PURE__ */ s.jsxs(
                  be,
                  {
                    TypgraphyProps: {
                      component: "h3",
                      variant: "bodySmall",
                      gutterBottom: !1
                    },
                    arrow: !0,
                    children: [
                      e == null ? void 0 : e.contactPersonName,
                      " (",
                      e == null ? void 0 : e.ownerUserEmail,
                      ")"
                    ]
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}, tc = (t) => {
  const e = Mn(t);
  return /* @__PURE__ */ s.jsxs(R, { className: Re.organization, children: [
    /* @__PURE__ */ s.jsx(
      gr,
      {
        size: 40,
        organizationType: e,
        src: t.logoUrl
      }
    ),
    /* @__PURE__ */ s.jsxs(R, { className: Re.info, children: [
      /* @__PURE__ */ s.jsx(
        be,
        {
          TypgraphyProps: {
            component: "h2",
            variant: "bodyMedium",
            weight: "demi",
            gutterBottom: !1
          },
          arrow: !0,
          children: t == null ? void 0 : t.organizationName
        }
      ),
      /* @__PURE__ */ s.jsxs(
        R,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ s.jsx(
              A,
              {
                component: "label",
                variant: "bodySmall",
                gutterBottom: !1,
                sx: { textColor: "neutral-500", flexShrink: 0 },
                children: "Owner :"
              }
            ),
            /* @__PURE__ */ s.jsxs(
              be,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: [
                  t == null ? void 0 : t.contactPersonName,
                  " (",
                  t == null ? void 0 : t.ownerUserEmail,
                  ")"
                ]
              }
            )
          ]
        }
      )
    ] })
  ] });
}, rc = () => /* @__PURE__ */ s.jsxs(
  R,
  {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      p: 12,
      textAlign: "center",
      height: 100
    },
    children: [
      /* @__PURE__ */ s.jsx(oa, { fontSize: 40, sx: { textColor: "neutral-500" } }),
      /* @__PURE__ */ s.jsx(
        A,
        {
          component: "h2",
          variant: "bodyMedium",
          weight: "demi",
          sx: { my: 8 },
          children: "No results found"
        }
      ),
      /* @__PURE__ */ s.jsx(A, { children: "We can't find any items matching your search" })
    ]
  }
), $n = () => {
  var T, G;
  const t = ht({
    variant: "popper",
    popupId: "profilePopper"
  }), { appMeta: e } = Ge(), [r, n] = u.useState(""), [a, o] = u.useState(void 0), l = u.useRef(!1), [i, c] = u.useState(!1), [m, y] = u.useState(null), p = Rt(r, 200), f = e.getAppData("My Profile");
  let I = "", b = "";
  f && (I = e.prepareAppSwitchingURL(f), b = e.prepareAppSwitchingURL(
    f,
    "/organizations"
  ));
  const w = Eo({
    isOrganizationAccess: !1,
    limit: 4,
    sortBy: "-lastActive",
    searchField: p
  });
  u.useEffect(() => {
    var F, X, z;
    (w.isLoading || w.isFetching) === !1 && l.current === !1 && (l.current = !0, o(((z = (X = (F = w == null ? void 0 : w.data) == null ? void 0 : F.pages) == null ? void 0 : X[0]) == null ? void 0 : z.data) ?? []));
  }, [
    w.isLoading,
    w.isFetching,
    w.data,
    a,
    o
  ]);
  const S = u.useMemo(() => {
    var F, X, z, W, V, C;
    return w.isFetching ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(Et, {}, 0),
      /* @__PURE__ */ s.jsx(Et, {}, 1),
      /* @__PURE__ */ s.jsx(Et, {}, 2)
    ] }) : (((z = (X = (F = w.data) == null ? void 0 : F.pages) == null ? void 0 : X[0]) == null ? void 0 : z.data.length) ?? 0) > 0 ? (C = (V = (W = w.data) == null ? void 0 : W.pages) == null ? void 0 : V[0]) == null ? void 0 : C.data.map((H) => /* @__PURE__ */ s.jsx(
      ec,
      {
        organizationDetails: H,
        prepareOrganizationSwitchingURL: e.prepareOrganizationSwitchingURL
      },
      H.owId
    )) : null;
  }, [
    w.isFetching,
    w.data,
    e.prepareOrganizationSwitchingURL
  ]);
  u.useEffect(() => {
    var F, X, z;
    w.data && m === null && (z = (X = (F = w == null ? void 0 : w.data) == null ? void 0 : F.pages) == null ? void 0 : X[0]) != null && z.currentOrganization && y(w.data.pages[0].currentOrganization);
  }, [y, w.data, m]);
  const N = ((a == null ? void 0 : a.length) ?? 0) <= 0, k = async () => {
    try {
      c(!0);
      const F = await mo();
      qe(F);
    } catch {
    } finally {
      c(!1), e.logout();
    }
  };
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(Te, { enterDelay: 1e3, title: e.organizationName, arrow: !0, children: /* @__PURE__ */ s.jsx(
      We,
      {
        variant: "text",
        color: "secondary",
        className: Re.button,
        startIcon: /* @__PURE__ */ s.jsx(
          gr,
          {
            size: 24,
            src: e.organizationLogo,
            organizationType: e.organizationType
          }
        ),
        ...kt(t),
        selected: t.isOpen,
        children: /* @__PURE__ */ s.jsx(A, { noWrap: !0, gutterBottom: !1, children: e.organizationName })
      }
    ) }),
    /* @__PURE__ */ s.jsx(nr, { ...St(t), placement: "bottom-end", children: /* @__PURE__ */ s.jsx(yt, { onClickAway: t.close, children: /* @__PURE__ */ s.jsxs(qr, { className: Ce(Re.drawer, Re.profileDrawer), children: [
      /* @__PURE__ */ s.jsxs(R, { className: Re.user, children: [
        /* @__PURE__ */ s.jsx(
          ze,
          {
            size: 64,
            color: "primary",
            className: Re.avatar,
            src: e.userAvatar
          }
        ),
        /* @__PURE__ */ s.jsxs(R, { className: Re.info, children: [
          /* @__PURE__ */ s.jsx(
            be,
            {
              TypgraphyProps: {
                component: "h2",
                variant: "bodyLarge",
                weight: "demi",
                gutterBottom: !1
              },
              arrow: !0,
              children: e.userDisplayName
            }
          ),
          /* @__PURE__ */ s.jsx(
            be,
            {
              TypgraphyProps: {
                component: "h3",
                variant: "bodySmall",
                sx: { mb: 4 }
              },
              arrow: !0,
              children: e.userEmail
            }
          ),
          /* @__PURE__ */ s.jsx(
            Vr,
            {
              href: I,
              sx: { textWeight: "demi" },
              children: "Manage my profile"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ s.jsx(R, { sx: { px: 12 }, children: m === null ? /* @__PURE__ */ s.jsx(Et, { variant: "currentOrg" }) : /* @__PURE__ */ s.jsx(tc, { ...m }) }),
      /* @__PURE__ */ s.jsx(Yt, { color: "secondary" }),
      N === !1 ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(R, { sx: { px: 12 }, children: /* @__PURE__ */ s.jsx(
          Te,
          {
            title: "Search other organization by name, email or ID",
            placement: "top",
            arrow: !0,
            children: /* @__PURE__ */ s.jsx(
              Ke,
              {
                variant: "outlinedDash",
                placeholder: "Search other organization by name, email or ID",
                InputProps: {
                  startAdornment: /* @__PURE__ */ s.jsx(Gr, {})
                },
                onChange: (F) => {
                  n(F.target.value);
                },
                defaultValue: r,
                fullWidth: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ s.jsx(R, { className: Re.profileList, children: (((G = (T = w.data) == null ? void 0 : T.pages[0]) == null ? void 0 : G.data.length) ?? 0) > 0 || w.isFetching ? S : /* @__PURE__ */ s.jsx(rc, {}) }),
        /* @__PURE__ */ s.jsx(Yt, { color: "secondary" })
      ] }) : null,
      /* @__PURE__ */ s.jsxs(
        R,
        {
          className: Ce(
            Re.profileActions,
            N && Re.noOrganizationAvailable
          ),
          children: [
            N === !1 ? /* @__PURE__ */ s.jsx(
              We,
              {
                variant: "outlined",
                Component: "a",
                href: b,
                children: "See all accesses"
              }
            ) : null,
            /* @__PURE__ */ s.jsx(We, { disabled: i, onClick: k, children: "Logout" })
          ]
        }
      )
    ] }) }) })
  ] });
};
$n.displayName = "ProfileDrawer";
const nc = (t = "") => {
  var e, r;
  return ((r = (e = t ?? "") == null ? void 0 : e.split(/[_,-]/)) == null ? void 0 : r[0]) ?? "";
}, sc = u.forwardRef(
  function(e, r) {
    var I, b, w, S, N, k, T, G;
    const {
      className: n,
      classes: a,
      children: o,
      sx: l,
      appLogo: i,
      hideAppName: c = !1,
      ...m
    } = e, { appMeta: y } = Ge(), p = At();
    if (ws(y == null ? void 0 : y.favicon), vs(((I = p == null ? void 0 : p.rootProps) == null ? void 0 : I.appName) ?? ""), !p || !y)
      return /* @__PURE__ */ s.jsx(
        R,
        {
          ref: r,
          className: Ce(Qe.root, a == null ? void 0 : a.root, n, je(l)),
          ...m,
          children: "Did you import the AppRootProvier and AppProvider Context"
        }
      );
    const f = i ?? p.rootProps.appLogo ?? /* @__PURE__ */ s.jsx(gt, {});
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsxs(
        R,
        {
          ref: r,
          className: Ce(Qe.root, a == null ? void 0 : a.root, n, je(l)),
          ...m,
          children: [
            /* @__PURE__ */ s.jsx(
              Te,
              {
                title: (b = p == null ? void 0 : p.rootProps) != null && b.appVersion ? `${(w = p == null ? void 0 : p.rootProps) == null ? void 0 : w.appName} - ${nc((S = p == null ? void 0 : p.rootProps) == null ? void 0 : S.appVersion)}` : "",
                arrow: !0,
                children: /* @__PURE__ */ s.jsxs(
                  Nt,
                  {
                    href: (N = p == null ? void 0 : p.rootProps) == null ? void 0 : N.appLink,
                    disableRipple: !0,
                    className: Qe.title,
                    children: [
                      f && /* @__PURE__ */ s.jsx(R, { Component: "span", className: Qe.icon, children: f }),
                      ((k = p == null ? void 0 : p.rootProps) == null ? void 0 : k.appName) && !c && /* @__PURE__ */ s.jsx(
                        A,
                        {
                          component: "h1",
                          variant: "h5",
                          weight: "bold",
                          gutterBottom: !1,
                          children: (T = p == null ? void 0 : p.rootProps) == null ? void 0 : T.appName
                        }
                      ),
                      ((G = p == null ? void 0 : p.rootProps) == null ? void 0 : G.isAppBeta) && /* @__PURE__ */ s.jsx(
                        Ve,
                        {
                          Component: "span",
                          color: "secondary",
                          label: "BETA",
                          size: "exSmall",
                          className: Qe.beta
                        }
                      )
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx(R, { className: Ce(Qe.content, a == null ? void 0 : a.content), children: o }),
            /* @__PURE__ */ s.jsxs(R, { className: Qe.nav, children: [
              /* @__PURE__ */ s.jsx(El, {}),
              /* @__PURE__ */ s.jsx(oc, {}),
              /* @__PURE__ */ s.jsx(ac, {}),
              /* @__PURE__ */ s.jsx(zn, {}),
              /* @__PURE__ */ s.jsx($n, {})
            ] })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(Cl, {})
    ] });
  }
);
sc.displayName = "AppBar";
const ac = () => {
  const { appMeta: t } = Ge(), e = t.getAppData("Marketplace");
  let r = "";
  return e && (r = t.prepareAppSwitchingURL(e)), /* @__PURE__ */ s.jsx(Te, { title: "Home", arrow: !0, children: /* @__PURE__ */ s.jsx(Fe, { color: "secondary", Component: "a", href: r, children: /* @__PURE__ */ s.jsx(ia, {}) }) });
}, oc = () => {
  const { appMeta: t } = Ge();
  return (t.appHelpURL.length ?? 0) > 0 && /* @__PURE__ */ s.jsx(Te, { title: "Support", arrow: !0, children: /* @__PURE__ */ s.jsx(
    Fe,
    {
      color: "secondary",
      Component: "a",
      href: t.appHelpURL,
      target: "_blank",
      children: /* @__PURE__ */ s.jsx(la, {})
    }
  ) });
}, ic = "_root_1dkbb_1", lc = {
  root: ic
}, cc = u.forwardRef(function(e, r) {
  const {
    className: n,
    classes: a,
    children: o,
    Component: l = "div",
    sx: i,
    ...c
  } = e;
  return /* @__PURE__ */ s.jsx(
    l,
    {
      className: Ce(lc.root, a == null ? void 0 : a.root, n, je(i)),
      ref: r,
      ...c,
      children: o
    }
  );
});
cc.displayName = "NotificationBar";
const dc = "_icons_g3lp7_1", uc = "_avatarWrapper_g3lp7_6", pc = "_avatar_g3lp7_6", fc = "_workspace_g3lp7_15", gc = "_advertiser_g3lp7_18", ft = {
  icons: dc,
  avatarWrapper: uc,
  avatar: pc,
  workspace: fc,
  advertiser: gc
}, mc = {
  Pending: /* @__PURE__ */ s.jsx(Xr, { color: "warning" }),
  Active: /* @__PURE__ */ s.jsx(ca, { color: "success" }),
  Invited: /* @__PURE__ */ s.jsx(da, { color: "warning" }),
  Suspended: /* @__PURE__ */ s.jsx(en, { color: "warning" }),
  Rejected: /* @__PURE__ */ s.jsx(nn, { color: "error" })
}, hc = Oe.DefaultListOptionItemWrapper({
  disableCheckbox: !1,
  disableRowExpansion: !1,
  selectionStyle: "all",
  arrowPosition: "right"
}), yc = (t) => {
  const e = (
    // @ts-ignore
    mc[t.original.status]
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(R, { className: ft.avatarWrapper, children: t.original.type === "workspace" ? /* @__PURE__ */ s.jsx(
      ot,
      {
        color: "primary",
        overlap: "circular",
        variant: "dot",
        size: "small",
        badgeContent: /* @__PURE__ */ s.jsx(an, {}),
        children: /* @__PURE__ */ s.jsx(
          ze,
          {
            size: 36,
            className: Ce(ft.avatar, ft.workspace),
            src: t.original.logoUrl
          }
        )
      }
    ) : /* @__PURE__ */ s.jsx(
      ze,
      {
        size: 36,
        className: Ce(ft.avatar, ft.advertiser),
        src: t.original.logoUrl
      }
    ) }),
    /* @__PURE__ */ s.jsxs(
      R,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          ml: 8,
          overflow: "hidden",
          width: 100
        },
        children: [
          /* @__PURE__ */ s.jsx(
            be,
            {
              TypgraphyProps: {
                weight: "demi"
              },
              arrow: !0,
              children: t.original.label
            }
          ),
          /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
            /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", alignItems: "center", gap: 4 }, children: [
              /* @__PURE__ */ s.jsx(
                A,
                {
                  variant: "label",
                  weight: "demi",
                  lineHeight: "single-line",
                  sx: { textColor: "neutral-500" },
                  children: "ID"
                }
              ),
              /* @__PURE__ */ s.jsx(
                A,
                {
                  component: "span",
                  variant: "label",
                  lineHeight: "single-line",
                  children: t.original.value
                }
              )
            ] }),
            /* @__PURE__ */ s.jsx(
              A,
              {
                sx: { textColor: "neutral-400" },
                lineHeight: "single-line",
                children: "•"
              }
            ),
            /* @__PURE__ */ s.jsxs(
              R,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 14
                },
                children: [
                  e,
                  /* @__PURE__ */ s.jsx(
                    A,
                    {
                      variant: "label",
                      component: "span",
                      lineHeight: "single-line",
                      children: t.original.status
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    )
  ] });
}, gd = () => u.useRef({}), wc = u.forwardRef((t, e) => {
  var J, ce;
  const {
    userType: r = "SUPER",
    filters: n,
    multiple: a = !1,
    slotProps: o,
    /* @ts-ignore */
    apiType: l,
    loggedInOwId: i,
    onChange: c,
    enableLocalSearch: m = !1,
    enableLazyLoading: y = !0,
    TextFieldProps: p,
    getOptionDisabled: f,
    initialData: I,
    allowParentNodeSelection: b,
    ...w
  } = t;
  let { initialData: S } = t;
  const N = It((O, g, P) => {
    c == null || c(O, g, P);
  }), k = u.useState(() => t.userType === "WORKSPACE" || t.userType === "SUPER" && t.apiType === "multiLevel" ? 0 : t.userType === "SUPER" && t.apiType === "workspace" ? 1 : 0)[0], T = Oe.useSelectAdvanceApiRef(), [G, F] = u.useState(""), X = Rt(G, 250), [z, W] = u.useState(
    Er(S)
  ), V = u.useRef(z);
  V.current = z;
  const C = u.useRef(
    new Map(Object.entries(S ?? {}))
  ), [H, oe] = u.useState(!1), re = u.useCallback(
    (O) => {
      F(O), oe(!1);
    },
    [F]
  ), {
    data: Q,
    isLoading: ie,
    isFetching: xe,
    fetchNextPage: ne
  } = ro(
    {
      ...n,
      limit: xa,
      searchField: m ? void 0 : X,
      isSelectAll: y ? H : !0
    },
    {
      enabled: k === 0
      /* multiLevel */
    }
  ), {
    data: D,
    isLoading: M,
    isFetching: he
  } = no(
    {
      ...n,
      searchField: m ? void 0 : X
    },
    {
      enabled: k === 1
      /* workspace */
    }
  ), pe = u.useMemo(() => {
    var O, g, P, U, K, $, me, ye;
    if (r === "WORKSPACE" && k === 0)
      return (g = (O = Q == null ? void 0 : Q.pages) == null ? void 0 : O[0]) != null && g.data[0] ? ((U = (P = Q == null ? void 0 : Q.pages) == null ? void 0 : P[0]) == null ? void 0 : U.data[0].value) === `${i}` ? ((me = ($ = (K = Q == null ? void 0 : Q.pages) == null ? void 0 : K[0]) == null ? void 0 : $.data[0]) == null ? void 0 : me.subRows) ?? [] : [] : [];
    {
      let we = !1;
      return ((ye = Q == null ? void 0 : Q.pages) == null ? void 0 : ye.reduce((Ee, se) => {
        let Ne = se.data;
        return we === !1 && (Ne = se.data.filter(
          (Me) => Me.value !== `${i}`
        ), Ne.length !== se.data.length && (we = !0)), [...Ee, ...Ne];
      }, [])) ?? [];
    }
  }, [Q, r, k, i]), Ie = u.useMemo(
    () => ((D == null ? void 0 : D.data) ?? []).filter(
      (O) => O.value !== `${i}`
    ),
    [D, i]
  ), Y = k === 0 ? pe : Ie, h = k === 0 ? ie : M, B = k === 0 ? xe : he;
  u.useEffect(() => {
    if (k === 0 && H && Y.length > 0) {
      const O = {};
      C.current.clear(), Y.forEach((g) => {
        var P, U;
        if ((((P = g.subRows) == null ? void 0 : P.length) ?? 0) > 0)
          (U = g.subRows) == null || U.forEach((K) => {
            ((f == null ? void 0 : f(K)) ?? !1) === !0 && !(S != null && S[K.value]) || (O[K.value] = !0, C.current.set(K.value, K));
          }), b && (O[g.value] = !0, C.current.set(g.value, g));
        else {
          if (((f == null ? void 0 : f(g)) ?? !1) === !0 && !(S != null && S[g.value]))
            return;
          O[g.value] = !0, C.current.set(g.value, g);
        }
      }), W(O), V.current = O, N(
        Object.fromEntries(C.current.entries()),
        "userAction",
        !0
      );
    }
  }, [
    k,
    H,
    Y,
    S,
    f,
    N,
    b
  ]);
  const te = u.useMemo(() => {
    if (!(h || B)) {
      if (!Array.isArray(Y))
        return "error";
      if (((Y == null ? void 0 : Y.length) ?? 0) <= 0)
        return G ? "noResult" : "noRows";
    }
  }, [Y, h, B, G]), le = () => {
    const O = C.current.entries(), g = T.current.tableInstance.getRowModel().rowsById, P = {};
    for (const U of O) {
      const [K, $] = U;
      g[K] && (P[K] = $);
    }
    return P;
  }, j = (O) => {
    var we, Ee;
    const g = typeof O == "function" ? O(z) : O;
    if (a === !1) {
      const se = Object.keys(g)[0], Me = (we = T.current.tableInstance.getRowModel().rowsById[se]) == null ? void 0 : we.original;
      C.current.clear(), C.current.set(se, Me), W(O), N(
        Object.fromEntries(C.current.entries()),
        "userAction"
      );
      return;
    }
    const P = Object.keys(g), U = le(), K = Object.keys(U), $ = T.current.tableInstance.getRowModel().rowsById, me = P.filter(
      (se) => U[se] === void 0
    ), ye = K.filter(
      (se) => g[se] === void 0
    );
    for (const se of me)
      (Ee = $[se]) != null && Ee.original && C.current.set(se, $[se].original);
    for (const se of ye)
      C.current.delete(se);
    W(O), N(
      Object.fromEntries(C.current.entries()),
      "userAction"
    );
  }, _ = (O) => {
    C.current.delete(O);
    const g = { ...z };
    delete g[O], W(g), N(
      Object.fromEntries(C.current.entries()),
      "apiAction"
    );
  }, x = (O) => {
    try {
      const g = T.current.tableInstance.getRow(O);
      g && (C.current.set(g.id, g.original), W({ ...z, [g.id]: !0 }), N(
        Object.fromEntries(C.current.entries()),
        "apiAction"
      ));
    } catch (g) {
      console.log(g), console.log("cannot add row that is not part of current dataset");
    }
  }, L = (O) => {
    S = O;
    const g = Er(S);
    C.current = new Map(
      Object.entries(S ?? {})
    ), W(g), V.current = g;
  }, q = () => {
    re("");
    const O = /* @__PURE__ */ new Map(), g = {};
    for (const P of C.current.entries()) {
      const [U, K] = P;
      ((f == null ? void 0 : f(K)) ?? !1) === !0 && (O.set(U, K), g[U] = !0);
    }
    W(g), V.current = g, C.current = O;
  };
  return u.useImperativeHandle(e, () => ({
    getRowSelection: () => V.current,
    getRowSelectionData: () => C.current,
    getCurrentData: () => Y,
    removeSelection: _,
    setSelection: x,
    reinitializeRowSelection: L,
    setSearch: re,
    selectAll: () => oe(!0),
    reset: q
  })), /* @__PURE__ */ s.jsx(
    Ke,
    {
      ...p,
      select: "advanceSelect",
      placeholder: "Select Customer",
      SelectProps: {
        slotProps: {
          ...o,
          InputBaseProps: {
            placeholder: "Search by Organization, Customer ID, Status or Email",
            ...o == null ? void 0 : o.InputBaseProps
          }
        },
        allowParentNodeSelection: b,
        ...w,
        getOptionDisabled: f,
        data: Y ?? [],
        apiRef: T,
        inputValue: G,
        multiple: a,
        loading: h || B,
        enableSubRowSelection: !0,
        getSubRows: (O) => {
          var g;
          return (((g = O.subRows) == null ? void 0 : g.length) ?? 0) > 0 ? O.subRows : void 0;
        },
        getRowCanExpand: (O) => {
          var g, P;
          return (((P = (g = O.original) == null ? void 0 : g.subRows) == null ? void 0 : P.length) ?? 0) > 0;
        },
        overlay: te,
        onInputChange: (O, g, P) => {
          P !== "reset" && re(g);
        },
        ...r === "SUPER" && k === 0 ? {
          rowCount: y === !0 ? (((ce = (J = Q == null ? void 0 : Q.pages) == null ? void 0 : J[0]) == null ? void 0 : ce.filteredRecords) ?? 1) - 1 : (Y == null ? void 0 : Y.length) ?? 5,
          onFetchRows: () => ne()
        } : {},
        renderValue: () => {
          const O = Object.keys(V.current);
          if (a)
            return O.length ? `${O.length} Selected` : "​";
          {
            const g = O[0] ?? "", P = C.current.get(g);
            return /* @__PURE__ */ s.jsx(
              be,
              {
                TypgraphyProps: {
                  component: "span"
                },
                children: (P == null ? void 0 : P.label) ?? "​"
              }
            );
          }
        },
        renderListItem: hc,
        renderOption: ({ row: O }) => yc(O),
        onSelectAll: (O) => {
          O && oe(!0);
        },
        onClearAll: () => {
          setTimeout(() => {
            const O = /* @__PURE__ */ new Map(), g = {};
            for (const P of C.current.entries()) {
              const [U, K] = P;
              ((f == null ? void 0 : f(K)) ?? !1) === !0 && (O.set(U, K), g[U] = !0);
            }
            W(g), V.current = g, C.current = O, N(
              Object.fromEntries(C.current.entries()),
              "userAction"
            );
          }, 0);
        }
      },
      value: z,
      onChange: j
    }
  );
});
wc.displayName = "CustomerDropdown";
function Vt(t) {
  return {
    id: `new_payment_${t}`,
    "aria-controls": `new_payment_${t}`
  };
}
const vc = (t) => {
  const { value: e, paymentFee: r, onChange: n } = t;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(A, { component: "p", variant: "span", weight: "demi", children: "Make the payment via" }),
    /* @__PURE__ */ s.jsxs(
      A,
      {
        component: "p",
        variant: "label",
        sx: { mb: 8, textColor: "neutral-600" },
        children: [
          r,
          "% fee will be levied by the payment partner"
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      rr,
      {
        value: e,
        onChange: (a, o) => {
          n(o);
        },
        "aria-label": "payment tabs",
        size: "medium",
        variant: "pill",
        classes: {
          flexContainer: je({
            flexWrap: "wrap"
          })
        },
        gap: 8,
        children: [
          /* @__PURE__ */ s.jsx(
            at,
            {
              value: "Credit Card",
              icon: /* @__PURE__ */ s.jsx(jr, {}),
              iconPosition: "start",
              sx: { flexGrow: 1, justifyContent: "start" },
              label: /* @__PURE__ */ s.jsx(
                A,
                {
                  sx: {
                    display: "flex",
                    gap: 4,
                    alignItems: "center"
                  },
                  children: "Credit Card"
                }
              ),
              ...Vt(0)
            }
          ),
          /* @__PURE__ */ s.jsx(
            at,
            {
              value: "Debit Card",
              icon: /* @__PURE__ */ s.jsx(jr, {}),
              iconPosition: "start",
              sx: { flexGrow: 1, justifyContent: "start" },
              label: /* @__PURE__ */ s.jsx(
                A,
                {
                  sx: {
                    display: "flex",
                    gap: 4,
                    alignItems: "center"
                  },
                  children: "Debit Card"
                }
              ),
              ...Vt(1)
            }
          ),
          /* @__PURE__ */ s.jsx(
            at,
            {
              value: "PayPal",
              style: { maxWidth: 150 },
              icon: /* @__PURE__ */ s.jsx(ua, {}),
              iconPosition: "start",
              sx: { flexGrow: 1, justifyContent: "start" },
              label: /* @__PURE__ */ s.jsx(
                A,
                {
                  sx: {
                    display: "flex",
                    gap: 4,
                    alignItems: "center"
                  },
                  children: "PayPal"
                }
              ),
              ...Vt(2)
            }
          )
        ]
      }
    )
  ] });
};
function zr(t) {
  return {
    id: `paid_payment_${t}`,
    "aria-controls": `paid_payment_${t}`
  };
}
const xc = (t) => {
  const { value: e, onChange: r } = t;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(A, { component: "p", variant: "span", weight: "demi", sx: { mb: 8 }, children: [
      "Already paid via",
      /* @__PURE__ */ s.jsx(
        Ve,
        {
          variant: "filled",
          sx: { ml: 8 },
          size: "small",
          color: "secondary",
          icon: /* @__PURE__ */ s.jsx(pa, {}),
          label: /* @__PURE__ */ s.jsx(A, { variant: "label", weight: "normal", children: "Coming Soon" })
        }
      )
    ] }),
    /* @__PURE__ */ s.jsxs(
      rr,
      {
        value: e,
        onChange: (n, a) => {
          r == null || r(a);
        },
        "aria-label": "payment tabs",
        size: "medium",
        variant: "pill",
        gap: 8,
        children: [
          /* @__PURE__ */ s.jsx(
            at,
            {
              value: "Check",
              style: { flex: 1 },
              disabled: !0,
              icon: /* @__PURE__ */ s.jsx(fa, {}),
              iconPosition: "start",
              sx: { justifyContent: "start" },
              label: /* @__PURE__ */ s.jsx(
                A,
                {
                  sx: {
                    display: "flex",
                    gap: 4,
                    alignItems: "center"
                  },
                  children: "Check"
                }
              ),
              ...zr(3)
            },
            1
          ),
          /* @__PURE__ */ s.jsx(
            at,
            {
              value: "Wire transfer",
              disabled: !0,
              style: { flex: 1 },
              icon: /* @__PURE__ */ s.jsx(Ft, {}),
              iconPosition: "start",
              sx: { justifyContent: "start" },
              label: /* @__PURE__ */ s.jsx(
                A,
                {
                  sx: {
                    display: "flex",
                    gap: 4,
                    alignItems: "center"
                  },
                  children: "Wire Transfer"
                }
              ),
              ...zr(4)
            },
            2
          )
        ]
      }
    )
  ] });
}, Ic = async ({
  queryKey: t,
  signal: e
}) => {
  var a;
  t[0];
  const { CancelToken: r } = Le, n = r.source();
  e == null || e.addEventListener("abort", () => {
    n.cancel("v3/fa/basic/details - Request cancelled");
  });
  try {
    return (await ve().get("/v3/fa/basic/details", {
      cancelToken: n.token
    })).data.data;
  } catch (o) {
    return Promise.reject((a = o == null ? void 0 : o.response) == null ? void 0 : a.data);
  }
}, bc = async (t) => {
  var e;
  try {
    const r = new FormData();
    return Object.keys(t).forEach((a) => {
      const o = t[a];
      r.append(a, o instanceof Blob ? o : `${o}`);
    }), r.append(
      "paymentDate",
      new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).format(Date.now())
      // date format needed in the YYYY-MM-DD
    ), t.paymentMode && [st.PayPal, st["Credit Card"]].includes(
      t.paymentMode
    ) ? (await ve().post("/v3/fa/paypal/payment", {
      paymentAmount: t.paymentAmount
    })).data : (await ve().post("/v3/fa/payment/add-fund", r, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })).data;
  } catch (r) {
    return Promise.reject((e = r == null ? void 0 : r.response) == null ? void 0 : e.data);
  }
}, Sc = (t) => {
  var e, r;
  return qe(
    (r = (e = t == null ? void 0 : t.errorObjects) == null ? void 0 : e[0]) != null && r.error ? t.errorObjects[0].error : "Something went wrong. Please try after sometime.",
    {
      variant: "error"
    }
  );
}, Rc = () => ke(
  Ha.keys({ scope: "getPayPalFees" }),
  Ic,
  {
    onError: Sc,
    keepPreviousData: !0
  }
), jc = (t) => Rs({
  mutationFn: bc,
  mutationKey: ["addFund"],
  onSuccess: t == null ? void 0 : t.onSuccess,
  onError: t == null ? void 0 : t.onError,
  onSettled: (r, n, a) => {
    var o;
    (o = t == null ? void 0 : t.onSettled) == null || o.call(t, r, n, a);
  }
}), Kt = (t, e) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: e ?? "USD",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
}).format(t), Ac = (t, e) => new Intl.NumberFormat("en-US", {
  ...e
}).format(t), Lc = (t) => {
  const { amount: e, charge: r, mode: n } = t, a = e * r / 100;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(A, { component: "p", sx: { mb: 4 }, children: "You are about to add the following funds:" }),
    /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", justifyContent: "between", mb: 4 }, children: [
      /* @__PURE__ */ s.jsx(A, { children: "Payable Amount" }),
      /* @__PURE__ */ s.jsx(A, { weight: "demi", children: Kt(e) })
    ] }),
    /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", justifyContent: "between" }, children: [
      /* @__PURE__ */ s.jsxs(A, { children: [
        n,
        " fees (",
        r,
        "%)"
      ] }),
      /* @__PURE__ */ s.jsxs(A, { weight: "demi", children: [
        "- ",
        Kt(a)
      ] })
    ] }),
    /* @__PURE__ */ s.jsx(Yt, { color: "secondary", sx: { my: 4 } }),
    /* @__PURE__ */ s.jsxs(R, { sx: { display: "flex", justifyContent: "between" }, children: [
      /* @__PURE__ */ s.jsx(A, { weight: "demi", children: "Net Funds" }),
      /* @__PURE__ */ s.jsx(A, { weight: "demi", children: Kt(e - a) })
    ] })
  ] });
}, st = {
  "Credit Card": 5,
  "Debit Card": 5,
  PayPal: 1,
  Check: 2,
  "Wire transfer": 3
}, md = (t) => {
  const { onClose: e, owId: r } = t, [n, a] = u.useState(""), [o, l] = u.useState(null), { data: i, isFetching: c } = Rc(), m = u.useMemo(() => (i == null ? void 0 : i.paypalFeesPercentage) ?? 0, [i]), y = jc({
    onSuccess: (b, w) => {
      w.paymentMode && [
        st.PayPal,
        st["Credit Card"],
        st["Debit Card"]
      ].includes(w.paymentMode) && b.data && window.open(b.data, "_blank"), e();
    }
  }), p = () => {
    const b = st[o], w = {
      owId: r,
      paymentMode: b,
      paymentAmount: Number(n)
    };
    y.mutate(w);
  }, f = !Number(n) || !(o != null && o.length), I = y.isLoading || f;
  return /* @__PURE__ */ s.jsx(
    "form",
    {
      style: { height: "100%" },
      onSubmit: (b) => {
        b.preventDefault(), b.stopPropagation(), p();
      },
      children: /* @__PURE__ */ s.jsxs(
        R,
        {
          style: { width: 369 },
          sx: {
            display: "flex",
            flexDirection: "column",
            height: 100,
            overflow: "auto"
          },
          children: [
            /* @__PURE__ */ s.jsx(xs, { onClose: e, children: "Add Funds" }),
            /* @__PURE__ */ s.jsx(Kr, { dividers: !0, children: c ? /* @__PURE__ */ s.jsx(
              Rr,
              {
                sx: {
                  height: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  my: "auto"
                },
                children: /* @__PURE__ */ s.jsx(Is, { size: 64, thickness: 3 })
              }
            ) : /* @__PURE__ */ s.jsxs(
              Rr,
              {
                sx: { display: "flex", flexDirection: "column", p: 0, gap: 32 },
                children: [
                  /* @__PURE__ */ s.jsx(Lt, { children: /* @__PURE__ */ s.jsx(Pt, { children: /* @__PURE__ */ s.jsx(
                    Ke,
                    {
                      placeholder: "Enter Here",
                      label: "Enter Amount",
                      type: "number",
                      onBlur: () => {
                        const b = n.length ? Ac(Number(n), {
                          useGrouping: !1,
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) : "";
                        a(String(b));
                      },
                      variant: "outlined",
                      value: n,
                      sx: { ml: "auto", width: 100 },
                      helperText: "The fund added will be inclusive of taxes",
                      onChange: (b) => {
                        if (parseFloat(b.target.value) < 0)
                          return;
                        const w = b.target.value;
                        a(w);
                      }
                    }
                  ) }) }),
                  /* @__PURE__ */ s.jsx(Lt, { children: /* @__PURE__ */ s.jsx(Pt, { children: /* @__PURE__ */ s.jsx(
                    vc,
                    {
                      value: o,
                      paymentFee: m,
                      onChange: (b) => {
                        l(b);
                      }
                    }
                  ) }) }),
                  /* @__PURE__ */ s.jsx(Lt, { children: /* @__PURE__ */ s.jsx(Pt, { children: /* @__PURE__ */ s.jsx(xc, { value: o }) }) }),
                  n && o ? /* @__PURE__ */ s.jsx(Lt, { children: /* @__PURE__ */ s.jsx(Pt, { children: /* @__PURE__ */ s.jsx(
                    Lc,
                    {
                      amount: Number(n),
                      charge: m,
                      mode: o
                    }
                  ) }) }) : null
                ]
              }
            ) }),
            /* @__PURE__ */ s.jsxs(bs, { children: [
              /* @__PURE__ */ s.jsx(We, { onClick: () => e(), color: "secondary", children: "Cancel" }),
              /* @__PURE__ */ s.jsx(
                Ut,
                {
                  type: "submit",
                  loading: y.isLoading,
                  disabled: I,
                  children: "Proceed to Pay"
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, Pc = "_icons_1c6xj_1", Cc = "_status_1c6xj_6", qt = {
  icons: Pc,
  status: Cc
}, Mr = {
  1: {
    label: "Active",
    key: "active",
    iconName: "Ready"
  },
  2: {
    label: "Expired",
    key: "expired",
    iconName: "Expired"
  },
  3: {
    label: "Deleted",
    key: "deleted",
    iconName: "Deleted"
  }
}, Ec = {
  active: /* @__PURE__ */ s.jsx(ga, { sx: { flexShrink: 0 }, color: "info" }),
  expired: /* @__PURE__ */ s.jsx(tn, { sx: { flexShrink: 0 }, color: "warning" }),
  deleted: /* @__PURE__ */ s.jsx(rn, { sx: { flexShrink: 0 }, color: "warning" })
}, Oc = Oe.DefaultListOptionItemWrapper({
  disableCheckbox: !0,
  disableRowExpansion: !0,
  selectionStyle: "all"
}), kc = (t) => {
  const e = (
    // @ts-ignore
    Ec[Mr[t.original.ioStatusId].key]
  );
  return /* @__PURE__ */ s.jsxs(
    R,
    {
      sx: {
        display: "flex",
        alignItems: "start",
        overflow: "hidden",
        width: 100
      },
      children: [
        t.original.ioBudgetTypeId === 1 ? /* @__PURE__ */ s.jsx(
          Qr,
          {
            color: "primary",
            sx: { flexShrink: 0 },
            className: qt.icons
          }
        ) : /* @__PURE__ */ s.jsx(
          Zr,
          {
            color: "primary",
            sx: { flexShrink: 0 },
            className: qt.icons
          }
        ),
        /* @__PURE__ */ s.jsxs(
          R,
          {
            sx: {
              display: "flex",
              flexDirection: "column",
              ml: 8,
              overflow: "hidden",
              width: 100
            },
            children: [
              /* @__PURE__ */ s.jsx(
                be,
                {
                  TypgraphyProps: {
                    weight: "demi"
                  },
                  arrow: !0,
                  placement: "top",
                  children: t.original.ioName
                }
              ),
              /* @__PURE__ */ s.jsxs(
                R,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    overflow: "hidden"
                  },
                  children: [
                    /* @__PURE__ */ s.jsxs(
                      R,
                      {
                        sx: {
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          overflow: "hidden"
                        },
                        children: [
                          /* @__PURE__ */ s.jsx(
                            A,
                            {
                              variant: "label",
                              weight: "demi",
                              sx: { textColor: "neutral-500", flexShrink: 0 },
                              children: "ID"
                            }
                          ),
                          /* @__PURE__ */ s.jsx(
                            be,
                            {
                              TypgraphyProps: {
                                component: "span",
                                variant: "label"
                              },
                              arrow: !0,
                              placement: "top",
                              children: t.original.ioId
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ s.jsx(A, { sx: { textColor: "neutral-400", flexShrink: 0 }, children: "•" }),
                    /* @__PURE__ */ s.jsxs(
                      R,
                      {
                        sx: {
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          fontSize: 14,
                          overflow: "hidden"
                        },
                        children: [
                          e,
                          /* @__PURE__ */ s.jsx(
                            be,
                            {
                              TypgraphyProps: {
                                className: qt.status,
                                component: "span",
                                variant: "label"
                              },
                              arrow: !0,
                              placement: "top",
                              children: Mr[t.original.ioStatusId].label ?? ""
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, $r = (t) => {
  const e = {};
  for (const [r] of Object.entries(t ?? {}))
    e[r] = !0;
  return e;
}, Dc = u.forwardRef((t, e) => {
  const {
    TextFieldProps: r,
    multiple: n = !1,
    slotProps: a,
    prepopulate: o = !1,
    enabled: l = !0,
    enableLocalSearch: i = !1,
    enableLazyLoading: c = !0,
    params: m,
    onChange: y,
    getOptionDisabled: p,
    initialData: f,
    // not using this
    ...I
  } = t;
  let { initialData: b } = t;
  const [w, S] = u.useState(""), [N, k] = u.useState(
    $r(b)
  ), [T, G] = u.useState(!1), F = u.useState(0)[1], X = Oe.useSelectAdvanceApiRef(), z = u.useRef(N);
  z.current = N;
  const W = u.useRef(!1), V = u.useRef(!1), C = u.useRef(
    new Map(Object.entries(b ?? {}))
  ), H = Rt(w, 250), oe = It((j, _, x) => {
    y == null || y(j, _, x);
  }), re = u.useCallback(
    (j) => {
      S(j), G(!1);
    },
    [S]
  ), {
    data: Q,
    isLoading: ie,
    isFetching: xe,
    fetchNextPage: ne
  } = ko(
    {
      ...m,
      noOfEntries: 50,
      searchField: i ? void 0 : H,
      isSelectAll: c ? T : !0
    },
    {
      enabled: l
    }
  ), D = u.useMemo(() => {
    var j;
    return ((j = Q == null ? void 0 : Q.pages) == null ? void 0 : j.reduce((_, x) => [..._, ...(x == null ? void 0 : x.ioBasicDetailsList) ?? []], [])) ?? [];
  }, [Q]), M = u.useRef(D);
  M.current = D;
  const he = u.useMemo(
    () => {
      var j;
      return ((j = Q == null ? void 0 : Q.pages[0]) == null ? void 0 : j.filteredRecords) ?? 0;
    },
    [Q]
  ), pe = u.useMemo(() => {
    if (!(ie || xe)) {
      if (!Array.isArray(D))
        return "error";
      if (((D == null ? void 0 : D.length) ?? 0) <= 0)
        return w ? "noResult" : "noRows";
    }
  }, [D, ie, xe, w]), Ie = () => {
    const j = C.current.entries(), _ = X.current.tableInstance.getRowModel().rowsById, x = {};
    for (const L of j) {
      const [q, J] = L;
      _[q] && (x[q] = J);
    }
    return x;
  }, Y = (j) => {
    var g, P;
    const _ = typeof j == "function" ? j(N) : j;
    if (n === !1) {
      const U = Object.keys(_)[0], $ = (g = X.current.tableInstance.getRowModel().rowsById[U]) == null ? void 0 : g.original;
      C.current.clear(), C.current.set(U, $), k(j), oe(
        Object.fromEntries(C.current.entries()),
        "userAction"
      );
      return;
    }
    const x = Object.keys(_), L = Ie(), q = Object.keys(L), J = X.current.tableInstance.getRowModel().rowsById, ce = x.filter(
      (U) => L[U] === void 0
    ), O = q.filter(
      (U) => _[U] === void 0
    );
    for (const U of ce)
      (P = J[U]) != null && P.original && C.current.set(U, J[U].original);
    for (const U of O)
      C.current.delete(U);
    k(j), oe(
      Object.fromEntries(C.current.entries()),
      "userAction"
    );
  };
  u.useEffect(() => {
    if (T && D.length > 0) {
      const j = {};
      C.current.clear(), D.forEach((_) => {
        ((p == null ? void 0 : p(_)) ?? !1) === !0 && !(b != null && b[_.ioId]) || (j[_.ioId] = !0, C.current.set(String(_.ioId), _));
      }), k(j), z.current = j, oe(
        Object.fromEntries(C.current.entries()),
        "userAction",
        !0
      );
    }
  }, [T, D, b, p, oe]), u.useEffect(() => {
    var j, _, x;
    if (o === !1) {
      V.current = !0;
      return;
    } else if (b && W.current === !1 && V.current === !1) {
      W.current = !0, V.current = !0;
      return;
    } else if (D.length > 0 && V.current === !1) {
      for (let L = 0; L < ((D == null ? void 0 : D.length) ?? 0); L++)
        if ((((_ = (j = D[L]) == null ? void 0 : j.subRows) == null ? void 0 : _.length) ?? 0) > 0) {
          const q = (x = D[L]) == null ? void 0 : x.subRows[0];
          if (q) {
            k({ [q.value]: !0 }), C.current.set(q.value, q), oe(
              Object.fromEntries(C.current.entries()),
              "prepopulate"
            ), setTimeout(() => F((J) => J + 1)), V.current = !0;
            return;
          }
        }
      oe(
        Object.fromEntries(C.current.entries()),
        "prepopulate"
      ), setTimeout(() => F((L) => L + 1)), V.current = !0;
    }
  }, [
    D,
    o,
    k,
    oe,
    F,
    b
  ]);
  const h = (j) => {
    C.current.delete(j);
    const _ = { ...N };
    delete _[j], k(_), oe(
      Object.fromEntries(C.current.entries()),
      "apiAction"
    );
  }, B = (j) => {
    try {
      const _ = X.current.tableInstance.getRow(j);
      _ && (C.current.set(_.ioId, _.original), k({ ...N, [_.ioId]: !0 }), oe(
        Object.fromEntries(C.current.entries()),
        "apiAction"
      ));
    } catch (_) {
      console.log(_), console.log("cannot add row that is not part of current dataset");
    }
  }, te = (j) => {
    b = j;
    const _ = $r(b);
    C.current = new Map(
      Object.entries(b ?? {})
    ), k(_), z.current = _;
  }, le = (j = !0) => {
    V.current = !j, re("");
    const _ = /* @__PURE__ */ new Map(), x = {};
    for (const L of C.current.entries()) {
      const [q, J] = L;
      ((p == null ? void 0 : p(J)) ?? !1) === !0 && (_.set(q, J), x[q] = !0);
    }
    k(x), z.current = x, C.current = _;
  };
  return u.useImperativeHandle(e, () => ({
    getRowSelection: () => z.current,
    getRowSelectionData: () => C.current,
    getCurrentData: () => (M == null ? void 0 : M.current) ?? [],
    removeSelection: h,
    setSelection: B,
    reinitializeRowSelection: te,
    setSearch: re,
    selectAll: () => G(!0),
    reset: le
  })), /* @__PURE__ */ s.jsx(
    Ke,
    {
      size: "medium",
      ...r,
      select: "advanceSelect",
      placeholder: "Select Insertion Order",
      SelectProps: {
        slotProps: {
          ...a,
          InputBaseProps: {
            placeholder: "Search by ID, Name",
            ...a == null ? void 0 : a.InputBaseProps
          }
        },
        ...I,
        getOptionDisabled: p,
        data: D ?? [],
        apiRef: X,
        inputValue: w,
        multiple: n,
        loading: ie || xe,
        overlay: pe,
        getRowId: (j) => j && typeof j.ioId == "number" ? `${j.ioId}` : String(j.ioId),
        onInputChange: (j, _, x) => {
          x !== "reset" && re(_);
        },
        rowCount: he,
        onFetchRows: () => ne(),
        renderValue: () => {
          const j = Object.keys(z.current);
          if (n)
            return j.length ? `${j.length} Selected` : "​";
          {
            const _ = j[0] ?? "", x = C.current.get(_);
            return /* @__PURE__ */ s.jsx(
              R,
              {
                Component: "span",
                sx: { display: "flex", gap: 4, overflow: "hidden" },
                children: /* @__PURE__ */ s.jsx(
                  be,
                  {
                    TypgraphyProps: {
                      component: "span"
                    },
                    children: (x == null ? void 0 : x.ioName) ?? "​"
                  }
                )
              }
            );
          }
        },
        renderListItem: Oc,
        renderOption: ({ row: j }) => kc(j),
        onSelectAll: (j) => {
          j && G(!0);
        },
        onClearAll: () => {
          setTimeout(() => {
            const j = /* @__PURE__ */ new Map(), _ = {};
            for (const x of C.current.entries()) {
              const [L, q] = x;
              ((p == null ? void 0 : p(q)) ?? !1) === !0 && (j.set(L, q), _[L] = !0);
            }
            k(_), z.current = _, C.current = j, oe(
              Object.fromEntries(C.current.entries()),
              "userAction"
            );
          }, 0);
        }
      },
      value: N,
      onChange: Y
    }
  );
});
Dc.displayName;
const _c = "_root_1jv6s_1", Tc = "_fadeIn_1jv6s_1", Nc = "_hideButton_1jv6s_18", Uc = "_fadeOut_1jv6s_1", Fc = "_buttonTopLeft_1jv6s_31", Bc = "_buttonTopRight_1jv6s_35", zc = "_buttonBottomLeft_1jv6s_39", Mc = "_buttonBottomRight_1jv6s_43", $c = "_drawerContainer_1jv6s_48", Ot = {
  root: _c,
  fadeIn: Tc,
  hideButton: Nc,
  fadeOut: Uc,
  buttonTopLeft: Fc,
  buttonTopRight: Bc,
  buttonBottomLeft: zc,
  buttonBottomRight: Mc,
  drawerContainer: $c
}, Wc = async (t, e) => {
  var r;
  try {
    const n = await t.post("/v3/ua/login", {
      ...e,
      grantType: "password"
    });
    if (n.data.success) {
      const { data: a } = n.data;
      return a;
    }
    throw { response: n };
  } catch (n) {
    return Promise.reject((r = n == null ? void 0 : n.response) == null ? void 0 : r.data);
  }
}, Vc = ({ initData: t }) => {
  const [e, r] = u.useState(!1), { instance: n } = At() ?? {}, a = n == null ? void 0 : n.originURL, o = (w) => (S, N) => {
    r(N ? w : !1);
  }, [l, i] = u.useState(t), [c, m] = u.useState(!1), [y, p] = u.useState(""), [f, I] = u.useState();
  So({
    authData: f,
    owId: (f == null ? void 0 : f.owId) ?? -1,
    originURL: n.originURL,
    onComplete: ({ profileData: w, isError: S, owIdIndex: N }) => {
      console.log(w, S, N), S || window.location.reload();
    }
  });
  const b = async (w) => {
    try {
      p(""), m(!0);
      const { ...S } = w, N = new URL("/api", a), k = Le.create({
        baseURL: N.toString(),
        headers: {
          Authorization: dr
        }
      }), T = await Wc(k, S);
      T && I(T);
    } catch (S) {
      p(JSON.stringify(S));
    } finally {
      m(!1);
    }
  };
  return /* @__PURE__ */ s.jsxs(
    sr,
    {
      expanded: e === "userLoginPanel",
      onChange: o("userLoginPanel"),
      children: [
        /* @__PURE__ */ s.jsx(
          ar,
          {
            "aria-controls": "userLoginPanel-content",
            id: "userLoginPanel-header",
            classes: {
              content: je({
                alignItems: "center",
                justifyContent: "between",
                my: 4
              })
            },
            children: /* @__PURE__ */ s.jsx(A, { variant: "bodyMedium", weight: "demi", gutterBottom: !1, children: "User Login Settings" })
          }
        ),
        y && /* @__PURE__ */ s.jsx(wt, { severity: "error", children: y }),
        /* @__PURE__ */ s.jsx(or, { children: /* @__PURE__ */ s.jsxs(
          R,
          {
            Component: "form",
            onSubmit: (w) => {
              w.preventDefault(), b(l);
            },
            sx: { display: "flex", flexDirection: "column", gap: 12 },
            children: [
              "OriginURL: ",
              /* @__PURE__ */ s.jsx(Ve, { label: a ?? "" }),
              /* @__PURE__ */ s.jsx(
                Ke,
                {
                  type: "email",
                  label: "Email",
                  variant: "outlined",
                  placeholder: "User Email",
                  value: l == null ? void 0 : l.email,
                  fullWidth: !0,
                  id: "email",
                  name: "email",
                  onChange: (w) => (
                    // @ts-ignore
                    i((S) => ({ ...S, email: w.target.value }))
                  )
                }
              ),
              /* @__PURE__ */ s.jsx(
                Ke,
                {
                  label: "Password",
                  type: "password",
                  variant: "outlined",
                  placeholder: "Password",
                  value: l == null ? void 0 : l.password,
                  fullWidth: !0,
                  id: "password",
                  name: "password",
                  onChange: (w) => (
                    // @ts-ignore
                    i((S) => ({ ...S, password: w.target.value }))
                  )
                }
              ),
              /* @__PURE__ */ s.jsx(
                Ut,
                {
                  type: "submit",
                  loading: c,
                  loadingPosition: "end",
                  children: "Login"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, Kc = () => {
  const [t, e] = u.useState(!1), r = (y) => (p, f) => {
    e(f ? y : !1);
  }, [n, a] = u.useState(""), [o, l] = u.useState(!1), [i, c] = u.useState(""), m = async (y) => {
    try {
      l(!0), localStorage.setItem(fe.LAST_OWID, y), localStorage.setItem(
        fe.LEGACY_OWIDS_ARRAY,
        JSON.stringify([y])
      ), window.location.reload();
    } catch (p) {
      a(JSON.stringify(p));
    } finally {
      l(!1);
    }
  };
  return /* @__PURE__ */ s.jsxs(
    sr,
    {
      expanded: t === "userLoginPanel",
      onChange: r("userLoginPanel"),
      children: [
        /* @__PURE__ */ s.jsx(
          ar,
          {
            "aria-controls": "userLoginPanel-content",
            id: "userLoginPanel-header",
            classes: {
              content: je({
                alignItems: "center",
                justifyContent: "between",
                my: 4
              })
            },
            children: /* @__PURE__ */ s.jsx(A, { variant: "bodyMedium", weight: "demi", gutterBottom: !1, children: "Org Switching" })
          }
        ),
        n && /* @__PURE__ */ s.jsx(wt, { severity: "error", children: n }),
        /* @__PURE__ */ s.jsxs(
          or,
          {
            sx: { display: "flex", flexDirection: "column", gap: 12 },
            children: [
              /* @__PURE__ */ s.jsx(
                Ke,
                {
                  type: "number",
                  label: "OwId",
                  variant: "outlined",
                  placeholder: "Enter OwId",
                  value: i,
                  fullWidth: !0,
                  id: "owId",
                  name: "owId",
                  onChange: (y) => c(y.target.value)
                }
              ),
              /* @__PURE__ */ s.jsx(
                Ut,
                {
                  loading: o,
                  loadingPosition: "end",
                  onClick: () => m(i),
                  children: "Switch ORG"
                }
              )
            ]
          }
        )
      ]
    }
  );
}, qc = () => {
  const [t, e] = u.useState(!1), r = (y) => (p, f) => {
    e(f ? y : !1);
  }, [n, a] = u.useState(""), [o, l] = u.useState(!1), [i, c] = u.useState(""), m = async (y) => {
    try {
      l(!0), localStorage.setItem(fe.ORIGIN_URL, y), window.location.reload();
    } catch (p) {
      a(JSON.stringify(p));
    } finally {
      l(!1);
    }
  };
  return /* @__PURE__ */ s.jsxs(
    sr,
    {
      expanded: t === "userLoginPanel",
      onChange: r("userLoginPanel"),
      children: [
        /* @__PURE__ */ s.jsx(
          ar,
          {
            "aria-controls": "userLoginPanel-content",
            id: "userLoginPanel-header",
            classes: {
              content: je({
                alignItems: "center",
                justifyContent: "between",
                my: 4
              })
            },
            children: /* @__PURE__ */ s.jsx(A, { variant: "bodyMedium", weight: "demi", gutterBottom: !1, children: "Origin URL" })
          }
        ),
        n && /* @__PURE__ */ s.jsx(wt, { severity: "error", children: n }),
        /* @__PURE__ */ s.jsxs(
          or,
          {
            sx: { display: "flex", flexDirection: "column", gap: 12 },
            children: [
              /* @__PURE__ */ s.jsx(
                Ke,
                {
                  label: "OriginURL",
                  variant: "outlined",
                  placeholder: "Enter Origin URL",
                  value: i,
                  fullWidth: !0,
                  name: "originURL",
                  onChange: (y) => c(y.target.value)
                }
              ),
              /* @__PURE__ */ s.jsx(
                Ut,
                {
                  loading: o,
                  loadingPosition: "end",
                  onClick: () => m(i),
                  children: "Switch Origin URL"
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Hc = function(e) {
  const {
    className: r,
    classes: n,
    position: a = "top-left",
    panelPosition: o = "right",
    sx: l,
    slotProps: i
  } = e, [c, m] = u.useState(!1), y = (p) => p.replace(/-([a-z])/g, (f, I) => I.toUpperCase()).replace(/^(.)/, (f) => f.toUpperCase()).replace(/-/g, "");
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      We,
      {
        className: Ce(
          Ot.root,
          n == null ? void 0 : n.root,
          //@ts-ignore
          Ot[`button${y(a)}`],
          c && Ot.hideButton,
          r,
          je(l)
        ),
        size: "large",
        onClick: () => m(!0),
        children: /* @__PURE__ */ s.jsx(ma, {})
      }
    ),
    /* @__PURE__ */ s.jsx(
      Ss,
      {
        open: c,
        anchor: o,
        onClose: () => {
          console.log("I am closing"), m(!1);
        },
        variant: "persistent",
        children: /* @__PURE__ */ s.jsxs(
          R,
          {
            className: Ce(Ot.drawerContainer, n == null ? void 0 : n.drawerContainer),
            style: { width: 400 },
            children: [
              /* @__PURE__ */ s.jsxs(
                R,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "between",
                    p: 12,
                    borderBottom: 1
                  },
                  children: [
                    /* @__PURE__ */ s.jsx(
                      A,
                      {
                        component: "h2",
                        variant: "h6",
                        weight: "demi",
                        gutterBottom: !1,
                        children: "Dev Tools"
                      }
                    ),
                    /* @__PURE__ */ s.jsx(Fe, { color: "secondary", onClick: () => m(!1), children: /* @__PURE__ */ s.jsx(ir, {}) })
                  ]
                }
              ),
              /* @__PURE__ */ s.jsxs(
                R,
                {
                  sx: {
                    display: "flex",
                    flexDirection: "column",
                    height: 100,
                    overflow: "auto",
                    p: 12
                  },
                  children: [
                    /* @__PURE__ */ s.jsx(Vc, { ...i == null ? void 0 : i.authProps }),
                    /* @__PURE__ */ s.jsx(Kc, {}),
                    /* @__PURE__ */ s.jsx(qc, {})
                  ]
                }
              )
            ]
          }
        )
      }
    )
  ] });
}, Yc = Hc, hd = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : Yc;
export {
  va as APP_ICON_MAPPING,
  od as AUTH,
  md as AddFunds,
  sc as AppBar,
  fd as AppProvider,
  cd as AppRootProvider,
  Ia as CAMPAIGN_PAGE_SIZE,
  xa as CUSTOMER_MULTILEVEL_PAGE_SIZE,
  wc as CustomerDropdown,
  ud as DataDogProvider,
  sd as ENV,
  _t as FILTERS_DISABLED_FOR_BROWSE,
  id as INIT,
  Dc as IOSelect,
  dr as IQM_PLATFORM_BASIC_AUTH_HEADER,
  bl as InfoBar,
  pd as InitProvider,
  dd as InitRootProvider,
  Fn as IntercomProvider,
  fe as LOCALSTORAGE_KEYS,
  cc as NotificationBar,
  Be as ORGANIZATION_TYPE,
  ad as OWID,
  on as OWID_HEADER_KEY,
  st as PaymentModeId,
  hd as PlatformDevTools,
  Cl as ResponsiveExperinceAlert,
  ln as SVG_HOST_PROD_URL,
  cn as SVG_HOST_STAGE_URL,
  Fo as SearchSegmentOption,
  xt as SegmentAvailability,
  Ci as SegmentSelect,
  el as SelectIOCampaignList,
  Gi as SelectPrebidSegment,
  wn as apiTimingsInterceptor,
  Cr as attachInstance,
  vt as authAppDetail,
  Pa as constructProviderDataFromSearchResults,
  it as defaultFilterState,
  Ra as filterActionMapping,
  qo as filterPartnerProviderData,
  ur as filterTabOptions,
  jn as getFiltersApiParams,
  ve as getInstance,
  $o as getIsSegmentSelectFilterApplied,
  An as getSortingApiParams,
  ja as logoutUserOnTokenExpiryInterceptor,
  ao as normalizeCampaignData,
  so as normalizeIOCampaignData,
  Xa as normalizeWorkspaceData,
  Qa as normalizeWorkspaceMultilevelData,
  Pr as sortingOptions,
  In as transformChildSegmentData,
  Er as transformCustomerInitDataToRowSelection,
  Or as transformIOCampaignInitDataToRowSelection,
  Aa as transformInitDataToRowSelection,
  Mo as transformInitSegmentSelectDataToRowSelection,
  Pn as transformParentPartnerData,
  xn as transformParentProviderData,
  La as transformSearchSegmentData,
  Wo as transformSegmentDataToNormalized,
  Ko as transformSegmentsBySearchKeyword,
  ld as useAdblockerDetection,
  Io as useAllowApplicationData,
  Eo as useAllowedOrganizationList,
  Ge as useAppContext,
  At as useAppRootContext,
  xo as useChatBotConfig,
  bo as useCustomerConfigData,
  gd as useCustomerDropdownAPIRef,
  ro as useCustomerMultiLevelData,
  no as useCustomerWrokspaceData,
  cl as useDataDogContext,
  ko as useIOBasicList,
  lo as useIOCampaignList,
  Lo as useInitChatBotConfig,
  fl as useInitContext,
  Ao as useInitData,
  Nn as useInitRootContext,
  pl as useIntercomContext,
  Ga as usePrebidProviderData,
  Ja as usePrebidSearchSegmentData,
  vo as useProfileData,
  Wi as useSegmentedAvailabilityFilterList,
  Fi as useSegmentedPartnerAndProviderList,
  Bi as useSegmentedPartnerProviderFilterList,
  Mi as useSegmentedPriceFilterList,
  $i as useSegmentedReachFilterList,
  Vi as useSegmentedVerticalFilterList,
  zi as useSegmentsBySearchKeyword,
  So as useSetupAuthDataInLocalstorage,
  Ct as validateValueAndParse
};
//# sourceMappingURL=index.js.map
